import { IInterface } from '../../../IMasterSync';
import {
  P00039DataRxTxIndex,
  P00039DeviceTableRxTxIndex,
} from '../../P00039Sync';
import { Buffer } from 'buffer';
import { IDeviceTableNode } from '../../../IDeviceTable';
import { IProduct } from '../../../IProduct';
import { P0003600, P0003600Data } from '../../P0003600';
import { P0004700 } from '../../P0004700';
import { P0003601, P0003601Data } from '../../P0003601';
import { P00046 } from '../../P00046';
import { P00030, P00030Data } from '../../P00030';
import { P00032, P00032Data } from '../../P00032';
import { P0003605, P0003605Data } from '../../P0003605';
import { P0004800 } from '../../P0004800';
import { P0003607, P0003607Data } from '../../P0003607';
import { P00049 } from '../../P00049';
import { P0003606, P0003606Data } from '../../P0003606';
import { P0004801 } from '../../P0004801';
import { P00043, P00043Data } from '../../P00043';
import { P00042, P00042Data } from '../../P00042';
import { P00041, P00041Data } from '../../P00041';
import { P0003602, P0003602Data } from '../../P0003602';
import { P0004702 } from '../../P0004702';
import { P0003603, P0003603Data } from '../../P0003603';
import { P0004703 } from '../../P0004703';
import { P0003604, P0003604Data } from '../../P0003604';
import { P0004704 } from '../../P0004704';
import { P00045, P00045Data } from '../../P00045';
import { P00039Data } from '../../P00039';
import { P00031, P00031Data } from '../../P00031';
import { P00061, P00061Data } from '../../P00061';
import { P00037, P00037Data } from '../../P00037';
import { P00062, P00062Data } from '../../P00062';
import { P00058, P00058Data } from '../../P00058';
import { P0006600 } from '../../P0006600';
import { Pool } from '../../../../../../apis/pool.api';

export class P00039InterfaceV9 implements IInterface {
  productDeviceTableIndex = [
    { index: 0, modelIdentifier: 'P00039' },
    { index: 1, modelIdentifier: 'P00036-00' },
    { index: 2, modelIdentifier: 'P00047-00' },
    { index: 3, modelIdentifier: 'P00036-01' },
    { index: 4, modelIdentifier: 'P00046' },
    { index: 5, modelIdentifier: 'P00031' },
    { index: 6, modelIdentifier: 'P00030' },
    { index: 7, modelIdentifier: 'P00032' },
    { index: 8, modelIdentifier: 'P00036-05' },
    { index: 9, modelIdentifier: 'P00048-00' },
    { index: 10, modelIdentifier: 'P00037-00' },
    { index: 11, modelIdentifier: 'P00036-07' },
    { index: 12, modelIdentifier: 'P00049' },
    { index: 13, modelIdentifier: 'P00036-06' },
    { index: 14, modelIdentifier: 'P00048-01' },
    { index: 15, modelIdentifier: 'P00043' },
    { index: 16, modelIdentifier: 'P00042' },
    { index: 17, modelIdentifier: 'P00041' },
    { index: 18, modelIdentifier: 'P00036-02' },
    { index: 19, modelIdentifier: 'P00047-02' },
    { index: 20, modelIdentifier: 'P00036-03' },
    { index: 21, modelIdentifier: 'P00047-03' },
    { index: 22, modelIdentifier: 'P00036-04' },
    { index: 23, modelIdentifier: 'P00047-04' },
    { index: 24, modelIdentifier: 'P00045' },
    { index: 25, modelIdentifier: 'P00061' },
    { index: 26, modelIdentifier: 'P00062' },
    { index: 27, modelIdentifier: 'P00058' },
    { index: 28, modelIdentifier: 'P00066-00' },
  ];

  dataRxtxDescriptors = [
    {
      key: P00039DataRxTxIndex.System_Sync,
      product: ['P00039'],
      read: this.maitreRead,
      write: null,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.Maitre_Parametrage,
      product: ['P00039'],
      read: this.maitreRead,
      write: this.maitreWrite,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Maitre_Installation,
      product: ['P00039'],
      read: this.maitreRead,
      write: this.maitreWrite,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Maitre_Status,
      product: ['P00039'],
      read: this.maitreRead,
      write: null,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.Maitre_Settings,
      product: ['P00039'],
      read: this.maitreRead,
      write: this.maitreWrite,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.Maitre_Maj,
      product: ['P00039'],
      read: this.maitreRead,
      write: null,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.Eclairage_Controle,
      product: ['P00039'],
      read: this.maitreRead,
      write: this.maitreWrite,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Eclairage_Parametrage,
      product: ['P00039'],
      read: this.maitreRead,
      write: this.maitreWrite,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Eclairage_Parametrage2,
      product: ['P00039'],
      read: this.maitreRead,
      write: this.maitreWrite,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Eclairage_Parametrage3,
      product: ['P00039'],
      read: this.maitreRead,
      write: this.maitreWrite,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Eclairage_Parametrage4,
      product: ['P00039'],
      read: this.maitreRead,
      write: this.maitreWrite,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Eclairage_Parametrage5,
      product: ['P00039'],
      read: this.maitreRead,
      write: this.maitreWrite,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Eclairage_Parametrage6,
      product: ['P00039'],
      read: this.maitreRead,
      write: this.maitreWrite,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Eclairage_Parametrage7,
      product: ['P00039'],
      read: this.maitreRead,
      write: this.maitreWrite,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Eclairage_Installation,
      product: ['P00039'],
      read: this.maitreRead,
      write: this.maitreWrite,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Eclairage_Status,
      product: ['P00039'],
      read: this.maitreRead,
      write: null,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.ZB_Controle,
      product: ['P00039'],
      read: this.maitreRead,
      write: this.maitreWrite,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.ZB_Controle2,
      product: ['P00039'],
      read: this.maitreRead,
      write: this.maitreWrite,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.ZB_Status,
      product: ['P00039'],
      read: this.maitreRead,
      write: null,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.ZB_Status2,
      product: ['P00039'],
      read: this.maitreRead,
      write: null,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.DeviceTable_Controle,
      product: ['P00039'],
      read: this.maitreRead,
      write: this.maitreWrite,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.DeviceTable_Status,
      product: ['P00039'],
      read: this.maitreRead,
      write: null,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.FiltrationStandard_Controle,
      product: ['P00036-00', 'P00047-00'],
      read: this.P0003600Read,
      write: this.P0003600Write,
      notify: this.P0003600Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.FiltrationStandard_Parametrage,
      product: ['P00036-00', 'P00047-00'],
      read: this.P0003600Read,
      write: this.P0003600Write,
      notify: this.P0003600Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.FiltrationStandard_Parametrage2,
      product: ['P00036-00', 'P00047-00'],
      read: this.P0003600Read,
      write: this.P0003600Write,
      notify: this.P0003600Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.FiltrationStandard_Parametrage3,
      product: ['P00036-00', 'P00047-00'],
      read: this.P0003600Read,
      write: this.P0003600Write,
      notify: this.P0003600Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.FiltrationStandard_Installation,
      product: ['P00036-00', 'P00047-00'],
      read: this.P0003600Read,
      write: this.P0003600Write,
      notify: this.P0003600Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.FiltrationStandard_Status,
      product: ['P00036-00', 'P00047-00'],
      read: this.P0003600Read,
      write: null,
      notify: this.P0003600Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.FiltrationStandard_Status2,
      product: ['P00036-00', 'P00047-00'],
      read: this.P0003600Read,
      write: null,
      notify: this.P0003600Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.FiltrationVS_Controle,
      product: ['P00036-01', 'P00046'],
      read: this.P0003601Read,
      write: this.P0003601Write,
      notify: this.P0003601Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.FiltrationVS_Parametrage,
      product: ['P00036-01', 'P00046'],
      read: this.P0003601Read,
      write: this.P0003601Write,
      notify: this.P0003601Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.FiltrationVS_Parametrage2,
      product: ['P00036-01', 'P00046'],
      read: this.P0003601Read,
      write: this.P0003601Write,
      notify: this.P0003601Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.FiltrationVS_Parametrage3,
      product: ['P00036-01', 'P00046'],
      read: this.P0003601Read,
      write: this.P0003601Write,
      notify: this.P0003601Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.FiltrationVS_Parametrage4,
      product: ['P00036-01', 'P00046'],
      read: this.P0003601Read,
      write: this.P0003601Write,
      notify: this.P0003601Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.FiltrationVS_Installation,
      product: ['P00036-01', 'P00046'],
      read: this.P0003601Read,
      write: this.P0003601Write,
      notify: this.P0003601Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.FiltrationVS_Status,
      product: ['P00036-01', 'P00046'],
      read: this.P0003601Read,
      write: null,
      notify: this.P0003601Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.FiltrationVS_Status2,
      product: ['P00036-01', 'P00046'],
      read: this.P0003601Read,
      write: null,
      notify: this.P0003601Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.InjectionChlore_Controle,
      product: ['P00036-05', 'P00048-00'],
      read: this.P0003605Read,
      write: this.P0003605Write,
      notify: this.P0003605Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.InjectionChlore_Parametrage,
      product: ['P00036-05', 'P00048-00'],
      read: this.P0003605Read,
      write: this.P0003605Write,
      notify: this.P0003605Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.InjectionChlore_Installation,
      product: ['P00036-05', 'P00048-00'],
      read: this.P0003605Read,
      write: this.P0003605Write,
      notify: this.P0003605Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.InjectionChlore_Status,
      product: ['P00036-05', 'P00048-00'],
      read: this.P0003605Read,
      write: null,
      notify: this.P0003605Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.InjectionChlore_Status2,
      product: ['P00036-05', 'P00048-00'],
      read: this.P0003605Read,
      write: null,
      notify: this.P0003605Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.InjectionPh_Controle,
      product: ['P00036-06', 'P00048-01'],
      read: this.P0003606Read,
      write: this.P0003606Write,
      notify: this.P0003606Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.InjectionPh_Parametrage,
      product: ['P00036-06', 'P00048-01'],
      read: this.P0003606Read,
      write: this.P0003606Write,
      notify: this.P0003606Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.InjectionPh_Installation,
      product: ['P00036-06', 'P00048-01'],
      read: this.P0003606Read,
      write: this.P0003606Write,
      notify: this.P0003606Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.InjectionPh_Status,
      product: ['P00036-06', 'P00048-01'],
      read: this.P0003606Read,
      write: null,
      notify: this.P0003606Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.Robot_Controle,
      product: ['P00036-03', 'P00047-03'],
      read: this.P0003603Read,
      write: this.P0003603Write,
      notify: this.P0003603Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Robot_Parametrage,
      product: ['P00036-03', 'P00047-03'],
      read: this.P0003603Read,
      write: this.P0003603Write,
      notify: this.P0003603Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Robot_Installation,
      product: ['P00036-03', 'P00047-03'],
      read: this.P0003603Read,
      write: this.P0003603Write,
      notify: this.P0003603Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Robot_Status,
      product: ['P00036-03', 'P00047-03'],
      read: this.P0003603Read,
      write: null,
      notify: this.P0003603Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.NCC_Controle,
      product: ['P00036-02', 'P00047-02'],
      read: this.P0003602Read,
      write: this.P0003602Write,
      notify: this.P0003602Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.NCC_Parametrage,
      product: ['P00036-02', 'P00047-02'],
      read: this.P0003602Read,
      write: this.P0003602Write,
      notify: this.P0003602Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.NCC_Installation,
      product: ['P00036-02', 'P00047-02'],
      read: this.P0003602Read,
      write: this.P0003602Write,
      notify: this.P0003602Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.NCC_Status,
      product: ['P00036-02', 'P00047-02'],
      read: this.P0003602Read,
      write: null,
      notify: this.P0003602Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.Blower_Controle,
      product: ['P00036-04', 'P00047-04'],
      read: this.P0003604Read,
      write: this.P0003604Write,
      notify: this.P0003604Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Blower_Parametrage,
      product: ['P00036-04', 'P00047-04'],
      read: this.P0003604Read,
      write: this.P0003604Write,
      notify: this.P0003604Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Blower_Installation,
      product: ['P00036-04', 'P00047-04'],
      read: this.P0003604Read,
      write: this.P0003604Write,
      notify: this.P0003604Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Blower_Status,
      product: ['P00036-04', 'P00047-04'],
      read: this.P0003604Read,
      write: null,
      notify: this.P0003604Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.ElectrolyseurStandard_Controle,
      product: ['P00036-07', 'P00049'],
      read: this.P0003607Read,
      write: this.P0003607Write,
      notify: this.P0003607Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage,
      product: ['P00036-07', 'P00049'],
      read: this.P0003607Read,
      write: this.P0003607Write,
      notify: this.P0003607Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage2,
      product: ['P00036-07', 'P00049'],
      read: this.P0003607Read,
      write: this.P0003607Write,
      notify: this.P0003607Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.ElectrolyseurStandard_Installation,
      product: ['P00036-07', 'P00049'],
      read: this.P0003607Read,
      write: this.P0003607Write,
      notify: this.P0003607Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.ElectrolyseurStandard_Status,
      product: ['P00036-07', 'P00049'],
      read: this.P0003607Read,
      write: null,
      notify: this.P0003607Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.ElectrolyseurStandard_Status2,
      product: ['P00036-07', 'P00049'],
      read: this.P0003607Read,
      write: null,
      notify: this.P0003607Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.CouvertureManuelle_Controle,
      product: ['P00039'],
      read: this.maitreRead,
      write: this.maitreWrite,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.CouvertureManuelle_Installation,
      product: ['P00039'],
      read: this.maitreRead,
      write: this.maitreWrite,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.CouvertureManuelle_Status,
      product: ['P00039'],
      read: this.maitreRead,
      write: null,
      notify: this.maitreRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.Connect_Status,
      product: ['P00045'],
      read: this.P00045Read,
      write: null,
      notify: this.P00045Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.Connect_Status2,
      product: ['P00045'],
      read: this.P00045Read,
      write: null,
      notify: this.P00045Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.Connect_Timezone,
      product: ['P00045'],
      read: this.P00045Read,
      write: this.P00045Write,
      notify: this.P00045Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Connect_Installation,
      product: ['P00045'],
      read: this.P00045Read,
      write: this.P00045Write,
      notify: this.P00045Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Connect_Installation2,
      product: ['P00045'],
      read: this.P00045Read,
      write: this.P00045Write,
      notify: this.P00045Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Connect_Installation3,
      product: ['P00045'],
      read: this.P00045Read,
      write: this.P00045Write,
      notify: this.P00045Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Sense_Status,
      product: ['P00032'],
      read: this.P00032Read,
      write: null,
      notify: this.P00032Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.Sense_Controle,
      product: ['P00032'],
      read: this.P00032Read,
      write: this.P00032Write,
      notify: this.P00032Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Sense_Installation,
      product: ['P00032'],
      read: this.P00032Read,
      write: this.P00032Write,
      notify: this.P00032Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PAC_Control,
      product: ['P00043'],
      read: this.P00043Read,
      write: this.P00043Write,
      notify: this.P00043Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PAC_Parametrage,
      product: ['P00043'],
      read: this.P00043Read,
      write: this.P00043Write,
      notify: this.P00043Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PAC_Parametrage2,
      product: ['P00043'],
      read: this.P00043Read,
      write: this.P00043Write,
      notify: this.P00043Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PAC_Installation,
      product: ['P00043'],
      read: this.P00043Read,
      write: this.P00043Write,
      notify: this.P00043Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PAC_Status,
      product: ['P00043'],
      read: this.P00043Read,
      write: null,
      notify: this.P00043Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.TAir_Status,
      product: ['P00030'],
      read: this.P00030Read,
      write: null,
      notify: this.P00030Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.TAir_Controle,
      product: ['P00030'],
      read: this.P00030Read,
      write: this.P00030Write,
      notify: this.P00030Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.TAir_Installation,
      product: ['P00030'],
      read: this.P00030Read,
      write: this.P00030Write,
      notify: this.P00030Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Volet24_Status,
      product: ['P00041'],
      read: this.P00041Read,
      write: null,
      notify: this.P00041Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.Volet24_Parametrage,
      product: ['P00041'],
      read: this.P00041Read,
      write: this.P00041Write,
      notify: this.P00041Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Volet24_Controle,
      product: ['P00041'],
      read: this.P00041Read,
      write: this.P00041Write,
      notify: this.P00041Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Volet24_Installation,
      product: ['P00041'],
      read: this.P00041Read,
      write: this.P00041Write,
      notify: this.P00041Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Volet230_Status,
      product: ['P00042'],
      read: this.P00042Read,
      write: null,
      notify: this.P00042Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.Volet230_Parametrage,
      product: ['P00042'],
      read: this.P00042Read,
      write: this.P00042Write,
      notify: this.P00042Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Volet230_Controle,
      product: ['P00042'],
      read: this.P00042Read,
      write: this.P00042Write,
      notify: this.P00042Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Volet230_Installation,
      product: ['P00042'],
      read: this.P00042Read,
      write: this.P00042Write,
      notify: this.P00042Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.TunableStandard_Controle,
      product: ['P00031'],
      read: this.P00031Read,
      write: this.P00031Write,
      notify: this.P00031Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.TunableStandard_Installation,
      product: ['P00031'],
      read: this.P00031Read,
      write: this.P00031Write,
      notify: this.P00031Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.TunableStandard_Status,
      product: ['P00031'],
      read: this.P00031Read,
      write: null,
      notify: this.P00031Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.TunableStandard_Parametrage1,
      product: ['P00031'],
      read: this.P00031Read,
      write: this.P00031Write,
      notify: this.P00031Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.TunableStandard_Parametrage2,
      product: ['P00031'],
      read: this.P00031Read,
      write: this.P00031Write,
      notify: this.P00031Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.TunableCouleur_Controle,
      product: ['P00031'],
      read: this.P00031Read,
      write: this.P00031Write,
      notify: this.P00031Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.TunableCouleur_Parametrage1,
      product: ['P00031'],
      read: this.P00031Read,
      write: this.P00031Write,
      notify: this.P00031Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.TunableCouleur_Parametrage2,
      product: ['P00031'],
      read: this.P00031Read,
      write: this.P00031Write,
      notify: this.P00031Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.TunableCouleur_Parametrage3,
      product: ['P00031'],
      read: this.P00031Read,
      write: this.P00031Write,
      notify: this.P00031Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.TunableCouleur_Parametrage4,
      product: ['P00031'],
      read: this.P00031Read,
      write: this.P00031Write,
      notify: this.P00031Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.TunableCouleur_Parametrage5,
      product: ['P00031'],
      read: this.P00031Read,
      write: this.P00031Write,
      notify: this.P00031Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.TunableCouleur_Status,
      product: ['P00031'],
      read: this.P00031Read,
      write: null,
      notify: this.P00031Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.TunableBlanc_Controle,
      product: ['P00031'],
      read: this.P00031Read,
      write: this.P00031Write,
      notify: this.P00031Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.TunableBlanc_Parametrage1,
      product: ['P00031'],
      read: this.P00031Read,
      write: this.P00031Write,
      notify: this.P00031Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.TunableBlanc_Parametrage2,
      product: ['P00031'],
      read: this.P00031Read,
      write: this.P00031Write,
      notify: this.P00031Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.TunableBlanc_Parametrage3,
      product: ['P00031'],
      read: this.P00031Read,
      write: this.P00031Write,
      notify: this.P00031Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.TunableBlanc_Status,
      product: ['P00031'],
      read: this.P00031Read,
      write: null,
      notify: this.P00031Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.Tunable_Installation,
      product: ['P00031'],
      read: this.P00031Read,
      write: this.P00031Write,
      notify: this.P00031Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Tunable_Status,
      product: ['P00031'],
      read: this.P00031Read,
      write: null,
      notify: this.P00031Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.Tunable_Controle,
      product: ['P00031'],
      read: this.P00031Read,
      write: this.P00031Write,
      notify: this.P00031Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.Tunable_Parametrage,
      product: ['P00031'],
      read: this.P00031Read,
      write: this.P00031Write,
      notify: this.P00031Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACWP_Installation,
      product: ['P00061'],
      read: this.P00061Read,
      write: this.P00061Write,
      notify: this.P00061Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACWP_Controle,
      product: ['P00061'],
      read: this.P00061Read,
      write: this.P00061Write,
      notify: this.P00061Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACWP_Parametrage1,
      product: ['P00061'],
      read: this.P00061Read,
      write: this.P00061Write,
      notify: this.P00061Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACWP_Parametrage2,
      product: ['P00061'],
      read: this.P00061Read,
      write: this.P00061Write,
      notify: this.P00061Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACWP_Parametrage3,
      product: ['P00061'],
      read: this.P00061Read,
      write: this.P00061Write,
      notify: this.P00061Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACWP_Parametrage4,
      product: ['P00061'],
      read: this.P00061Read,
      write: this.P00061Write,
      notify: this.P00061Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACWP_Parametrage5,
      product: ['P00061'],
      read: this.P00061Read,
      write: this.P00061Write,
      notify: this.P00061Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACWP_Parametrage6,
      product: ['P00061'],
      read: this.P00061Read,
      write: this.P00061Write,
      notify: this.P00061Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACWP_Parametrage7,
      product: ['P00061'],
      read: this.P00061Read,
      write: this.P00061Write,
      notify: this.P00061Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACWP_Parametrage8,
      product: ['P00061'],
      read: this.P00061Read,
      write: this.P00061Write,
      notify: this.P00061Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACWP_Parametrage9,
      product: ['P00061'],
      read: this.P00061Read,
      write: this.P00061Write,
      notify: this.P00061Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACWP_Status1,
      product: ['P00061'],
      read: this.P00061Read,
      write: null,
      notify: this.P00061Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.PACWP_Status2,
      product: ['P00061'],
      read: this.P00061Read,
      write: null,
      notify: this.P00061Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.SALT_Installation,
      product: ['P00037-00'],
      read: this.P00037Read,
      write: this.P00037Write,
      notify: this.P00037Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.SALT_Controle,
      product: ['P00037-00'],
      read: this.P00037Read,
      write: this.P00037Write,
      notify: this.P00037Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.SALT_Parametrage1,
      product: ['P00037-00'],
      read: this.P00037Read,
      write: this.P00037Write,
      notify: this.P00037Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.SALT_Parametrage2,
      product: ['P00037-00'],
      read: this.P00037Read,
      write: this.P00037Write,
      notify: this.P00037Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.SALT_Parametrage3,
      product: ['P00037-00'],
      read: this.P00037Read,
      write: this.P00037Write,
      notify: this.P00037Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.SALT_Parametrage4,
      product: ['P00037-00'],
      read: this.P00037Read,
      write: this.P00037Write,
      notify: this.P00037Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.SALT_Parametrage5,
      product: ['P00037-00'],
      read: this.P00037Read,
      write: this.P00037Write,
      notify: this.P00037Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.SALT_Status1,
      product: ['P00037-00'],
      read: this.P00037Read,
      write: null,
      notify: this.P00037Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.SALT_Status2,
      product: ['P00037-00'],
      read: this.P00037Read,
      write: null,
      notify: this.P00037Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.PACPOLY_Installation,
      product: ['P00062'],
      read: this.P00062Read,
      write: this.P00062Write,
      notify: this.P00062Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACPOLY_Controle,
      product: ['P00062'],
      read: this.P00062Read,
      write: this.P00062Write,
      notify: this.P00062Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACPOLY_Parametrage1,
      product: ['P00062'],
      read: this.P00062Read,
      write: this.P00062Write,
      notify: this.P00062Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACPOLY_Parametrage2,
      product: ['P00062'],
      read: this.P00062Read,
      write: this.P00062Write,
      notify: this.P00062Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACPOLY_Parametrage3,
      product: ['P00062'],
      read: this.P00062Read,
      write: this.P00062Write,
      notify: this.P00062Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACPOLY_Parametrage4,
      product: ['P00062'],
      read: this.P00062Read,
      write: this.P00062Write,
      notify: this.P00062Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACPOLY_Parametrage5,
      product: ['P00062'],
      read: this.P00062Read,
      write: this.P00062Write,
      notify: this.P00062Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACPOLY_Parametrage6,
      product: ['P00062'],
      read: this.P00062Read,
      write: this.P00062Write,
      notify: this.P00062Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACPOLY_Parametrage7,
      product: ['P00062'],
      read: this.P00062Read,
      write: this.P00062Write,
      notify: this.P00062Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACPOLY_Parametrage8,
      product: ['P00062'],
      read: this.P00062Read,
      write: this.P00062Write,
      notify: this.P00062Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACPOLY_Parametrage9,
      product: ['P00062'],
      read: this.P00062Read,
      write: this.P00062Write,
      notify: this.P00062Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PACPOLY_Status1,
      product: ['P00062'],
      read: this.P00062Read,
      write: null,
      notify: this.P00062Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.PompeVS_Installation,
      product: ['P00058', 'P00066-00'],
      read: this.P00058Read,
      write: this.P00058Write,
      notify: this.P00058Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PompeVS_Controle,
      product: ['P00058', 'P00066-00'],
      read: this.P00058Read,
      write: this.P00058Write,
      notify: this.P00058Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PompeVS_Parametrage1,
      product: ['P00058', 'P00066-00'],
      read: this.P00058Read,
      write: this.P00058Write,
      notify: this.P00058Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PompeVS_Parametrage2,
      product: ['P00058', 'P00066-00'],
      read: this.P00058Read,
      write: this.P00058Write,
      notify: this.P00058Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PompeVS_Parametrage3,
      product: ['P00058', 'P00066-00'],
      read: this.P00058Read,
      write: this.P00058Write,
      notify: this.P00058Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PompeVS_Parametrage4,
      product: ['P00058', 'P00066-00'],
      read: this.P00058Read,
      write: this.P00058Write,
      notify: this.P00058Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PompeVS_Parametrage5,
      product: ['P00058', 'P00066-00'],
      read: this.P00058Read,
      write: this.P00058Write,
      notify: this.P00058Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PompeVS_Parametrage6,
      product: ['P00058', 'P00066-00'],
      read: this.P00058Read,
      write: this.P00058Write,
      notify: this.P00058Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PompeVS_Parametrage7,
      product: ['P00058', 'P00066-00'],
      read: this.P00058Read,
      write: this.P00058Write,
      notify: this.P00058Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PompeVS_Parametrage8,
      product: ['P00058', 'P00066-00'],
      read: this.P00058Read,
      write: this.P00058Write,
      notify: this.P00058Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PompeVS_Parametrage9,
      product: ['P00058', 'P00066-00'],
      read: this.P00058Read,
      write: this.P00058Write,
      notify: this.P00058Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PompeVS_Parametrage10,
      product: ['P00058', 'P00066-00'],
      read: this.P00058Read,
      write: this.P00058Write,
      notify: this.P00058Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PompeVS_Parametrage11,
      product: ['P00058', 'P00066-00'],
      read: this.P00058Read,
      write: this.P00058Write,
      notify: this.P00058Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PompeVS_Parametrage12,
      product: ['P00058', 'P00066-00'],
      read: this.P00058Read,
      write: this.P00058Write,
      notify: this.P00058Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PompeVS_Parametrage13,
      product: ['P00058', 'P00066-00'],
      read: this.P00058Read,
      write: this.P00058Write,
      notify: this.P00058Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PompeVS_Parametrage14,
      product: ['P00058', 'P00066-00'],
      read: this.P00058Read,
      write: this.P00058Write,
      notify: this.P00058Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PompeVS_Parametrage15,
      product: ['P00058', 'P00066-00'],
      read: this.P00058Read,
      write: this.P00058Write,
      notify: this.P00058Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PompeVS_Parametrage16,
      product: ['P00058', 'P00066-00'],
      read: this.P00058Read,
      write: this.P00058Write,
      notify: this.P00058Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PompeVS_Parametrage17,
      product: ['P00058', 'P00066-00'],
      read: this.P00058Read,
      write: this.P00058Write,
      notify: this.P00058Read,
      allowBle: true,
      allowMqtt: true,
      restore: true,
    },
    {
      key: P00039DataRxTxIndex.PompeVS_Status1,
      product: ['P00058', 'P00066-00'],
      read: this.P00058Read,
      write: null,
      notify: this.P00058Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DataRxTxIndex.PompeVS_Status2,
      product: ['P00058', 'P00066-00'],
      read: this.P00058Read,
      write: null,
      notify: this.P00058Read,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
  ];

  deviceTableRxtxDescriptors = [
    {
      key: P00039DeviceTableRxTxIndex.System_Sync,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P00039,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P0003600,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P0004700,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P0003601,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P00046,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P00030,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P00031,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P00032,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P0003605,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P0004800,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P0003700,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P0003607,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P00049,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P0003606,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P0004801,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P00043,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P00042,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P00041,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P0003602,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P0004702,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P0003603,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P0004703,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P0003604,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P0004704,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P00045,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P00061,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P00062,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P00058,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
    {
      key: P00039DeviceTableRxTxIndex.DeviceTable_P0006600,
      product: ['P00039'],
      read: this.deviceTableRead,
      write: null,
      notify: this.deviceTableRead,
      allowBle: true,
      allowMqtt: true,
      restore: false,
    },
  ];

  deviceTableRead(pool: Pool, index: number, buffer: Buffer) {
    let deviceTableData: IDeviceTableNode | null = null;
    let product: IProduct | null = null;
    const data = pool.deviceTable.master;

    switch (index) {
      case P00039DeviceTableRxTxIndex.System_Sync:
        data.deviceTable.syncMode = buffer.readUInt8(0);
        return data;
      case P00039DeviceTableRxTxIndex.DeviceTable_P00039:
        deviceTableData = data.deviceTable.P00039;
        //TODO reflechir à renommer le master par P00039
        //product = new P00039();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P0003600:
        deviceTableData = data.deviceTable.P0003600;
        product = new P0003600();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P0004700:
        deviceTableData = data.deviceTable.P0004700;
        product = new P0004700();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P0003601:
        deviceTableData = data.deviceTable.P0003601;
        product = new P0003601();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P00046:
        deviceTableData = data.deviceTable.P00046;
        product = new P00046();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P00030:
        deviceTableData = data.deviceTable.P00030;
        product = new P00030();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P00031:
        deviceTableData = data.deviceTable.P00031;
        product = new P00031();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P00032:
        deviceTableData = data.deviceTable.P00032;
        product = new P00032();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P0003605:
        deviceTableData = data.deviceTable.P0003605;
        product = new P0003605();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P0004800:
        deviceTableData = data.deviceTable.P0004800;
        product = new P0004800();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P0003607:
        deviceTableData = data.deviceTable.P0003607;
        product = new P0003607();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P00049:
        deviceTableData = data.deviceTable.P00049;
        product = new P00049();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P0003606:
        deviceTableData = data.deviceTable.P0003606;
        product = new P0003606();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P0004801:
        deviceTableData = data.deviceTable.P0004801;
        product = new P0004801();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P00043:
        deviceTableData = data.deviceTable.P00043;
        product = new P00043();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P00042:
        deviceTableData = data.deviceTable.P00042;
        product = new P00042();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P00041:
        deviceTableData = data.deviceTable.P00041;
        product = new P00041();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P0003602:
        deviceTableData = data.deviceTable.P0003602;
        product = new P0003602();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P0004702:
        deviceTableData = data.deviceTable.P0004702;
        product = new P0004702();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P0003603:
        deviceTableData = data.deviceTable.P0003603;
        product = new P0003603();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P0004703:
        deviceTableData = data.deviceTable.P0004703;
        product = new P0004703();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P0003604:
        deviceTableData = data.deviceTable.P0003604;
        product = new P0003604();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P0004704:
        deviceTableData = data.deviceTable.P0004704;
        product = new P0004704();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P00045:
        deviceTableData = data.deviceTable.P00045;
        product = new P00045();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P00061:
        deviceTableData = data.deviceTable.P00061;
        product = new P00061();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P0003700:
        deviceTableData = data.deviceTable.P0003700;
        product = new P00037();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P00062:
        deviceTableData = data.deviceTable.P00062;
        product = new P00062();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P00058:
        deviceTableData = data.deviceTable.P00058;
        product = new P00058();
        break;
      case P00039DeviceTableRxTxIndex.DeviceTable_P0006600:
        deviceTableData = data.deviceTable.P0006600;
        product = new P0006600();
        break;
    }

    if (deviceTableData === null) {
      return data;
    }

    deviceTableData.nodeId = buffer.readUInt16LE(0);
    deviceTableData.presenceProduit = buffer.readUInt8(2);

    deviceTableData.dureeAbsence = buffer.readUInt32LE(3);
    deviceTableData.dureeTotal = buffer.readUInt32LE(7);
    deviceTableData.dureeAbsenceTotal = buffer.readUInt32LE(11);
    deviceTableData.firmwareVersion = buffer.readUInt8(15);
    deviceTableData.gblVersion = buffer.readUInt8(16);
    deviceTableData.produitInit = buffer.readUInt8(17);
    deviceTableData.serialNumber = buffer
      .toString('utf8', 18, 26)
      .toString()
      .replace(/[^0-9a-z+]/gi, '');
    deviceTableData.compteurAbscence = buffer.readUInt16LE(27);
    deviceTableData.qualityZB = buffer.readUInt8(29);

    return data;
  }

  maitreWrite(
    productClass: IProduct,
    pool: Pool,
    index: number,
  ): Buffer | null {
    const data = pool.deviceTable[productClass.dataIdentifier!]
      .data as P00039Data;

    if (index == P00039DataRxTxIndex.System_Sync) {
      const buffer = Buffer.allocUnsafe(2);
      buffer.writeUInt8(1, 0);
      return buffer;
    } else if (index == P00039DataRxTxIndex.Maitre_Parametrage) {
      const buffer = Buffer.allocUnsafe(1);
      buffer.writeUInt8(data.maitrePLangue, 0);
      return buffer;
    } else if (index == P00039DataRxTxIndex.Maitre_Installation) {
      const buffer = Buffer.allocUnsafe(2);
      buffer.writeUInt8(data.maitreITypeAntenneRF, 0);

      let o = 0x00;

      o = (o << 0) | data.maitreIConfirmationOTA;
      o = (o << 1) | data.maitreIResetUsine;
      o = (o << 1) | data.maitreIInstallationOk;

      buffer.writeUInt8(o, 1);
      return buffer;
    } else if (index == P00039DataRxTxIndex.Eclairage_Controle) {
      const buffer = Buffer.allocUnsafe(2);

      buffer.writeUInt8(data.eclairageStandardCModeFonctionnement, 0);

      let o = 0x00;

      o = (o << 0) | data.eclairageStandardCResetUsine;
      o = (o << 1) | data.eclairageStandardCSynchronisationProgramme;
      o = (o << 1) | data.eclairageStandardCProgrammeSuivant;
      o = (o << 1) | data.eclairageStandardCDemarrageMinuterie;

      buffer.writeUInt8(o, 1);

      return buffer;
    } else if (index == P00039DataRxTxIndex.Eclairage_Parametrage) {
      const buffer = Buffer.allocUnsafe(50);
      buffer.write(data.eclairageStandardPHorlogeJour, 0, 42, 'hex');
      buffer.write(data.eclairageStandardPHorlogeSemaine, 42, 6, 'hex');

      buffer.writeUInt8(
        Math.floor(data.eclairageStandardPDureeMinuterie / 60),
        48,
      );
      buffer.writeUInt8(data.eclairageStandardPDureeMinuterie % 60, 49);

      return buffer;
    } else if (index == P00039DataRxTxIndex.Eclairage_Parametrage2) {
      const buffer = Buffer.allocUnsafe(4);
      buffer.writeUInt8(
        Math.floor(data.eclairageStandardPHeureExtinction / 60),
        0,
      );
      buffer.writeUInt8(data.eclairageStandardPHeureExtinction % 60, 1);

      buffer.writeUInt8(data.eclairageStandardPVoletDeReference, 2);

      let o = 0x00;

      o = (o << 0) | data.eclairageStandardPActivationFonctionVolet;
      o = (o << 1) | data.eclairageStandardPActivationRedemarrageEclairage;
      o = (o << 1) | data.eclairageStandardPActivationExtinction24h;
      o = (o << 1) | data.eclairageStandardPActivationExtinction;
      o = (o << 1) | data.eclairageStandardPHorlogeType;

      buffer.writeUInt8(o, 3);

      return buffer;
    } else if (index == P00039DataRxTxIndex.Eclairage_Parametrage3) {
      const buffer = Buffer.allocUnsafe(1);
      buffer.writeUInt8(
        Math.floor(data.eclairageStandardPCodeProgrammeWeltico),
        0,
      );
      return buffer;
    } else if (index == P00039DataRxTxIndex.Eclairage_Parametrage4) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.eclairageStandardPHorlogeWelticoSemaine, 0, 24, 'hex');
      buffer.write(
        data.eclairageStandardPHorlogeWelticoJourLundi,
        24,
        24,
        'hex',
      );

      return buffer;
    } else if (index == P00039DataRxTxIndex.Eclairage_Parametrage5) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(
        data.eclairageStandardPHorlogeWelticoJourMardi,
        0,
        24,
        'hex',
      );
      buffer.write(
        data.eclairageStandardPHorlogeWelticoJourMercredi,
        24,
        24,
        'hex',
      );

      return buffer;
    } else if (index == P00039DataRxTxIndex.Eclairage_Parametrage6) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(
        data.eclairageStandardPHorlogeWelticoJourJeudi,
        0,
        24,
        'hex',
      );
      buffer.write(
        data.eclairageStandardPHorlogeWelticoJourVendredi,
        24,
        24,
        'hex',
      );

      return buffer;
    } else if (index == P00039DataRxTxIndex.Eclairage_Parametrage7) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(
        data.eclairageStandardPHorlogeWelticoJourSamedi,
        0,
        24,
        'hex',
      );
      buffer.write(
        data.eclairageStandardPHorlogeWelticoJourDimanche,
        24,
        24,
        'hex',
      );

      return buffer;
    } else if (index == P00039DataRxTxIndex.Eclairage_Installation) {
      const buffer = Buffer.allocUnsafe(2);
      buffer.writeUInt8(data.eclairageStandardITypeEclairage, 0);
      buffer.writeUInt8(data.eclairageStandardIDureeRuptureAlimentation, 1);
      return buffer;
    } else if (index == P00039DataRxTxIndex.ZB_Controle) {
      const buffer = Buffer.allocUnsafe(48);
      buffer.writeUInt16LE(data.reseauZBCRestitutionPanID, 0);
      buffer.writeInt8(data.reseauZBCRestitutionRadioPower, 2);
      buffer.writeInt8(data.reseauZBCRestitutionRadioChannel, 3);
      buffer.write(data.reseauZBCRestitutionEUI64, 4, 8);
      buffer.write(data.reseauZBCRestitutionGlobalKey, 12, 16);
      buffer.writeUInt32LE(data.reseauZBCRestitutionGlobalFrameCounter, 28);
      buffer.write(data.reseauZBCRestitutionNetworkKey, 32, 16);
      return buffer;
    } else if (index == P00039DataRxTxIndex.ZB_Controle2) {
      const buffer = Buffer.allocUnsafe(13);
      buffer.writeUInt32LE(data.reseauZBCRestitutionNetworkFrameCounter, 0);
      buffer.writeUInt8(data.reseauZBCRestitutionNetworkKeySequenceNumber, 4);
      buffer.write(data.reseauZBCRestitutionExtendedPANID, 5, 8);
      return buffer;
    } else if (index == P00039DataRxTxIndex.DeviceTable_Controle) {
      const buffer = Buffer.allocUnsafe(5);
      buffer.writeUInt8(data.deviceTableCProduitAAssocier, 0);
      buffer.writeUInt8(data.deviceTableCProduitADesassocier, 1);
      buffer.writeUInt16LE(data.deviceTableCNodeIdProduitASupprimer, 2);

      let o = 0x00;
      o = (o << 0) | data.deviceTableCAnnulerDernierCommisionning;
      buffer.writeUInt8(o, 4);

      return buffer;
    } else if (index == P00039DataRxTxIndex.CouvertureManuelle_Installation) {
      const buffer = Buffer.allocUnsafe(1);

      let o = 0x00;
      o = (o << 0) | data.couvertureManuelleIPresenceCouverture;
      buffer.writeUInt8(o, 0);

      return buffer;
    } else if (index == P00039DataRxTxIndex.CouvertureManuelle_Controle) {
      const buffer = Buffer.allocUnsafe(1);

      let o = 0x00;
      o = (o << 0) | data.couvertureManuelleCResetUsine;
      o = (o << 1) | data.couvertureManuelleCEtatVolet;
      buffer.writeUInt8(o, 0);

      return buffer;
    } else if (index == P00039DataRxTxIndex.Maitre_Settings) {
      const buffer = Buffer.allocUnsafe(1);

      let o = 0x00;
      o = (o << 0) | data.settingsSaveAll;
      o = (o << 1) | data.settingsResetAll;
      buffer.writeUInt8(o, 0);

      return buffer;
    }

    return null;
  }

  maitreRead(pool: Pool, action: number, buffer: Buffer): Pool {
    const data = pool.deviceTable.master.data as P00039Data;

    if (action == P00039DataRxTxIndex.System_Sync) {
      data.syncMode = buffer.readUInt8(0);
    } else if (action == P00039DataRxTxIndex.Maitre_Parametrage) {
      data.maitrePLangue = buffer.readUInt8(0);
    } else if (action == P00039DataRxTxIndex.Maitre_Installation) {
      data.maitreITypeAntenneRF = buffer.readUInt8(0);
      data.maitreIInstallationOk = buffer.readUInt8(1) & 1;
      data.maitreIResetUsine = (buffer.readUInt8(1) >> 1) & 1;
      data.maitreIConfirmationOTA = (buffer.readUInt8(1) >> 2) & 1;
    } else if (action == P00039DataRxTxIndex.Maitre_Status) {
      data.maitreSCompteurResetUsine = buffer.readUInt16LE(0);
      data.maitreSTemperaturePuce = buffer.readUInt16LE(2);
      data.maitreSTensionPile = buffer.readUInt16LE(4);
      data.maitreSAlarmeTensionPile = buffer.readUInt8(6) & 1;
      data.maitreSCompteurReset = buffer.readUInt16LE(7);
      data.maitreSCompteurCoupureAlimentation = buffer.readUInt16LE(9);
    } else if (action == P00039DataRxTxIndex.Eclairage_Controle) {
      data.eclairageStandardCModeFonctionnement = buffer.readUInt8(0);
      data.eclairageStandardCDemarrageMinuterie = buffer.readUInt8(1) & 1;
      data.eclairageStandardCProgrammeSuivant = (buffer.readUInt8(1) >> 1) & 1;
      data.eclairageStandardCSynchronisationProgramme =
        (buffer.readUInt8(1) >> 2) & 1;
      data.eclairageStandardCResetUsine = (buffer.readUInt8(1) >> 3) & 1;
    } else if (action == P00039DataRxTxIndex.Eclairage_Parametrage) {
      data.eclairageStandardPHorlogeJour = buffer.toString('hex', 0, 42);
      data.eclairageStandardPHorlogeSemaine = buffer.toString('hex', 42, 48);
      data.eclairageStandardPDureeMinuterie =
        buffer.readUInt8(48) * 60 + buffer.readUInt8(49);
    } else if (action == P00039DataRxTxIndex.Eclairage_Parametrage2) {
      data.eclairageStandardPHeureExtinction =
        buffer.readUInt8(0) * 60 + buffer.readUInt8(1);
      data.eclairageStandardPVoletDeReference = buffer.readUInt8(2);
      data.eclairageStandardPHorlogeType = buffer.readUInt8(3) & 1;
      data.eclairageStandardPActivationExtinction =
        (buffer.readUInt8(3) >> 1) & 1;
      data.eclairageStandardPActivationExtinction24h =
        (buffer.readUInt8(3) >> 2) & 1;
      data.eclairageStandardPActivationRedemarrageEclairage =
        (buffer.readUInt8(3) >> 3) & 1;
      data.eclairageStandardPActivationFonctionVolet =
        (buffer.readUInt8(3) >> 4) & 1;
    } else if (action == P00039DataRxTxIndex.Eclairage_Parametrage3) {
      data.eclairageStandardPCodeProgrammeWeltico = buffer.readUInt8(0);
    } else if (action == P00039DataRxTxIndex.Eclairage_Parametrage4) {
      data.eclairageStandardPHorlogeWelticoSemaine = buffer.toString(
        'hex',
        0,
        24,
      );
      data.eclairageStandardPHorlogeWelticoJourLundi = buffer.toString(
        'hex',
        24,
        48,
      );
    } else if (action == P00039DataRxTxIndex.Eclairage_Parametrage5) {
      data.eclairageStandardPHorlogeWelticoJourMardi = buffer.toString(
        'hex',
        0,
        24,
      );
      data.eclairageStandardPHorlogeWelticoJourMercredi = buffer.toString(
        'hex',
        24,
        48,
      );
    } else if (action == P00039DataRxTxIndex.Eclairage_Parametrage6) {
      data.eclairageStandardPHorlogeWelticoJourJeudi = buffer.toString(
        'hex',
        0,
        24,
      );
      data.eclairageStandardPHorlogeWelticoJourVendredi = buffer.toString(
        'hex',
        24,
        48,
      );
    } else if (action == P00039DataRxTxIndex.Eclairage_Parametrage7) {
      data.eclairageStandardPHorlogeWelticoJourSamedi = buffer.toString(
        'hex',
        0,
        24,
      );
      data.eclairageStandardPHorlogeWelticoJourDimanche = buffer.toString(
        'hex',
        24,
        48,
      );
    } else if (action == P00039DataRxTxIndex.Eclairage_Installation) {
      data.eclairageStandardITypeEclairage = buffer.readUInt8(0);
      data.eclairageStandardIDureeRuptureAlimentation = buffer.readUInt8(1);
    } else if (action == P00039DataRxTxIndex.Eclairage_Status) {
      data.eclairageStandardSCommandeEclairage = buffer.readUInt8(0) & 1;
      data.eclairageStandardSArretEclairageParMinuterie =
        (buffer.readUInt8(0) >> 1) & 1;
      data.eclairageStandardSArretEclairageParExtinctionAuto =
        (buffer.readUInt8(0) >> 2) & 1;
      data.eclairageStandardSArretEclairageParExtinction24h =
        (buffer.readUInt8(0) >> 3) & 1;
      data.eclairageStandardSArretEclairageParFonctionVolet =
        (buffer.readUInt8(0) >> 4) & 1;
      data.eclairageStandardSCompteAReboursMinuterie = buffer.readUInt32LE(1);
      data.eclairageStandardSCompteAReboursExtinction24h =
        buffer.readUInt32LE(5);
      data.eclairageStandardSCompteurResetUsine = buffer.readUInt16LE(9);
    } else if (action == P00039DataRxTxIndex.ZB_Controle) {
      data.reseauZBCRestitutionPanID = buffer.readUInt16LE(0);
      data.reseauZBCRestitutionRadioPower = buffer.readInt8(2);
      data.reseauZBCRestitutionRadioChannel = buffer.readInt8(3);
      data.reseauZBCRestitutionEUI64 = buffer.toString('hex', 4, 12);
      data.reseauZBCRestitutionGlobalKey = buffer.toString('hex', 12, 28);
      data.reseauZBCRestitutionGlobalFrameCounter = buffer.readUInt32LE(28);
      data.reseauZBCRestitutionNetworkKey = buffer.toString('hex', 32, 48);
    } else if (action == P00039DataRxTxIndex.ZB_Controle2) {
      data.reseauZBCRestitutionNetworkFrameCounter = buffer.readUInt32LE(0);
      data.reseauZBCRestitutionNetworkKeySequenceNumber = buffer.readUInt8(4);
      data.reseauZBCRestitutionExtendedPANID = buffer.toString('hex', 5, 13);
    } else if (action == P00039DataRxTxIndex.ZB_Status) {
      data.reseauZBSPanID = buffer.readUInt16LE(0);
      data.reseauZBSRadioPower = buffer.readInt8(2);
      data.reseauZBSRadioChannel = buffer.readInt8(3);
      data.reseauZBSEUI64 = buffer.toString('hex', 4, 12);
      data.reseauZBSGlobalKey = buffer.toString('hex', 12, 28);
      data.reseauZBSGlobalFrameCounter = buffer.readUInt32LE(28);
      data.reseauZBSNetworkKey = buffer.toString('hex', 32, 48);
    } else if (action == P00039DataRxTxIndex.ZB_Status2) {
      data.reseauZBSNetworkFrameCounter = buffer.readUInt32LE(0);
      data.reseauZBSNetworkKeySequenceNumber = buffer.readUInt8(4);
      data.reseauZBSExtendedPANID = buffer.toString('hex', 5, 13);
      data.reseauZBSEtatNetwork = buffer.readUInt8(13) & 1;
    } else if (action == P00039DataRxTxIndex.DeviceTable_Controle) {
      data.deviceTableCProduitAAssocier = buffer.readUInt8(0);
      data.deviceTableCProduitADesassocier = buffer.readUInt8(1);
      data.deviceTableCNodeIdProduitASupprimer = buffer.readUInt16LE(2);
      data.deviceTableCAnnulerDernierCommisionning = buffer.readUInt8(4) & 1;
    } else if (action == P00039DataRxTxIndex.DeviceTable_Status) {
      data.deviceTableSModeJoignable = buffer.readUInt8(0) & 1;
      data.deviceTableSNodeIdProduitEntrant = buffer.readUInt16LE(1);
      data.deviceTableSErreurDernierAjout = buffer.readUInt8(3);

      data.deviceTableSManufacturerName = buffer.toString('utf8', 4, 24);
      data.deviceTableSPuissanceActive = buffer.readUInt16LE(25);
      data.deviceTableSPuissanceApparenteTotal = buffer.readUInt32LE(27);
    } else if (action == P00039DataRxTxIndex.CouvertureManuelle_Installation) {
      data.couvertureManuelleIPresenceCouverture = buffer.readUInt8(0) & 1;
    } else if (action == P00039DataRxTxIndex.CouvertureManuelle_Controle) {
      data.couvertureManuelleCEtatVolet = buffer.readUInt8(0) & 1;
      data.couvertureManuelleCResetUsine = (buffer.readUInt8(0) >> 1) & 1;
    } else if (action == P00039DataRxTxIndex.CouvertureManuelle_Status) {
      data.couvertureManuelleSEtatVolet = buffer.readUInt8(0) & 1;
    } else if (action == P00039DataRxTxIndex.Maitre_Settings) {
      data.settingsResetAll = buffer.readUInt8(0) & 1;
      data.settingsSaveAll = (buffer.readUInt8(0) >> 1) & 1;
    } else if (action == P00039DataRxTxIndex.Maitre_Maj) {
      data.majTauxAvancementVerifyAndExtractMetadata = buffer.readUInt8(0);
      data.majEtatCourant = buffer.readUInt8(1);
    }

    return pool;
  }

  P0003600Read(pool: Pool, action: number, buffer: Buffer): Pool {
    const P0003600P0004700Read = (data: P0003600Data): P0003600Data => {
      if (action == P00039DataRxTxIndex.FiltrationStandard_Controle) {
        data.fsCModeFonctionnement = buffer.readUInt8(0);
        data.fsCProgrammeFiltrationAuto = buffer.readUInt8(1);
        data.fsCResetManuelProtectionMagnetique = buffer.readUInt8(2) & 1;
        data.fsCResetManuelProtectionThermique = (buffer.readUInt8(2) >> 1) & 1;
        data.fsCConfirmationOTA = (buffer.readUInt8(2) >> 2) & 1;
        data.fsCResetUsine = (buffer.readUInt8(2) >> 3) & 1;
      } else if (action == P00039DataRxTxIndex.FiltrationStandard_Parametrage) {
        data.fsPTypeHorlogePPH = buffer.readUInt8(0) & 1;
        data.fsPTypeHorlogePPE = (buffer.readUInt8(0) >> 1) & 1;
        data.fsPActivationFonctionFiltration2424 =
          (buffer.readUInt8(0) >> 2) & 1;
        data.fsPHeureDepart = buffer.readUInt8(1) * 60 + buffer.readUInt8(2);
        data.fsPDureeAjustementLoiDEau = buffer.readInt8(3);
        data.fsPSeuilTemperatureFonctionFiltration2424 = buffer.readUInt8(4);
        data.fsPTypeFonctionHorsGel = buffer.readUInt8(5);
        data.fsPSeuilTemperatureFonctionHorsGel = buffer.readInt8(6);
      } else if (
        action == P00039DataRxTxIndex.FiltrationStandard_Parametrage2
      ) {
        data.fsPHorlogePicotJourPPE = buffer.toString('hex', 0, 42);
        data.fsPHorlogePicotSemainePPE = buffer.toString('hex', 42, 48);
      } else if (
        action == P00039DataRxTxIndex.FiltrationStandard_Parametrage3
      ) {
        data.fsPHorlogePicotJourPPH = buffer.toString('hex', 0, 42);
        data.fsPHorlogePicotSemainePPH = buffer.toString('hex', 42, 48);
      } else if (
        action == P00039DataRxTxIndex.FiltrationStandard_Installation
      ) {
        data.fsIConfigurationProduit = buffer.readUInt8(0) & 1;
        data.fsIActivationProtectionThermique = (buffer.readUInt8(0) >> 1) & 1;
        data.fsIActivationProtectionMagnetique = (buffer.readUInt8(0) >> 2) & 1;
        data.fsICourantNominalPompe = buffer.readUInt8(1);
        data.fsICapteurTemperatureFiltration2424 = buffer.readUInt8(2);
        data.fsICapteurTemperatureReferenceLoiDEau = buffer.readUInt8(3);
        data.fsICapteurTemperatureReferenceHorsGel = buffer.readUInt8(4);
        data.fsIDureeDetectionMaintenue = buffer.readUInt8(5);
        data.fsISeuilCourantDetection = buffer.readUInt8(6);
      } else if (action == P00039DataRxTxIndex.FiltrationStandard_Status) {
        data.fsSCommandePompe = buffer.readUInt8(0) & 1;
        data.fsSEtatPompe = (buffer.readUInt8(0) >> 1) & 1;
        data.fsSEtatProtectionMagnetique = (buffer.readUInt8(0) >> 2) & 1;
        data.fsSEtatProtectionThermique = (buffer.readUInt8(0) >> 3) & 1;
        data.fsSEtatBouton = (buffer.readUInt8(0) >> 4) & 1;
        data.fsSDetectionFonctionnementPompe = (buffer.readUInt8(0) >> 5) & 1;
        data.fsSAlarme = (buffer.readUInt8(0) >> 6) & 1;

        data.fsSCourantConsomePompe = buffer.readUInt16LE(1);
        data.fsSNombreCommutationRelais = buffer.readUInt32LE(3);
        data.fsSTensionSecteur = buffer.readUInt8(7);
        data.fsSPuissanceApparente = buffer.readUInt16LE(8);
        data.fsSPuissanceActive = buffer.readUInt16LE(10);
        data.fsSCompteurPuissanceApparenteTotal = buffer.readUInt32LE(12);
        data.fsSCompteurPuissanceActiveTotale = buffer.readUInt32LE(16);
        data.fsSCompteurAmpereHeure = buffer.readUInt32LE(20);
        data.fsSTempsSousTension = buffer.readUInt32LE(24);
        data.fsSCompteurBouton = buffer.readUInt32LE(28);

        data.fsSTemperatureReferenceDisponibleLoiDEau =
          buffer.readUInt8(32) & 1;
        data.fsSPompeFiltrationPiloteLoiDEau = (buffer.readUInt8(32) >> 1) & 1;
        data.fsSPompeFiltrationPilotePPH = (buffer.readUInt8(32) >> 2) & 1;
        data.fsSPompeFiltrationPilotePPE = (buffer.readUInt8(32) >> 3) & 1;
        data.fsSTemperatureReferenceDisponible2424 =
          (buffer.readUInt8(32) >> 4) & 1;
        data.fsSPompeFiltrationPilote2424 = (buffer.readUInt8(32) >> 5) & 1;
        data.fsSPompeFiltrationPilote72H = (buffer.readUInt8(32) >> 6) & 1;
        data.fsSPompeFiltrationPiloteUsine1 = (buffer.readUInt8(32) >> 7) & 1;

        data.fsSPompeFiltrationPiloteUsine2 = buffer.readUInt8(33) & 1;
        data.fsSPompeFiltrationPiloteUsine3 = (buffer.readUInt8(33) >> 1) & 1;
        data.fsSTemperatureReferenceDisponibleHorsGel =
          (buffer.readUInt8(33) >> 2) & 1;
        data.fsSPompeFiltrationPiloteHorsGel = (buffer.readUInt8(33) >> 3) & 1;
        data.fsSEntreeAsserviePrioriteElectrolyseElectrolyseurStandard =
          (buffer.readUInt8(33) >> 4) & 1;
        data.fsSEntreeAsservieAutoMaintienFiltrationElectrolyseurStandard =
          (buffer.readUInt8(33) >> 5) & 1;
        data.fsSEntreeAsservieAutoMaintienFiltrationInjectionCL =
          (buffer.readUInt8(33) >> 6) & 1;
        data.fsSEntreeAsserviePrioriteElectrolyseElectrolyseurCellule =
          (buffer.readUInt8(33) >> 7) & 1;

        data.fsSEntreeAsservieAutoMaintienFiltrationElectrolyseurCellule =
          buffer.readUInt8(34) & 1;
        data.fsSEntreeAsservieAutoMaintienFiltrationInjectionPH =
          (buffer.readUInt8(34) >> 1) & 1;
        data.fsSEntreeAsservieAutoMaintienFiltrationInjectionPAC =
          (buffer.readUInt8(34) >> 2) & 1;
        data.fsSEntreeAsservieRedemarrageEclairageStandard =
          (buffer.readUInt8(34) >> 3) & 1;
        data.fsSEntreeAsservieRedemarrageEclairageTunable =
          (buffer.readUInt8(34) >> 4) & 1;
        data.fsSEntreeAsserviePrioriteRobot = (buffer.readUInt8(34) >> 5) & 1;
        data.fsSEntreeAsservieAutoMaintienRobot =
          (buffer.readUInt8(34) >> 6) & 1;
        data.fsSPompeFiltrationFonctionEntreeAsservi =
          (buffer.readUInt8(34) >> 7) & 1;
        data.fsSEntreeAsserviFonctionPrioritePacWp = buffer.readUInt8(35) & 1;
        data.fsSEntreeAsserviFonctionAutoMaintienPacWp =
          (buffer.readUInt8(35) >> 1) & 1;

        data.fsSEntreeAsserviFonctionPrioritePac =
          (buffer.readUInt8(35) >> 2) & 1;
        data.fsSEntreeAsserviFonctionPrioritePacPoly =
          (buffer.readUInt8(35) >> 3) & 1;
        data.fsSEntreeAsserviFonctionAutoMaintienPacPoly =
          (buffer.readUInt8(35) >> 4) & 1;

        data.fsSEntreeAsserviArretFiltrationVolet24 =
          (buffer.readUInt8(35) >> 5) & 1;
        data.fsSEntreeAsserviArretFiltrationVolet230 =
          (buffer.readUInt8(35) >> 6) & 1;
        data.fsSAsservissement = (buffer.readUInt8(35) >> 7) & 1;
      } else if (action == P00039DataRxTxIndex.FiltrationStandard_Status2) {
        data.fsSMesureTemperatureLoiDEau = buffer.readInt16LE(0);
        data.fsSDureeFiltrationMinuteLoiDEau = buffer.readUInt16LE(2);
        data.fsSHeureArretMinuteLoiDEau = buffer.readUInt16LE(4);
        data.fsSCompteARebours72H = buffer.readUInt32LE(6);
        data.fsSDureeFiltrationMinuteUsine1 = buffer.readUInt16LE(10);
        data.fsSHeureArretMinuteUsine1 = buffer.readUInt16LE(12);
        data.fsSDureeFiltrationMinuteUsine2 = buffer.readUInt16LE(14);
        data.fsSHeureArretMinuteUsine2 = buffer.readUInt16LE(16);
        data.fsSDureeFiltrationMinuteUsine3 = buffer.readUInt16LE(18);
        data.fsSHeureArretMinuteUsine3 = buffer.readUInt16LE(20);
        data.fsSMesureTemperature2424 = buffer.readInt16LE(22);
        data.fsSMesureTemperatureHorsGel = buffer.readInt16LE(24);
        data.fsSEtatFonctionHorsGel = buffer.readUInt8(26);
        data.fsSCompteAReboursEtatDiscontinu = buffer.readUInt16LE(27);

        data.fsSCompteurResetManuelProtectionMagnetique =
          buffer.readUInt16LE(29);
        data.fsSCompteurResetManuelProtectionThermique =
          buffer.readUInt16LE(31);
        data.fsSCompteurResetUsine = buffer.readUInt16LE(33);
      }

      return data;
    };

    //On va vérifier ici la présence de P0003600 ou P0004700
    if (pool?.deviceTable?.P0003600?.data) {
      pool!.deviceTable!.P0003600!.data = P0003600P0004700Read(
        pool!.deviceTable!.P0003600!.data,
      );
    }

    if (pool?.deviceTable?.P0004700?.data) {
      pool!.deviceTable!.P0004700!.data = P0003600P0004700Read(
        pool!.deviceTable!.P0004700!.data,
      );
    }

    return pool;
  }

  P0003600Write(
    productClass: IProduct,
    pool: Pool,
    index: number,
  ): Buffer | null {
    const data = pool.deviceTable[productClass.dataIdentifier!]
      .data as P0003600Data;

    if (index == P00039DataRxTxIndex.FiltrationStandard_Controle) {
      const buffer = Buffer.allocUnsafe(3);
      buffer.writeUInt8(data.fsCModeFonctionnement, 0);
      buffer.writeUInt8(data.fsCProgrammeFiltrationAuto, 1);

      let o = 0x00;

      o = (o << 0) | data.fsCResetUsine;
      o = (o << 1) | data.fsCConfirmationOTA;
      o = (o << 1) | data.fsCResetManuelProtectionThermique;
      o = (o << 1) | data.fsCResetManuelProtectionMagnetique;

      buffer.writeUInt8(o, 2);
      return buffer;
    } else if (index == P00039DataRxTxIndex.FiltrationStandard_Parametrage) {
      const buffer = Buffer.allocUnsafe(52);
      let o = 0x00;

      o = (o << 0) | data.fsPActivationFonctionFiltration2424;
      o = (o << 1) | data.fsPTypeHorlogePPE;
      o = (o << 1) | data.fsPTypeHorlogePPH;

      buffer.writeUInt8(o, 0);

      buffer.writeUInt8(Math.floor(data.fsPHeureDepart / 60), 1);
      buffer.writeUInt8(data.fsPHeureDepart % 60, 2);
      buffer.writeInt8(data.fsPDureeAjustementLoiDEau, 3);

      buffer.writeUInt8(data.fsPSeuilTemperatureFonctionFiltration2424, 4);
      buffer.writeUInt8(data.fsPTypeFonctionHorsGel, 5);
      buffer.writeInt8(data.fsPSeuilTemperatureFonctionHorsGel, 6);

      return buffer;
    } else if (index == P00039DataRxTxIndex.FiltrationStandard_Parametrage2) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.fsPHorlogePicotJourPPE, 0, 42, 'hex');
      buffer.write(data.fsPHorlogePicotSemainePPE, 42, 6, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.FiltrationStandard_Parametrage3) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.fsPHorlogePicotJourPPH, 0, 42, 'hex');
      buffer.write(data.fsPHorlogePicotSemainePPH, 42, 6, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.FiltrationStandard_Installation) {
      const buffer = Buffer.allocUnsafe(7);

      let o = 0x00;

      o = (o << 0) | data.fsIActivationProtectionMagnetique;
      o = (o << 1) | data.fsIActivationProtectionThermique;
      o = (o << 1) | data.fsIConfigurationProduit;

      buffer.writeUInt8(o, 0);
      buffer.writeUInt8(data.fsICourantNominalPompe, 1);
      buffer.writeUInt8(data.fsICapteurTemperatureFiltration2424, 2);
      buffer.writeUInt8(data.fsICapteurTemperatureReferenceLoiDEau, 3);
      buffer.writeUInt8(data.fsICapteurTemperatureReferenceHorsGel, 4);
      buffer.writeUInt8(data.fsIDureeDetectionMaintenue, 5);
      buffer.writeUInt8(data.fsISeuilCourantDetection, 6);

      return buffer;
    }

    return null;
  }

  P0003601Read(pool: Pool, action: number, buffer: Buffer): Pool {
    const P0003601P00046Read = (data: P0003601Data): P0003601Data => {
      if (action == P00039DataRxTxIndex.FiltrationVS_Controle) {
        data.fvsCModeFonctionnement = buffer.readUInt8(0);
        data.fvsCVitesseManuelle = buffer.readUInt8(1);
        data.fvsCProgrammeFiltrationAuto = buffer.readUInt8(2);
        data.fvsCConfirmationOTA = buffer.readUInt8(3) & 1;
        data.fvsCResetUsine = (buffer.readUInt8(3) >> 1) & 1;
      } else if (action == P00039DataRxTxIndex.FiltrationVS_Parametrage) {
        data.fvsPHorlogeVitesseJoursPPHA = buffer.toString('hex', 0, 48);
      } else if (action == P00039DataRxTxIndex.FiltrationVS_Parametrage2) {
        data.fvsPHorlogeVitesseJoursPPHB = buffer.toString('hex', 0, 36);
        data.fvsPHorlogeVitesseSemainePPH = buffer.toString('hex', 36, 48);
        data.fvsPTypeHorlogePPH = buffer.readUInt8(48);
        data.fvsPSeuilTemperature2424 = buffer.readUInt8(49);
      } else if (action == P00039DataRxTxIndex.FiltrationVS_Parametrage3) {
        data.fvsPHorlogeVitesseJoursPPEA = buffer.toString('hex', 0, 48);
      } else if (action == P00039DataRxTxIndex.FiltrationVS_Parametrage4) {
        data.fvsPHorlogeVitesseJoursPPEB = buffer.toString('hex', 0, 36);
        data.fvsPHorlogeVitesseSemainePPE = buffer.toString('hex', 36, 48);
        data.fvsPTypeHorlogePPE = buffer.readUInt8(48) & 1;
        data.fvsPActivationFonction2424 = (buffer.readUInt8(48) >> 1) & 1;
        data.fvsPSeuilTemperatureHorsGel = buffer.readInt8(49);
      } else if (action == P00039DataRxTxIndex.FiltrationVS_Installation) {
        data.fvsIConfigurationProduit = buffer.readUInt8(0) & 1;
        data.fvsITableTraductionVitesses = buffer.toString('hex', 1, 5);
        data.fvsICapteurTemperatureReferenceHorsGel = buffer.readUInt8(5);
        data.fvsICapteurTemperatureReference2424 = buffer.readUInt8(6);
      } else if (action == P00039DataRxTxIndex.FiltrationVS_Status) {
        data.fvsSVitesseFiltration = buffer.readUInt8(0);
        data.fvsSControleContacts = buffer.readUInt8(1);
        data.fvsSEtatBouton = (buffer.readUInt8(1) >> 4) & 1;
        data.fvsSFonctionnementPompe = (buffer.readUInt8(1) >> 5) & 1;
        data.fvsSAlarme = (buffer.readUInt8(1) >> 6) & 1;

        data.fvsSCourantConsommePompe = buffer.readUInt16LE(2);
        data.fvsSTensionSecteur = buffer.readUInt8(4);
        data.fvsSPuissanceApparente = buffer.readUInt16LE(5);
        data.fvsSPuissanceActive = buffer.readUInt16LE(7);
        data.fvsSCompteurPuissanceApparenteTotale = buffer.readUInt32LE(9);
        data.fvsSCompteurPuissanceActiveTotale = buffer.readUInt32LE(13);
        data.fvsSCompteurAmpereHeure = buffer.readUInt32LE(17);
        data.fvsSTempsSousTension = buffer.readUInt32LE(21);
        data.fvsSCompteurBouton = buffer.readUInt32LE(25);

        data.fvsSEtatVitesse = buffer.readUInt8(29);
        data.fvsSEtatContacts = buffer.readUInt8(30);
        data.fvsSTemperatureReferenceDisponibleHorsGel =
          (buffer.readUInt8(30) >> 4) & 1;
        data.fvsSEtatFonctionHorsGel = (buffer.readUInt8(30) >> 5) & 1;
        data.fvsSTemperatureReferenceDisponible2424 =
          (buffer.readUInt8(30) >> 6) & 1;

        data.fvsSCompteAReboursSeconde72h = buffer.readUInt32LE(31);

        data.fvsSVitesseFiltration72h = buffer.readUInt8(35);
        data.fvsSVitesseFiltrationPPH = buffer.readUInt8(36);
        data.fvsSVitesseFiltrationPPE = buffer.readUInt8(37);
        data.fvsSMesureTemperatureHorsGel = buffer.readInt16LE(38);
        data.fvsSVitesseFiltrationHorsGel = buffer.readUInt8(40);
        data.fvsSMesureTemperature2424 = buffer.readInt16LE(41);
        data.fvsSVitesseFiltration2424 = buffer.readUInt8(43);

        data.fvsSAsservissementFonctionPrioriteElectrolyseurStandard =
          buffer.readUInt8(44) & 1;
        data.fvsSAsservissementFonctionAutoMaintienElectrolyseurStandard =
          (buffer.readUInt8(44) >> 1) & 1;
        data.fvsSAsservissementFonctionAutoMaintienInjectionCl =
          (buffer.readUInt8(44) >> 2) & 1;
        data.fvsSAsservissementFonctionPrioriteElectrolyseurCellule =
          (buffer.readUInt8(44) >> 3) & 1;
        data.fvsSAsservissementFonctionAutoMaintienElectrolyseurCellule =
          (buffer.readUInt8(44) >> 4) & 1;
        data.fvsSAsservissementFonctionAutoMaintienInjectionPh =
          (buffer.readUInt8(44) >> 5) & 1;
        data.fvsSAsservissementFonctionAutoMaintienPAC =
          (buffer.readUInt8(44) >> 6) & 1;
        data.fvsSAsservissementFonctionRedemEclairageStandard =
          (buffer.readUInt8(44) >> 7) & 1;

        data.fvsSAsservissementFonctionRedemTunable = buffer.readUInt8(45) & 1;
        data.fvsSAsservissementFonctionPrioriteRobot =
          (buffer.readUInt8(45) >> 1) & 1;
        data.fvsSAsservissementFonctionAutoMaintienRobot =
          (buffer.readUInt8(45) >> 2) & 1;
        data.fvsSEntreeAsserviFonctionPrioritePacWp =
          (buffer.readUInt8(45) >> 3) & 1;
        data.fvsSEntreeAsserviFonctionAutoMaintienPacWp =
          (buffer.readUInt8(45) >> 4) & 1;

        data.fvsSVitesseFiltrationEntreeAsservie = buffer.readUInt8(46);
        data.fvsSCompteurResetUsine = buffer.readUInt16LE(47);
      } else if (action == P00039DataRxTxIndex.FiltrationVS_Status2) {
        data.fvsSEntreeAsserviFonctionPrioritePac = buffer.readUInt8(0) & 1;
        data.fvsSEntreeAsserviFonctionPrioritePacPoly =
          (buffer.readUInt8(0) >> 1) & 1;
        data.fvsSEntreeAsserviFonctionAutoMaintienPacPoly =
          (buffer.readUInt8(0) >> 2) & 1;
        data.fvsSEntreeAsserviArretFiltrationVolet24 =
          (buffer.readUInt8(0) >> 3) & 1;
        data.fvsSEntreeAsserviArretFiltrationVolet230 =
          (buffer.readUInt8(0) >> 4) & 1;
        data.fvsSEntreeAsserviPrioriteBoostElectrolyseur =
          (buffer.readUInt8(0) >> 5) & 1;
        data.fvsSAsservissement = (buffer.readUInt8(0) >> 6) & 1;
      }

      return data;
    };

    //On va vérifier ici la présence de P0003600 ou P0004700
    if (pool?.deviceTable?.P0003601?.data) {
      pool!.deviceTable!.P0003601!.data = P0003601P00046Read(
        pool!.deviceTable!.P0003601!.data,
      );
    }

    if (pool?.deviceTable?.P00046?.data) {
      pool!.deviceTable!.P00046!.data = P0003601P00046Read(
        pool!.deviceTable!.P00046!.data,
      );
    }

    return pool;
  }

  P0003601Write(
    productClass: IProduct,
    pool: Pool,
    index: number,
  ): Buffer | null {
    const data = pool.deviceTable[productClass.dataIdentifier!]
      .data as P0003601Data;

    if (index == P00039DataRxTxIndex.FiltrationVS_Controle) {
      const buffer = Buffer.allocUnsafe(4);
      buffer.writeUInt8(data.fvsCModeFonctionnement, 0);
      buffer.writeUInt8(data.fvsCVitesseManuelle, 1);
      buffer.writeUInt8(data.fvsCProgrammeFiltrationAuto, 2);

      let o = 0x00;

      o = (o << 0) | data.fvsCResetUsine;
      o = (o << 1) | data.fvsCConfirmationOTA;

      buffer.writeUInt8(o, 3);

      return buffer;
    } else if (index == P00039DataRxTxIndex.FiltrationVS_Parametrage) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.fvsPHorlogeVitesseJoursPPHA, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.FiltrationVS_Parametrage2) {
      const buffer = Buffer.allocUnsafe(50);

      buffer.write(data.fvsPHorlogeVitesseJoursPPHB, 0, 36, 'hex');
      buffer.write(data.fvsPHorlogeVitesseSemainePPH, 36, 12, 'hex');
      buffer.writeUInt8(data.fvsPTypeHorlogePPH, 48);
      buffer.writeUInt8(data.fvsPSeuilTemperature2424, 49);

      return buffer;
    } else if (index == P00039DataRxTxIndex.FiltrationVS_Parametrage3) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.fvsPHorlogeVitesseJoursPPEA, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.FiltrationVS_Parametrage4) {
      const buffer = Buffer.allocUnsafe(50);

      buffer.write(data.fvsPHorlogeVitesseJoursPPEB, 0, 36, 'hex');
      buffer.write(data.fvsPHorlogeVitesseSemainePPE, 36, 12, 'hex');

      let o = 0x00;

      o = (o << 0) | data.fvsPActivationFonction2424;
      o = (o << 1) | data.fvsPTypeHorlogePPE;

      buffer.writeUInt8(o, 48);

      buffer.writeInt8(data.fvsPSeuilTemperatureHorsGel, 49);

      return buffer;
    } else if (index == P00039DataRxTxIndex.FiltrationVS_Installation) {
      const buffer = Buffer.allocUnsafe(7);

      let o = 0x00;

      o = (o << 0) | data.fvsIConfigurationProduit;

      buffer.writeUInt8(o, 0);

      buffer.write(data.fvsITableTraductionVitesses, 1, 4, 'hex');
      buffer.writeUInt8(data.fvsICapteurTemperatureReferenceHorsGel, 5);
      buffer.writeUInt8(data.fvsICapteurTemperatureReference2424, 6);

      return buffer;
    }

    return null;
  }

  P0003605Read(pool: Pool, action: number, buffer: Buffer): Pool {
    const P0003605P0004800Read = (data: P0003605Data): P0003605Data => {
      if (action == P00039DataRxTxIndex.InjectionChlore_Controle) {
        data.icCModeFonctionnement = buffer.readUInt8(0);
        data.icCCommandeAmorcageCloud = buffer.readUInt8(1) & 1;
        data.icCCommandeAmorcageBle = (buffer.readUInt8(1) >> 1) & 1;
        data.icCCommandeAmorcageIHM = (buffer.readUInt8(1) >> 2) & 1;
        data.icCAckUtilisateur = (buffer.readUInt8(1) >> 3) & 1;
        data.icCResetCompteur = (buffer.readUInt8(1) >> 4) & 1;
        data.icCConfirmationOTA = (buffer.readUInt8(1) >> 5) & 1;
        data.icCResetUsine = (buffer.readUInt8(1) >> 6) & 1;
      } else if (action == P00039DataRxTxIndex.InjectionChlore_Parametrage) {
        data.icPDureeEntreDeuxInjections = buffer.readUInt16LE(0);
        data.icPDureeInjection = buffer.readUInt16LE(2);
        data.icPConsigneRegulationRx = buffer.readUInt16LE(4);
        data.icPHysteresisRegulationRx = buffer.readUInt8(6);
        data.icPDureeLimiteSurdosage = buffer.readUInt8(7);
        data.icPDureeMaximumQuotidienne = buffer.readUInt8(8);
        data.icPActivationSecuriteDesinfection = buffer.readUInt8(9) & 1;
      } else if (action == P00039DataRxTxIndex.InjectionChlore_Installation) {
        data.icIConfigurationProduit = buffer.readUInt8(0) & 1;
        data.icIActivationFonctionAutoMaintien = (buffer.readUInt8(0) >> 1) & 1;
        data.icIActivationProtectionSurdosage = (buffer.readUInt8(0) >> 2) & 1;
        data.icIDetecteurFinBidonInstalle = (buffer.readUInt8(0) >> 3) & 1;
        data.icISensContactFinBidon = (buffer.readUInt8(0) >> 4) & 1;
        data.icISondeRxReference = buffer.readUInt8(1);
        data.icISourceReferenceDebit = buffer.readUInt8(2);
        data.icISourceReferenceFonctionVolet = buffer.readUInt8(3);
      } else if (action == P00039DataRxTxIndex.InjectionChlore_Status) {
        data.icSEtatBouton = buffer.readUInt8(0) & 1;
        data.icSAlarme = (buffer.readUInt8(0) >> 1) & 1;
        data.icSEtatPompe = (buffer.readUInt8(0) >> 2) & 1;
        data.icSCommandeInjection = (buffer.readUInt8(0) >> 3) & 1;
        data.icSCommandeAmorcage = (buffer.readUInt8(0) >> 4) & 1;
        data.icSMesureRxReferenceDisponible = (buffer.readUInt8(0) >> 5) & 1;
        data.icSCommandeRegulation = (buffer.readUInt8(0) >> 6) & 1;
        data.icSMiseEnRouteFiltration = (buffer.readUInt8(0) >> 7) & 1;

        data.icSArretInjection = buffer.readUInt8(1) & 1;
        data.icSVigilenceChlore = (buffer.readUInt8(1) >> 1) & 1;
        data.icSEtatContactFinBidon = (buffer.readUInt8(1) >> 2) & 1;
        data.icSFinBidon = (buffer.readUInt8(1) >> 3) & 1;
        data.icSCommandeInjectionHivernage = (buffer.readUInt8(1) >> 4) & 1;
        data.icSSecuriteDesinfection = (buffer.readUInt8(1) >> 5) & 1;
        data.icSEtatVolet = (buffer.readUInt8(1) >> 6) & 1;
        data.icSDisponibiliteVolet = (buffer.readUInt8(1) >> 7) & 1;

        data.icSCompteurBouton = buffer.readUInt32LE(2);
        data.icSNombreCommutationRelais = buffer.readUInt32LE(6);
        data.icSDureeEntreDeuxInjections = buffer.readUInt16LE(10);
        data.icSDureeInjection = buffer.readUInt16LE(12);
        data.icSMesureRxReference = buffer.readUInt16LE(14);
        data.icSDetectionDebitReference = buffer.readUInt8(16);

        data.icSCompteurSurdosageEnSecondes = buffer.readUInt32LE(17);
        data.icSNombreTotalProtectionSurdosage = buffer.readUInt32LE(21);
        data.icSDureeDebitMaintenu = buffer.readUInt32LE(25);

        data.icSDureeInjectionEffectue = buffer.readUInt16LE(29);
        data.icSCompteurResetUsine = buffer.readUInt16LE(31);
        data.icSCompteurTempsInjection = buffer.readUInt32LE(33);
        data.icSModeRegulation = buffer.readUInt32LE(37) & 1;
        data.icSSecuriteInjectionCLPH = (buffer.readUInt32LE(37) >> 1) & 1;
      } else if (action == P00039DataRxTxIndex.InjectionChlore_Status2) {
        data.icSCompteurResetCompteur = buffer.readUInt16LE(0);
      }

      return data;
    };

    //On va vérifier ici la présence de P0003600 ou P0004700
    if (pool?.deviceTable?.P0003605?.data) {
      pool!.deviceTable!.P0003605!.data = P0003605P0004800Read(
        pool!.deviceTable!.P0003605!.data,
      );
    }

    if (pool?.deviceTable?.P0004800?.data) {
      pool!.deviceTable!.P0004800!.data = P0003605P0004800Read(
        pool!.deviceTable!.P0004800!.data,
      );
    }

    return pool;
  }

  P0003605Write(
    productClass: IProduct,
    pool: Pool,
    index: number,
  ): Buffer | null {
    const data = pool.deviceTable[productClass.dataIdentifier!]
      .data as P0003605Data;

    if (index == P00039DataRxTxIndex.InjectionChlore_Controle) {
      const buffer = Buffer.allocUnsafe(2);

      buffer.writeUInt8(data.icCModeFonctionnement, 0);

      let o = 0x00;

      o = (o << 0) | data.icCResetUsine;
      o = (o << 1) | data.icCConfirmationOTA;
      o = (o << 1) | data.icCResetCompteur;
      o = (o << 1) | data.icCAckUtilisateur;
      o = (o << 1) | data.icCCommandeAmorcageIHM;
      o = (o << 1) | data.icCCommandeAmorcageBle;
      o = (o << 1) | data.icCCommandeAmorcageCloud;

      buffer.writeUInt8(o, 1);
      return buffer;
    } else if (index == P00039DataRxTxIndex.InjectionChlore_Parametrage) {
      const buffer = Buffer.allocUnsafe(10);

      buffer.writeUInt16LE(data.icPDureeEntreDeuxInjections, 0);
      buffer.writeUInt16LE(data.icPDureeInjection, 2);
      buffer.writeUInt16LE(data.icPConsigneRegulationRx, 4);
      buffer.writeUInt8(data.icPHysteresisRegulationRx, 6);
      buffer.writeUInt8(data.icPDureeLimiteSurdosage, 7);
      buffer.writeUInt8(data.icPDureeMaximumQuotidienne, 8);

      let o = 0x00;
      o = (o << 0) | data.icPActivationSecuriteDesinfection;
      buffer.writeUInt8(o, 9);

      return buffer;
    } else if (index == P00039DataRxTxIndex.InjectionChlore_Installation) {
      const buffer = Buffer.allocUnsafe(4);

      let o = 0x00;

      o = (o << 0) | data.icISensContactFinBidon;
      o = (o << 1) | data.icIDetecteurFinBidonInstalle;
      o = (o << 1) | data.icIActivationProtectionSurdosage;
      o = (o << 1) | data.icIActivationFonctionAutoMaintien;
      o = (o << 1) | data.icIConfigurationProduit;

      buffer.writeUInt8(o, 0);
      buffer.writeUInt8(data.icISondeRxReference, 1);
      buffer.writeUInt8(data.icISourceReferenceDebit, 2);
      buffer.writeUInt8(data.icISourceReferenceFonctionVolet, 3);
      return buffer;
    }

    return null;
  }

  P0003606Read(pool: Pool, action: number, buffer: Buffer): Pool {
    const P0003606P0004801Read = (data: P0003606Data): P0003606Data => {
      if (action == P00039DataRxTxIndex.InjectionPh_Controle) {
        data.iphCCommandeAmorcageCloud = buffer.readUInt8(0) & 1;
        data.iphCCommandeAmorcageBle = (buffer.readUInt8(0) >> 1) & 1;
        data.iphCCommandeAmorcageIHM = (buffer.readUInt8(0) >> 2) & 1;
        data.iphCActivationRegulation = (buffer.readUInt8(0) >> 3) & 1;
        data.iphCAckUtilisateur = (buffer.readUInt8(0) >> 4) & 1;
        data.iphCResetCompteur = (buffer.readUInt8(0) >> 5) & 1;
        data.iphCConfirmationOTA = (buffer.readUInt8(0) >> 6) & 1;
        data.iphCResetUsine = (buffer.readUInt8(0) >> 7) & 1;
      } else if (action == P00039DataRxTxIndex.InjectionPh_Parametrage) {
        data.iphPDureeEntreDeuxInjections = buffer.readUInt16LE(0);
        data.iphPDureeInjection = buffer.readUInt16LE(2);
        data.iphPConsigneRegulationPh = buffer.readUInt8(4);
        data.iphPDureeLimiteSurdosage = buffer.readUInt8(5);
      } else if (action == P00039DataRxTxIndex.InjectionPh_Installation) {
        data.iphIConfigurationProduit = buffer.readUInt8(0) & 1;
        data.iphIActivationFonctionAutoMaintien =
          (buffer.readUInt8(0) >> 1) & 1;
        data.iphIActivationProtectionSurdosage = (buffer.readUInt8(0) >> 2) & 1;
        data.iphIDetecteurFinBidonInstalle = (buffer.readUInt8(0) >> 3) & 1;
        data.iphISensContactFinBidon = (buffer.readUInt8(0) >> 4) & 1;
        data.iphIActivationSecuritePh = (buffer.readUInt8(0) >> 5) & 1;
        data.iphISondePhReference = buffer.readUInt8(1);
        data.iphITypeCorrecteurPh = buffer.readUInt8(2);
        data.iphISourceReferenceDebit = buffer.readUInt8(3);
      } else if (action == P00039DataRxTxIndex.InjectionPh_Status) {
        data.iphSEtatBouton = buffer.readUInt8(0) & 1;
        data.iphSAlarme = (buffer.readUInt8(0) >> 1) & 1;
        data.iphSEtatPompe = (buffer.readUInt8(0) >> 2) & 1;
        data.iphSCommandeInjection = (buffer.readUInt8(0) >> 3) & 1;
        data.iphSCommandeAmorcage = (buffer.readUInt8(0) >> 4) & 1;
        data.iphSMesurePhReferenceDisponible = (buffer.readUInt8(0) >> 5) & 1;
        data.iphSCommandeRegulation = (buffer.readUInt8(0) >> 6) & 1;
        data.iphSSecuritePh = (buffer.readUInt8(0) >> 7) & 1;

        data.iphSMiseEnRouteFiltration = buffer.readUInt8(1) & 1;
        data.iphSArretInjection = (buffer.readUInt8(1) >> 1) & 1;
        data.iphSProtectionSurdosage = (buffer.readUInt8(1) >> 2) & 1;
        data.iphSEtatContactFinBidon = (buffer.readUInt8(1) >> 3) & 1;
        data.iphSFinBidon = (buffer.readUInt8(1) >> 4) & 1;

        data.iphSCompteurBouton = buffer.readUInt32LE(2);
        data.iphSNombreCommutationRelais = buffer.readUInt32LE(6);
        data.iphSCompteurResetCompteur = buffer.readUInt16LE(10);
        data.iphSMesurePhReference = buffer.readUInt16LE(12);
        data.iphSDetectionDebitReference = buffer.readUInt8(14);
        data.iphSDureeDebitMaintenu = buffer.readUInt32LE(15);
        data.iphSCompteurSurdosageEnSecondes = buffer.readUInt32LE(19);
        data.iphSNombreTotalProtectionSurdosage = buffer.readUInt32LE(23);
        data.iphSCompteurResetUsine = buffer.readUInt16LE(27);
        data.iphSCompteurTempsInjection = buffer.readUInt32LE(29);
      }

      return data;
    };

    //On va vérifier ici la présence de P0003606 ou P0004801
    if (pool?.deviceTable?.P0003606?.data) {
      pool!.deviceTable!.P0003606!.data = P0003606P0004801Read(
        pool!.deviceTable!.P0003606!.data,
      );
    }

    if (pool?.deviceTable?.P0004801?.data) {
      pool!.deviceTable!.P0004801!.data = P0003606P0004801Read(
        pool!.deviceTable!.P0004801!.data,
      );
    }

    return pool;
  }

  P0003606Write(
    productClass: IProduct,
    pool: Pool,
    index: number,
  ): Buffer | null {
    const data = pool.deviceTable[productClass.dataIdentifier!]
      .data as P0003606Data;

    if (index == P00039DataRxTxIndex.InjectionPh_Controle) {
      const buffer = Buffer.allocUnsafe(2);

      let o = 0x00;

      o = (o << 0) | data.iphCResetUsine;
      o = (o << 1) | data.iphCConfirmationOTA;
      o = (o << 1) | data.iphCResetCompteur;
      o = (o << 1) | data.iphCAckUtilisateur;
      o = (o << 1) | data.iphCActivationRegulation;
      o = (o << 1) | data.iphCCommandeAmorcageIHM;
      o = (o << 1) | data.iphCCommandeAmorcageBle;
      o = (o << 1) | data.iphCCommandeAmorcageCloud;

      buffer.writeUInt8(o, 0);
      return buffer;
    } else if (index == P00039DataRxTxIndex.InjectionPh_Parametrage) {
      const buffer = Buffer.allocUnsafe(6);

      buffer.writeUInt16LE(data.iphPDureeEntreDeuxInjections, 0);
      buffer.writeUInt16LE(data.iphPDureeInjection, 2);
      buffer.writeUInt8(data.iphPConsigneRegulationPh, 4);
      buffer.writeUInt8(data.iphPDureeLimiteSurdosage, 5);

      return buffer;
    } else if (index == P00039DataRxTxIndex.InjectionPh_Installation) {
      const buffer = Buffer.allocUnsafe(4);

      let o = 0x00;

      o = (o << 0) | data.iphIActivationSecuritePh;
      o = (o << 1) | data.iphISensContactFinBidon;
      o = (o << 1) | data.iphIDetecteurFinBidonInstalle;
      o = (o << 1) | data.iphIActivationProtectionSurdosage;
      o = (o << 1) | data.iphIActivationFonctionAutoMaintien;
      o = (o << 1) | data.iphIConfigurationProduit;

      buffer.writeUInt8(o, 0);
      buffer.writeUInt8(data.iphISondePhReference, 1);
      buffer.writeUInt8(data.iphITypeCorrecteurPh, 2);
      buffer.writeUInt8(data.iphISourceReferenceDebit, 3);
      return buffer;
    }

    return null;
  }

  P0003603Read(pool: Pool, action: number, buffer: Buffer): Pool {
    const P0003603P0004703Read = (data: P0003603Data): P0003603Data => {
      if (action == P00039DataRxTxIndex.Robot_Controle) {
        data.rbCConfirmationOTA = buffer.readUInt8(0) & 1;
        data.rbCResetManuelProtectionMagnetique =
          (buffer.readUInt8(0) >> 1) & 1;
        data.rbCResetManuelProtectionThermique = (buffer.readUInt8(0) >> 2) & 1;
        data.rbCResetUsine = (buffer.readUInt8(0) >> 3) & 1;
        data.rbCModeFonctionnement = buffer.readUInt8(1);
      } else if (action == P00039DataRxTxIndex.Robot_Parametrage) {
        data.rbPHorlogeJour = buffer.toString('hex', 0, 42);
        data.rbPHorlogeSemaine = buffer.toString('hex', 42, 48);
        data.rbPTypeHorloge = buffer.readUInt8(48) & 1;
      } else if (action == P00039DataRxTxIndex.Robot_Installation) {
        data.rbIConfigurationProduit = buffer.readUInt8(0) & 1;
        data.rbIActivationProtectionThermique = (buffer.readUInt8(0) >> 1) & 1;
        data.rbIActivationProtectionMagnetique = (buffer.readUInt8(0) >> 2) & 1;
        data.rbIActivationFonctionAutoMaintienRobot =
          (buffer.readUInt8(0) >> 3) & 1;
        data.rbIActivationPrioriteRobot = (buffer.readUInt8(0) >> 4) & 1;
        data.rbISourceDebitReference = buffer.readUInt8(1);
        data.rbICourantNominal = buffer.readUInt8(2);
      } else if (action == P00039DataRxTxIndex.Robot_Status) {
        data.rbSAlarm = buffer.readUInt8(0) & 1;
        data.rbSCommandePompe = (buffer.readUInt8(0) >> 1) & 1;
        data.rbSEtatPompe = (buffer.readUInt8(0) >> 2) & 1;
        data.rbSEtatProtectionMagnetique = (buffer.readUInt8(0) >> 3) & 1;
        data.rbSEtatProtectionThermique = (buffer.readUInt8(0) >> 4) & 1;
        data.rbSEtatBouton = (buffer.readUInt8(0) >> 5) & 1;
        data.rbSCommandePompeHorloge = (buffer.readUInt8(0) >> 6) & 1;
        data.rbSMiseenRouteFiltrationAutoMaintien =
          (buffer.readUInt8(0) >> 7) & 1;

        data.rbSMiseEnRouteFiltrationPrioriteRobot = buffer.readUInt8(1) & 1;
        data.rbSArretSurpresseurProtectionDebit =
          (buffer.readUInt8(1) >> 1) & 1;

        data.rbSDetectionDebitReference = buffer.readUInt8(2);
        data.rbSCourantConsommePompe = buffer.readUInt16LE(3);
        data.rbSNombreCommutationRelais = buffer.readUInt32LE(5);
        data.rbSTensionSecteur = buffer.readUInt8(9);
        data.rbSPuissanceApparente = buffer.readUInt16LE(10);
        data.rbSPuissanceActive = buffer.readUInt16LE(12);
        data.rbSCompteurPuissanceApparenteTotale = buffer.readUInt32LE(14);
        data.rbSCompteurPuissanceActiveTotale = buffer.readUInt32LE(18);
        data.rbSCompteurAmpereHeure = buffer.readUInt32LE(22);

        data.rbSTempsSousTension = buffer.readUInt32LE(26);
        data.rbSCompteurBouton = buffer.readUInt32LE(30);
        data.rbSCompteurResetUsine = buffer.readUInt16LE(34);

        data.rbSCompteurResetManuelProtectionMagnetique =
          buffer.readUInt16LE(36);
        data.rbSCompteurResetManuelProtectionThermique =
          buffer.readUInt16LE(38);
      }

      return data;
    };

    //On va vérifier ici la présence de P0003603 ou P0004703
    if (pool?.deviceTable?.P0003603?.data) {
      pool!.deviceTable!.P0003603!.data = P0003603P0004703Read(
        pool!.deviceTable!.P0003603!.data,
      );
    }

    if (pool?.deviceTable?.P0004703?.data) {
      pool!.deviceTable!.P0004703!.data = P0003603P0004703Read(
        pool!.deviceTable!.P0004703!.data,
      );
    }

    return pool;
  }

  P0003603Write(
    productClass: IProduct,
    pool: Pool,
    index: number,
  ): Buffer | null {
    const data = pool.deviceTable[productClass.dataIdentifier!]
      .data as P0003603Data;

    if (index == P00039DataRxTxIndex.Robot_Controle) {
      const buffer = Buffer.allocUnsafe(2);

      let o = 0x00;
      o = (o << 0) | data.rbCResetUsine;
      o = (o << 1) | data.rbCResetManuelProtectionThermique;
      o = (o << 1) | data.rbCResetManuelProtectionMagnetique;
      o = (o << 1) | data.rbCConfirmationOTA;

      buffer.writeUInt8(o, 0);
      buffer.writeUInt8(data.rbCModeFonctionnement, 1);
      return buffer;
    } else if (index == P00039DataRxTxIndex.Robot_Parametrage) {
      const buffer = Buffer.allocUnsafe(50);

      buffer.write(data.rbPHorlogeJour, 0, 42, 'hex');
      buffer.write(data.rbPHorlogeSemaine, 42, 6, 'hex');

      let o = 0x00;
      o = (o << 0) | data.rbPTypeHorloge;
      buffer.writeUInt8(o, 48);

      return buffer;
    } else if (index == P00039DataRxTxIndex.Robot_Installation) {
      const buffer = Buffer.allocUnsafe(3);

      let o = 0x00;

      o = (o << 0) | data.rbIActivationPrioriteRobot;
      o = (o << 1) | data.rbIActivationFonctionAutoMaintienRobot;
      o = (o << 1) | data.rbIActivationProtectionMagnetique;
      o = (o << 1) | data.rbIActivationProtectionThermique;
      o = (o << 1) | data.rbIConfigurationProduit;

      buffer.writeUInt8(o, 0);
      buffer.writeUInt8(data.rbISourceDebitReference, 1);
      buffer.writeUInt8(data.rbICourantNominal, 2);
      return buffer;
    }

    return null;
  }

  P0003602Read(pool: Pool, action: number, buffer: Buffer): Pool {
    const P0003602P0004702Read = (data: P0003602Data): P0003602Data => {
      if (action == P00039DataRxTxIndex.NCC_Controle) {
        data.ncCConfirmationOTA = buffer.readUInt8(0) & 1;
        data.ncCResetProtectionMagnetique = (buffer.readUInt8(0) >> 1) & 1;
        data.ncCResetProtectionThermique = (buffer.readUInt8(0) >> 2) & 1;
        data.ncCResetUsine = (buffer.readUInt8(0) >> 3) & 1;
        data.ncCCommandePompe = (buffer.readUInt8(0) >> 4) & 1;
      } else if (action == P00039DataRxTxIndex.NCC_Parametrage) {
        data.ncPDureeTemporisation = buffer.readUInt8(0);
      } else if (action == P00039DataRxTxIndex.NCC_Installation) {
        data.ncIConfigurationProduit = buffer.readUInt8(0) & 1;
        data.ncIActivationProtectionThermique = (buffer.readUInt8(0) >> 1) & 1;
        data.ncIActivationProtectionMagnetique = (buffer.readUInt8(0) >> 2) & 1;
        data.ncICourantNominalPompe = buffer.readUInt8(1);
      } else if (action == P00039DataRxTxIndex.NCC_Status) {
        data.ncSAlarme = buffer.readUInt8(0) & 1;
        data.ncSCommandePompe = (buffer.readUInt8(0) >> 1) & 1;
        data.ncSEtatPompe = (buffer.readUInt8(0) >> 2) & 1;
        data.ncSEtatProtectionMagnetique = (buffer.readUInt8(0) >> 3) & 1;
        data.ncSEtatProtectionThermique = (buffer.readUInt8(0) >> 4) & 1;
        data.ncSEtatBouton = (buffer.readUInt8(0) >> 5) & 1;

        data.ncSCompteARebours = buffer.readUInt16LE(1);
        data.ncSCourantConsommePompe = buffer.readUInt16LE(3);
        data.ncSNombreCommutationRelais = buffer.readUInt32LE(5);
        data.ncSTensionSecteur = buffer.readUInt8(9);
        data.ncSPuissanceApparente = buffer.readUInt16LE(10);
        data.ncSPuissanceActive = buffer.readUInt16LE(12);
        data.ncSCompteurPuissanceApparenteTotale = buffer.readUInt32LE(14);
        data.ncSCompteurPuissanceActiveTotale = buffer.readUInt32LE(18);
        data.ncSCompteurAmpereHeure = buffer.readUInt32LE(22);

        data.ncSTempsSousTension = buffer.readUInt32LE(26);
        data.ncSCompteurBouton = buffer.readUInt32LE(30);
        data.ncSCompteurResetUsine = buffer.readUInt16LE(34);

        data.ncSCompteurResetManuelProtectionMagnetique =
          buffer.readUInt16LE(36);
        data.ncSCompteurResetManuelProtectionThermique =
          buffer.readUInt16LE(38);
      }

      return data;
    };

    //On va vérifier ici la présence de P0003602 ou P0004702
    if (pool?.deviceTable?.P0003602?.data) {
      pool!.deviceTable!.P0003602!.data = P0003602P0004702Read(
        pool!.deviceTable!.P0003602!.data,
      );
    }

    if (pool?.deviceTable?.P0004702?.data) {
      pool!.deviceTable!.P0004702!.data = P0003602P0004702Read(
        pool!.deviceTable!.P0004702!.data,
      );
    }

    return pool;
  }

  P0003602Write(
    productClass: IProduct,
    pool: Pool,
    index: number,
  ): Buffer | null {
    const data = pool.deviceTable[productClass.dataIdentifier!]
      .data as P0003602Data;

    if (index == P00039DataRxTxIndex.NCC_Controle) {
      const buffer = Buffer.allocUnsafe(1);

      let o = 0x00;
      o = (o << 0) | data.ncCCommandePompe;
      o = (o << 1) | data.ncCResetUsine;
      o = (o << 1) | data.ncCResetProtectionThermique;
      o = (o << 1) | data.ncCResetProtectionMagnetique;
      o = (o << 1) | data.ncCConfirmationOTA;

      buffer.writeUInt8(o, 0);

      return buffer;
    } else if (index == P00039DataRxTxIndex.NCC_Parametrage) {
      const buffer = Buffer.allocUnsafe(1);

      buffer.writeUInt8(data.ncPDureeTemporisation, 0);

      return buffer;
    } else if (index == P00039DataRxTxIndex.NCC_Installation) {
      const buffer = Buffer.allocUnsafe(2);

      let o = 0x00;

      o = (o << 0) | data.ncIActivationProtectionMagnetique;
      o = (o << 1) | data.ncIActivationProtectionThermique;
      o = (o << 1) | data.ncIConfigurationProduit;

      buffer.writeUInt8(o, 0);
      buffer.writeUInt8(data.ncICourantNominalPompe, 1);

      return buffer;
    }

    return null;
  }

  P0003604Read(pool: Pool, action: number, buffer: Buffer): Pool {
    const P0003604P0004704Read = (data: P0003604Data): P0003604Data => {
      if (action == P00039DataRxTxIndex.Blower_Controle) {
        data.blCConfirmationOTA = buffer.readUInt8(0) & 1;
        data.blCResetProtectionMagnetique = (buffer.readUInt8(0) >> 1) & 1;
        data.blCResetProtectionThermique = (buffer.readUInt8(0) >> 2) & 1;
        data.blCResetUsine = (buffer.readUInt8(0) >> 3) & 1;
        data.blCCommandePompe = (buffer.readUInt8(0) >> 4) & 1;
      } else if (action == P00039DataRxTxIndex.Blower_Parametrage) {
        data.blPDureeTemporisation = buffer.readUInt8(0);
      } else if (action == P00039DataRxTxIndex.Blower_Installation) {
        data.blIConfigurationProduit = buffer.readUInt8(0) & 1;
        data.blIActivationProtectionThermique = (buffer.readUInt8(0) >> 1) & 1;
        data.blIActivationProtectionMagnetique = (buffer.readUInt8(0) >> 2) & 1;
        data.blICourantNominalPompe = buffer.readUInt8(1);
      } else if (action == P00039DataRxTxIndex.Blower_Status) {
        data.blSAlarme = buffer.readUInt8(0) & 1;
        data.blSCommandePompe = (buffer.readUInt8(0) >> 1) & 1;
        data.blSEtatPompe = (buffer.readUInt8(0) >> 2) & 1;
        data.blSEtatProtectionMagnetique = (buffer.readUInt8(0) >> 3) & 1;
        data.blSEtatProtectionThermique = (buffer.readUInt8(0) >> 4) & 1;
        data.blSEtatBouton = (buffer.readUInt8(0) >> 5) & 1;

        data.blSCompteARebours = buffer.readUInt16LE(1);
        data.blSCourantConsommePompe = buffer.readUInt16LE(3);
        data.blSNombreCommutationRelais = buffer.readUInt32LE(5);
        data.blSTensionSecteur = buffer.readUInt8(9);
        data.blSPuissanceApparente = buffer.readUInt16LE(10);
        data.blSPuissanceActive = buffer.readUInt16LE(12);
        data.blSCompteurPuissanceApparenteTotale = buffer.readUInt32LE(14);
        data.blSCompteurPuissanceActiveTotale = buffer.readUInt32LE(18);
        data.blSCompteurAmpereHeure = buffer.readUInt32LE(22);

        data.blSTempsSousTension = buffer.readUInt32LE(26);
        data.blSCompteurBouton = buffer.readUInt32LE(30);
        data.blSCompteurResetUsine = buffer.readUInt16LE(34);

        data.blSCompteurResetManuelProtectionMagnetique =
          buffer.readUInt16LE(36);
        data.blSCompteurResetManuelProtectionThermique =
          buffer.readUInt16LE(38);
      }
      return data;
    };

    //On va vérifier ici la présence de P0003602 ou P0004702
    if (pool?.deviceTable?.P0003604.data) {
      pool!.deviceTable!.P0003604!.data = P0003604P0004704Read(
        pool!.deviceTable!.P0003604!.data,
      );
    }

    if (pool?.deviceTable?.P0004704?.data) {
      pool!.deviceTable!.P0004704!.data = P0003604P0004704Read(
        pool!.deviceTable!.P0004704!.data,
      );
    }

    return pool;
  }

  P0003604Write(
    productClass: IProduct,
    pool: Pool,
    index: number,
  ): Buffer | null {
    const data = pool.deviceTable[productClass.dataIdentifier!]
      .data as P0003604Data;

    if (index == P00039DataRxTxIndex.Blower_Controle) {
      const buffer = Buffer.allocUnsafe(1);

      let o = 0x00;
      o = (o << 0) | data.blCCommandePompe;
      o = (o << 1) | data.blCResetUsine;
      o = (o << 1) | data.blCResetProtectionThermique;
      o = (o << 1) | data.blCResetProtectionMagnetique;
      o = (o << 1) | data.blCConfirmationOTA;

      buffer.writeUInt8(o, 0);

      return buffer;
    } else if (index == P00039DataRxTxIndex.Blower_Parametrage) {
      const buffer = Buffer.allocUnsafe(1);

      buffer.writeUInt8(data.blPDureeTemporisation, 0);

      return buffer;
    } else if (index == P00039DataRxTxIndex.Blower_Installation) {
      const buffer = Buffer.allocUnsafe(2);

      let o = 0x00;

      o = (o << 0) | data.blIActivationProtectionMagnetique;
      o = (o << 1) | data.blIActivationProtectionThermique;
      o = (o << 1) | data.blIConfigurationProduit;

      buffer.writeUInt8(o, 0);
      buffer.writeUInt8(data.blICourantNominalPompe, 1);

      return buffer;
    }

    return null;
  }

  P0003607Read(pool: Pool, action: number, buffer: Buffer): Pool {
    const P0003607P0004900Read = (data: P0003607Data): P0003607Data => {
      if (action == P00039DataRxTxIndex.ElectrolyseurStandard_Controle) {
        data.esCModeFonctionnement = buffer.readUInt8(0);
        data.esCConfirmationOTA = buffer.readUInt8(1) & 1;
        data.esCResetCompteur = (buffer.readUInt8(1) >> 1) & 1;
        data.esCResetUsine = (buffer.readUInt8(1) >> 2) & 1;
      } else if (
        action == P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage
      ) {
        data.esPTypeHorloge = buffer.readUInt8(0) & 1;
        data.esPActivationFonctionHivernage = (buffer.readUInt8(0) >> 1) & 1;
        data.esPActivationSecuriteDesinfection = (buffer.readUInt8(0) >> 2) & 1;
        data.esPConsigneRx = buffer.readUInt16LE(1);
        data.esPHysteresisRegulationRx = buffer.readUInt8(45);
        data.esPHorlogeJour = buffer.toString('hex', 3, 45);
      } else if (
        action == P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage2
      ) {
        data.esPHorlogeSemaine = buffer.toString('hex', 0, 6);
        data.esPDureeInversionPolarite = buffer.readUInt8(6);
        data.esPTauxAbaissement = buffer.readUInt8(7);
        data.esPTemperatureHivernage = buffer.readUInt8(8);
      } else if (
        action == P00039DataRxTxIndex.ElectrolyseurStandard_Installation
      ) {
        data.esIConfigurationProduit = buffer.readUInt8(0) & 1;
        data.esIActivationFonctionPrioriteElectrolyse =
          (buffer.readUInt8(0) >> 1) & 1;
        data.esIActivationFonctionAutoMaintien = (buffer.readUInt8(0) >> 2) & 1;
        data.esISensContactSel = (buffer.readUInt8(0) >> 3) & 1;
        data.esIActivationInversionPolarite = (buffer.readUInt8(0) >> 4) & 1;
        data.esISourceReferenceVolet = buffer.readUInt8(1);
        data.esISondeReferenceRx = buffer.readUInt8(2);
        data.esIMethodeAsservissement = buffer.readUInt8(3);
        data.esICapteurTemperatureReference = buffer.readUInt8(4);
        data.esISourceReferenceDebit = buffer.readUInt8(5);
      } else if (action == P00039DataRxTxIndex.ElectrolyseurStandard_Status) {
        data.esSCommandeElectrolyseur = buffer.readUInt8(0) & 1;
        data.esSEtatSortieElectrolyseur = (buffer.readUInt8(0) >> 1) & 1;
        data.esSEtatBouton = (buffer.readUInt8(0) >> 2) & 1;
        data.esSAlarme = (buffer.readUInt8(0) >> 3) & 1;
        data.esSMesureRxReferenceRegRx = (buffer.readUInt8(0) >> 4) & 1;
        data.esSCommandeElectrolyseurRegRx = (buffer.readUInt8(0) >> 5) & 1;
        data.esSCommandeElectrolyseurRegHorloge =
          (buffer.readUInt8(0) >> 6) & 1;
        data.esSArretElectrolyseurInversionPolarite =
          (buffer.readUInt8(0) >> 7) & 1;

        data.esSAsservissementAlimentationVolet = buffer.readUInt8(1) & 1;
        data.esSArretElectrolyseurAsservissementAlimentation =
          (buffer.readUInt8(1) >> 1) & 1;
        data.esSAsservissementContactSelVolet = (buffer.readUInt8(1) >> 2) & 1;
        data.esSCommandeAsservissementVolet = (buffer.readUInt8(1) >> 3) & 1;
        data.esSProtectionHivernage = (buffer.readUInt8(1) >> 4) & 1;
        data.esSTemperatureReferenceDisponibleProtectionHivernage =
          (buffer.readUInt8(1) >> 5) & 1;
        data.esSArretElectrolyseurProtectionHivernage =
          (buffer.readUInt8(1) >> 6) & 1;
        data.esSArretElectrolyseurProtectionDebit =
          (buffer.readUInt8(1) >> 7) & 1;

        data.esSMiseRouteFiltrationPrioElectrolyse = buffer.readUInt8(2) & 1;
        data.esSMiseRouteFiltrationPrioAutoMaintien =
          (buffer.readUInt8(2) >> 1) & 1;
        data.esSEtatVolet = (buffer.readUInt8(2) >> 2) & 1;
        data.esSSecuriteDesinfection = (buffer.readUInt8(2) >> 3) & 1;

        data.esSCourantConsomme = buffer.readUInt16LE(3);
        data.esSNombreCommutationRelais = buffer.readUInt32LE(5);
        data.esSTensionSecteur = buffer.readUInt8(9);
        data.esSPuissanceApparente = buffer.readUInt16LE(10);
        data.esSPuissanceActive = buffer.readUInt16LE(12);
        data.esSCompteurPuissanceApparenteTotal = buffer.readUInt32LE(14);
        data.esSCompteurPuissanceActiveTotal = buffer.readUInt32LE(18);
        data.esSCompteurAmpereHeure = buffer.readUInt32LE(22);
        data.esSTempsSousTension = buffer.readUInt32LE(26);
        data.esSCompteurBouton = buffer.readUInt32LE(30);
        data.esSMesureRxReference = buffer.readUInt16LE(34);
        data.esSCompteurInversionPolarite = buffer.readUInt32LE(36);
        data.esSMesureTemperature = buffer.readInt16LE(40);
        data.esSDetectionDebitReference = buffer.readUInt8(42);
      } else if (action == P00039DataRxTxIndex.ElectrolyseurStandard_Status2) {
        data.esSCumulTempsFonctionnementTemperatureBasse =
          buffer.readUInt32LE(0);
        data.esSCompteurResetUsine = buffer.readUInt16LE(4);
        data.esSCompteurResetCompteur = buffer.readUInt16LE(6);
      }

      return data;
    };

    //On va vérifier ici la présence de P0003607 ou P0004900
    if (pool?.deviceTable?.P0003607?.data) {
      pool!.deviceTable!.P0003607!.data = P0003607P0004900Read(
        pool!.deviceTable!.P0003607!.data,
      );
    }

    if (pool?.deviceTable?.P00049?.data) {
      pool!.deviceTable!.P00049!.data = P0003607P0004900Read(
        pool!.deviceTable!.P00049!.data,
      );
    }

    return pool;
  }

  P0003607Write(
    productClass: IProduct,
    pool: Pool,
    index: number,
  ): Buffer | null {
    const data = pool.deviceTable[productClass.dataIdentifier!]
      .data as P0003607Data;

    if (index == P00039DataRxTxIndex.ElectrolyseurStandard_Controle) {
      const buffer = Buffer.allocUnsafe(2);

      buffer.writeUInt8(data.esCModeFonctionnement, 0);

      let o = 0x00;

      o = (o << 0) | data.esCResetUsine;
      o = (o << 1) | data.esCResetCompteur;
      o = (o << 1) | data.esCConfirmationOTA;

      buffer.writeUInt8(o, 1);
      return buffer;
    } else if (index == P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage) {
      const buffer = Buffer.allocUnsafe(46);

      let o = 0x00;

      o = (o << 0) | data.esPActivationSecuriteDesinfection;
      o = (o << 1) | data.esPActivationFonctionHivernage;
      o = (o << 1) | data.esPTypeHorloge;

      buffer.writeUInt8(o, 0);
      buffer.writeUInt16LE(data.esPConsigneRx, 1);
      buffer.writeUInt8(data.esPHysteresisRegulationRx, 45);

      buffer.write(data.esPHorlogeJour, 3, 42, 'hex');
      return buffer;
    } else if (
      index == P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage2
    ) {
      const buffer = Buffer.allocUnsafe(9);

      buffer.write(data.esPHorlogeSemaine, 0, 6, 'hex');

      buffer.writeUInt8(data.esPDureeInversionPolarite, 6);
      buffer.writeUInt8(data.esPTauxAbaissement, 7);
      buffer.writeUInt8(data.esPTemperatureHivernage, 8);

      return buffer;
    } else if (
      index == P00039DataRxTxIndex.ElectrolyseurStandard_Installation
    ) {
      const buffer = Buffer.allocUnsafe(6);

      let o = 0x00;

      o = (o << 0) | data.esIActivationInversionPolarite;
      o = (o << 1) | data.esISensContactSel;
      o = (o << 1) | data.esIActivationFonctionAutoMaintien;
      o = (o << 1) | data.esIActivationFonctionPrioriteElectrolyse;
      o = (o << 1) | data.esIConfigurationProduit;

      buffer.writeUInt8(o, 0);

      buffer.writeUInt8(data.esISourceReferenceVolet, 1);
      buffer.writeUInt8(data.esISondeReferenceRx, 2);
      buffer.writeUInt8(data.esIMethodeAsservissement, 3);
      buffer.writeUInt8(data.esICapteurTemperatureReference, 4);
      buffer.writeUInt8(data.esISourceReferenceDebit, 5);
      return buffer;
    }

    return null;
  }

  P00045Read(pool: Pool, action: number, buffer: Buffer): Pool {
    if (!pool?.deviceTable?.connect?.data) {
      return pool;
    }

    const data = pool.deviceTable.connect.data as P00045Data;

    if (action == P00039DataRxTxIndex.Connect_Installation) {
      data.cnIMotDePasseWifi = buffer.toString('utf8', 0, 50);
    } else if (action == P00039DataRxTxIndex.Connect_Installation2) {
      data.cnINomWifi = buffer.toString('utf8', 0, 50);
    } else if (action == P00039DataRxTxIndex.Connect_Installation3) {
      data.cnIMiseAJourAutomatiqueProduits = buffer.readUInt8(0) & 1;
      data.cnIResetUsine = (buffer.readUInt8(0) >> 1) & 1;
      data.cnIConfigurationProduit = (buffer.readUInt8(0) >> 2) & 1;
      data.cnIConfirmationOTA = (buffer.readUInt8(0) >> 3) & 1;
    } else if (action == P00039DataRxTxIndex.Connect_Timezone) {
      data.cnITimezone = buffer
        .toString('utf8', 0, 50)
        .toString()
        .replace(/[^0-9a-zA-Z /+]/gi, '');
    } else if (action == P00039DataRxTxIndex.Connect_Status) {
      data.cnSClientConnecte = buffer.readUInt8(0) & 1;
      data.cnSEtatConnexionHTTPS = (buffer.readUInt8(0) >> 1) & 1;
      data.cnSEtatConnexionMQTT = (buffer.readUInt8(0) >> 2) & 1;
      data.cnSEtatConnexionEthernet = (buffer.readUInt8(0) >> 3) & 1;
      data.cnSEtatConnexionWifi = (buffer.readUInt8(0) >> 4) & 1;
      data.cnSEtatProcessusWifi = (buffer.readUInt8(0) >> 5) & 1;
      data.cnSEtatPurgeHistorique = (buffer.readUInt8(0) >> 6) & 1;
      data.cnSAlarme = (buffer.readUInt8(0) >> 7) & 1;

      data.cnSRSSIWifi = buffer.readUInt8(1);
      data.cnSDebutPurge =
        buffer.readUInt8(5).toString().padStart(2, '0') +
        '/' +
        buffer.readUInt8(4).toString().padStart(2, '0') +
        '/' +
        buffer.readUInt16LE(2).toString().padStart(4, '0') +
        ' ' +
        buffer.readUInt8(6).toString().padStart(2, '0') +
        ':' +
        buffer.readUInt8(7).toString().padStart(2, '0');
      data.cnSFinPurge =
        buffer.readUInt8(11).toString().padStart(2, '0') +
        '/' +
        buffer.readUInt8(10).toString().padStart(2, '0') +
        '/' +
        buffer.readUInt16LE(8).toString().padStart(4, '0') +
        ' ' +
        buffer.readUInt8(12).toString().padStart(2, '0') +
        ':' +
        buffer.readUInt8(13).toString().padStart(2, '0');

      data.cnSCompteurResetUsine = buffer.readUInt16LE(14);
    } else if (action == P00039DataRxTxIndex.Connect_Status2) {
      data.cnSCompteurPowerCycle = buffer.readUInt16LE(0);
      data.cnSCompteurResetTacheACWA = buffer.readUInt16LE(2);
      data.cnSCompteurResetTacheZ3 = buffer.readUInt16LE(4);
      data.cnSMaximumJournalierEspaceFlashUtilise = buffer.readUInt8(6);
      data.cnSCompteurAccessFichier = buffer.readUInt32LE(7);
      data.cnSCompteurErreurAccessFichier = buffer.readUInt16LE(11);
      data.cnSCompteurAPIPThread = buffer.readUInt32LE(13);
      data.cnSCompteurErreurAPIPThread = buffer.readUInt16LE(17);
      data.cnSMaximumJournalierRAMUtilise = buffer.readUInt8(19);
      data.cnSCompteurPublishMQTT = buffer.readUInt32LE(20);
      data.cnSCompteurErreurPublishMQTT = buffer.readUInt16LE(24);
      data.cnSCompteurRequetesHTTP = buffer.readUInt32LE(26);
      data.cnSCompteurErreursCURL = buffer.readUInt16LE(30);
      data.cnSCompteurErreursHTTP = buffer.readUInt16LE(32);
      data.cnSCompteurReportsZigbee = buffer.readUInt32LE(34);
      data.cnSCompteurErreurReportZigbee = buffer.readUInt16LE(38);
    }

    return pool;
  }

  P00045Write(
    productClass: IProduct,
    pool: Pool,
    index: number,
  ): Buffer | null {
    const data = pool.deviceTable[productClass.dataIdentifier!]
      .data as P00045Data;

    if (index == P00039DataRxTxIndex.Connect_Installation) {
      const buffer = Buffer.allocUnsafe(50);
      buffer.write(data.cnIMotDePasseWifi, 0, 50, 'utf8');
      return buffer;
    } else if (index == P00039DataRxTxIndex.Connect_Installation2) {
      const buffer = Buffer.allocUnsafe(50);
      buffer.write(data.cnINomWifi, 0, 50, 'utf8');
      return buffer;
    } else if (index == P00039DataRxTxIndex.Connect_Timezone) {
      const buffer = Buffer.allocUnsafe(50);
      buffer.write(data.cnITimezone, 0, 50, 'utf8');
      return buffer;
    } else if (index == P00039DataRxTxIndex.Connect_Installation3) {
      const buffer = Buffer.allocUnsafe(1);

      let o = 0x00;

      o = (o << 0) | data.cnIConfirmationOTA;
      o = (o << 1) | data.cnIConfigurationProduit;
      o = (o << 1) | data.cnIResetUsine;
      o = (o << 1) | data.cnIMiseAJourAutomatiqueProduits;

      buffer.writeUInt8(o, 0);
      return buffer;
    }

    return null;
  }

  P00030Read(pool: Pool, action: number, buffer: Buffer): Pool {
    if (!pool?.deviceTable?.P00030?.data) {
      return pool;
    }

    const data = pool.deviceTable.P00030.data as P00030Data;

    if (action == P00039DataRxTxIndex.TAir_Installation) {
      data.taIAjustementTemperature = buffer.readInt8(0);
      data.taIConfigurationProduit = buffer.readUInt8(1) & 1;
    } else if (action == P00039DataRxTxIndex.TAir_Controle) {
      data.taCResetUsine = buffer.readUInt8(0) & 1;
    } else if (action == P00039DataRxTxIndex.TAir_Status) {
      data.taSMesureBrutTemperature = buffer.readInt16LE(0);
      data.taSMesureTemperature = buffer.readInt16LE(2);
      data.taSTensionPile = buffer.readUInt16LE(4);
      data.taSCompteurResetUsine = buffer.readUInt16LE(6);
      data.taSEtatPile = buffer.readUInt8(8) & 1;
      data.taSAlarme = (buffer.readUInt8(8) >> 1) & 1;
    }

    return pool;
  }

  P00030Write(
    productClass: IProduct,
    pool: Pool,
    index: number,
  ): Buffer | null {
    const data = pool.deviceTable[productClass.dataIdentifier!]
      .data as P00030Data;

    if (index == P00039DataRxTxIndex.TAir_Installation) {
      const buffer = Buffer.allocUnsafe(2);

      buffer.writeInt8(data.taIAjustementTemperature, 0);

      let o = 0x00;
      o = (o << 0) | data.taIConfigurationProduit;

      buffer.writeUInt8(o, 1);

      return buffer;
    } else if (index == P00039DataRxTxIndex.TAir_Controle) {
      const buffer = Buffer.allocUnsafe(1);

      let o = 0x00;
      o = (o << 0) | data.taCResetUsine;

      buffer.writeUInt8(o, 0);
      return buffer;
    }

    return null;
  }

  P00032Read(pool: Pool, action: number, buffer: Buffer): Pool {
    if (!pool?.deviceTable?.P00032?.data) {
      return pool;
    }

    const data = pool.deviceTable.P00032.data as P00032Data;

    if (action == P00039DataRxTxIndex.Sense_Installation) {
      data.snIConfigurationProduit = buffer.readUInt8(0) & 1;
      data.snISondeRxInstalle = (buffer.readUInt8(0) >> 1) & 1;
      data.snISondePhInstalle = (buffer.readUInt8(0) >> 2) & 1;
      data.snIInstallationCapteurDebit = (buffer.readUInt8(0) >> 3) & 1;
      data.snISensContactSecDebit = (buffer.readUInt8(0) >> 4) & 1;
    } else if (action == P00039DataRxTxIndex.Sense_Controle) {
      data.snCResetUsine = buffer.readUInt8(0) & 1;
      data.snCResetCompteur = (buffer.readUInt8(0) >> 1) & 1;
    } else if (action == P00039DataRxTxIndex.Sense_Status) {
      data.snSDisponibiliteCapteurDebit = buffer.readUInt8(0) & 1;
      data.snSEtatDebit = (buffer.readUInt8(0) >> 1) & 1;
      data.snSPresenceDebit = (buffer.readUInt8(0) >> 2) & 1;
      data.snSReceptionNouvelleMesure = (buffer.readUInt8(0) >> 3) & 1;
      data.snSValiditeEtalonnageRx = (buffer.readUInt8(0) >> 4) & 1;
      data.snSDefautSondeRx = (buffer.readUInt8(0) >> 5) & 1;
      data.snSDisponibiliteMesureRx = (buffer.readUInt8(0) >> 6) & 1;
      data.snSDisponibiliteMesureTemperature = (buffer.readUInt8(0) >> 7) & 1;

      data.snSValiditeEtalonnagePh = buffer.readUInt8(1) & 1;
      data.snSDefautSondePh = (buffer.readUInt8(1) >> 1) & 1;
      data.snSDisponibiliteMesurePh = (buffer.readUInt8(1) >> 2) & 1;
      data.snSEtatPile = (buffer.readUInt8(1) >> 3) & 1;
      data.snSSourceAlimentation = (buffer.readUInt8(1) >> 4) & 1;
      data.snSAlarme = (buffer.readUInt8(1) >> 5) & 1;
      data.snSPreventionContreGel = (buffer.readUInt8(1) >> 6) & 1;

      data.snSTensionPile = buffer.readUInt8(2);
      data.snSentreeSondeRx = buffer.readUInt16LE(3);
      data.snSMesureRxCompense = buffer.readUInt16LE(5);
      data.snSConstanteSondeRx = buffer.readInt16LE(7);

      data.snSEtalonageRx =
        buffer.readUInt8(9).toString().padStart(2, '0') +
        '/' +
        buffer.readUInt8(10).toString().padStart(2, '0') +
        '/' +
        buffer.readUInt16LE(11).toString().padStart(4, '0');

      data.snSEntreeSondePh = buffer.readInt16LE(13);
      data.snSMesurePhCompenseCentieme = buffer.readUInt16LE(15);
      data.snSMesurePhCompenseDixieme = buffer.readUInt8(17);
      data.snSConstanteSondePh = buffer.readInt16LE(18);
      data.snSTauxAccroissement = buffer.readInt16LE(20);
      data.snSEtalonnagePh =
        buffer.readUInt8(22).toString().padStart(2, '0') +
        '/' +
        buffer.readUInt8(23).toString().padStart(2, '0') +
        '/' +
        buffer.readUInt16LE(24).toString().padStart(4, '0');
      data.snSTempsRestantPollingRapide = buffer.readUInt16LE(26);
      data.snSMesureTemperatureEau = buffer.readInt16LE(28);
      data.snSValiditeTemperatureEau = buffer.readUInt8(30);
      data.snSNombreSecondeTemperatureEleve = buffer.readUInt32LE(31);
      data.snSCompteurResetCompteur = buffer.readUInt16LE(35);
      data.snSCompteurResetUsine = buffer.readUInt16LE(37);
      data.snSSecuriteMesureInjectionCl = buffer.readUInt8(39) & 1;
      data.snSSecuriteMesureInjectionPh = (buffer.readUInt8(39) >> 1) & 1;
    }

    return pool;
  }

  P00032Write(
    productClass: IProduct,
    pool: Pool,
    index: number,
  ): Buffer | null {
    const data = pool.deviceTable[productClass.dataIdentifier!]
      .data as P00032Data;

    if (index == P00039DataRxTxIndex.Sense_Installation) {
      const buffer = Buffer.allocUnsafe(1);

      let o = 0x00;

      o = (o << 0) | data.snISensContactSecDebit;
      o = (o << 1) | data.snIInstallationCapteurDebit;
      o = (o << 1) | data.snISondePhInstalle;
      o = (o << 1) | data.snISondeRxInstalle;
      o = (o << 1) | data.snIConfigurationProduit;

      buffer.writeUInt8(o, 0);
      return buffer;
    } else if (index == P00039DataRxTxIndex.Sense_Controle) {
      const buffer = Buffer.allocUnsafe(1);

      let o = 0x00;

      o = (o << 0) | data.snCResetCompteur;
      o = (o << 1) | data.snCResetUsine;

      buffer.writeUInt8(o, 0);
      return buffer;
    }

    return null;
  }

  P00043Read(pool: Pool, action: number, buffer: Buffer): Pool {
    if (!pool?.deviceTable?.P00043?.data) {
      return pool;
    }

    const data = pool.deviceTable.P00043.data as P00043Data;

    if (action == P00039DataRxTxIndex.PAC_Installation) {
      data.paIConfigurationProduit = buffer.readUInt8(0) & 1;
      data.paIActivationAutoMaintien = (buffer.readUInt8(0) >> 1) & 1;
      data.paIActivationPrioritePAC = (buffer.readUInt8(0) >> 2) & 1;
      data.paISensContactSec = (buffer.readUInt8(0) >> 3) & 1;
      data.paICapteurTemperatureReference = buffer.readUInt8(1);
      data.paISourceReferenceDebit = buffer.readUInt8(2);
    } else if (action == P00039DataRxTxIndex.PAC_Control) {
      data.paCModeFonctionnement = buffer.readUInt8(0);
      data.paCConfirmationOTA = (buffer.readUInt8(1) >> 0) & 1;
      data.paCResetUsine = (buffer.readUInt8(1) >> 1) & 1;
    } else if (action == P00039DataRxTxIndex.PAC_Parametrage) {
      data.paPConsigneTemperature = buffer.readUInt8(0);
      data.paPHorlogePicotJour = buffer.toString('hex', 1, 43);
      data.paPHorlogePicotSemaine = buffer.toString('hex', 43, 49);
      data.paPTypeHorloge = buffer.readUInt8(49) & 1;
    } else if (action == P00039DataRxTxIndex.PAC_Parametrage2) {
      data.paPModeRegulation = buffer.readUInt8(0);
    } else if (action == P00039DataRxTxIndex.PAC_Status) {
      data.paSCommande = buffer.readUInt8(0) & 1;
      data.paSEtat = (buffer.readUInt8(0) >> 1) & 1;
      data.paSEtatBouton = (buffer.readUInt8(0) >> 2) & 1;
      data.paSCommandeRegulation = (buffer.readUInt8(0) >> 3) & 1;
      data.paSCommandeHorloge = (buffer.readUInt8(0) >> 4) & 1;
      data.paSArretCommandDebit = (buffer.readUInt8(0) >> 5) & 1;
      data.paSMiseEnRouteFiltrationPriorite = (buffer.readUInt8(0) >> 6) & 1;
      data.paSMiseEnRouteFiltrationAutoMaintien =
        (buffer.readUInt8(0) >> 7) & 1;

      data.paSAlarme = buffer.readUInt8(1) & 1;
      data.paSTEauReferenceDisponible = (buffer.readUInt8(1) >> 1) & 1;
      data.paSEtatContactSec = (buffer.readUInt8(1) >> 2) & 1;

      data.paSDetectionDebitReference = buffer.readUInt8(2);
      data.paSMesureTemperature = buffer.readInt16LE(3);

      data.paSNombreCommutationsRelais = buffer.readUInt32LE(5);
      data.paSTempsSousTension = buffer.readUInt32LE(9);
      data.paSCompteurBouton = buffer.readUInt32LE(13);
      data.paSDureeDebitMaintenu = buffer.readUInt32LE(17);
      data.paSCompteurResetUsine = buffer.readUInt16LE(21);
    }

    return pool;
  }

  P00043Write(
    productClass: IProduct,
    pool: Pool,
    index: number,
  ): Buffer | null {
    const data = pool.deviceTable[productClass.dataIdentifier!]
      .data as P00043Data;

    if (index == P00039DataRxTxIndex.PAC_Installation) {
      const buffer = Buffer.allocUnsafe(3);

      let o = 0x00;

      o = (o << 0) | data.paISensContactSec;
      o = (o << 1) | data.paIActivationPrioritePAC;
      o = (o << 1) | data.paIActivationAutoMaintien;
      o = (o << 1) | data.paIConfigurationProduit;

      buffer.writeUInt8(o, 0);

      buffer.writeUInt8(data.paICapteurTemperatureReference, 1);
      buffer.writeUInt8(data.paISourceReferenceDebit, 2);

      return buffer;
    } else if (index == P00039DataRxTxIndex.PAC_Parametrage) {
      const buffer = Buffer.allocUnsafe(50);

      buffer.writeUInt8(data.paPConsigneTemperature, 0);

      buffer.write(data.paPHorlogePicotJour, 1, 42, 'hex');
      buffer.write(data.paPHorlogePicotSemaine, 43, 6, 'hex');

      let o = 0x00;
      o = (o << 0) | data.paPTypeHorloge;

      buffer.writeUInt8(o, 49);

      return buffer;
    } else if (index == P00039DataRxTxIndex.PAC_Parametrage2) {
      const buffer = Buffer.allocUnsafe(1);
      buffer.writeUInt8(data.paPModeRegulation, 0);

      return buffer;
    } else if (index == P00039DataRxTxIndex.PAC_Control) {
      const buffer = Buffer.allocUnsafe(2);

      buffer.writeUInt8(data.paCModeFonctionnement, 0);

      let o = 0x00;

      o = (o << 0) | data.paCResetUsine;
      o = (o << 1) | data.paCConfirmationOTA;

      buffer.writeUInt8(o, 1);
      return buffer;
    }
    return null;
  }

  P00041Read(pool: Pool, action: number, buffer: Buffer): Pool {
    if (!pool?.deviceTable?.P00041?.data) {
      return pool;
    }

    const data = pool.deviceTable.P00041.data as P00041Data;

    if (action == P00039DataRxTxIndex.Volet24_Installation) {
      data.vo24IConfigurationProduit = buffer.readUInt8(0) & 1;
      data.vo24IAntenneRF = (buffer.readUInt8(0) >> 1) & 1;
      data.vo24IInversionMoteur = (buffer.readUInt8(0) >> 2) & 1;
      data.vo24IConfigurationAlimentationMoteur =
        (buffer.readUInt8(0) >> 3) & 1;
      data.vo24ITypeCommandeMoteur = (buffer.readUInt8(0) >> 4) & 1;
      data.vo24ITypeCommandeContactSec = (buffer.readUInt8(0) >> 5) & 1;
      data.vo24ITypeActivationfonctionArretFiltration =
        (buffer.readUInt8(0) >> 6) & 1;
    } else if (action == P00039DataRxTxIndex.Volet24_Controle) {
      data.vo24CConfirmationOTA = buffer.readUInt8(0) & 1;
      data.vo24CResetUsine = (buffer.readUInt8(0) >> 1) & 1;
      data.vo24CUpdateTable = (buffer.readUInt8(0) >> 2) & 1;
      data.vo24CCommandeCloud = buffer.readUInt8(1);
      data.vo24CCommandeBLE = buffer.readUInt8(2);
      data.vo24CCodeSaisi = buffer.readUInt16LE(3).toString().padStart(4, '0');
    } else if (action == P00039DataRxTxIndex.Volet24_Parametrage) {
      data.vo24PModeOuverture = buffer.readInt8(0) & 1;
      data.vo24PCodeDeverrouillage = buffer
        .readUInt16LE(1)
        .toString()
        .padStart(4, '0');
    } else if (action == P00039DataRxTxIndex.Volet24_Status) {
      data.vo24SAlarme = buffer.readUInt8(0) & 1;
      data.vo24SProtectionInversionSens = (buffer.readUInt8(0) >> 1) & 1;
      data.vo24SOuvertureTemporiseeEnCours = (buffer.readUInt8(0) >> 2) & 1;
      data.vo24SEtatVolet = (buffer.readUInt8(0) >> 3) & 1;
      data.vo24SDeverrouillage = (buffer.readUInt8(0) >> 4) & 1;
      data.vo24SSourceCommande = (buffer.readUInt8(0) >> 5) & 1;
      data.vo24SCommandeCS1 = (buffer.readUInt8(0) >> 6) & 1;
      data.vo24SCommandeCS2 = (buffer.readUInt8(0) >> 7) & 1;

      data.vo24SCommandeA = buffer.readUInt8(1) & 1;
      data.vo24SCommandeB = (buffer.readUInt8(1) >> 1) & 1;
      data.vo24SArretFiltration = (buffer.readUInt8(1) >> 2) & 1;

      data.vo24SCommandeVolet = buffer.readUInt8(2);
      data.vo24SEtatMoteur = buffer.readUInt8(3);
      data.vo24SCommandeBoiteACle = buffer.readUInt8(4);
      data.vo24SCommandeMaitre = buffer.readUInt8(5);
      data.vo24SSourceCommandeMaitre = buffer.readUInt8(6);
      data.vo24SCompteurDeverrouillage = buffer.readUInt8(7);
      data.vo24SDureeFonctionnementMoteur = buffer.readUInt8(8);
      data.vo24SCompteAReboursOuvertureTemporisee = buffer.readUInt16LE(9);
      data.vo24SNombreCommutationRelaisCS1 = buffer.readUInt32LE(11);
      data.vo24SNombreCommutationRelaisCS2 = buffer.readUInt32LE(15);
      data.vo24SNombreCommutationRelaisA = buffer.readUInt32LE(19);
      data.vo24SNombreCommutationRelaisB = buffer.readUInt32LE(23);
      data.vo24SCompteurBouton = buffer.readUInt32LE(27);
      data.vo24STempsSousTension = buffer.readUInt32LE(31);
      data.vo24SCompteurResetUsine = buffer.readUInt16LE(35);
    }

    return pool;
  }

  P00041Write(
    productClass: IProduct,
    pool: Pool,
    index: number,
  ): Buffer | null {
    const data = pool.deviceTable[productClass.dataIdentifier!]
      .data as P00041Data;

    if (index == P00039DataRxTxIndex.Volet24_Installation) {
      const buffer = Buffer.allocUnsafe(1);

      let o = 0x00;

      o = (o << 0) | data.vo24ITypeActivationfonctionArretFiltration;
      o = (o << 1) | data.vo24ITypeCommandeContactSec;
      o = (o << 1) | data.vo24ITypeCommandeMoteur;
      o = (o << 1) | data.vo24IConfigurationAlimentationMoteur;
      o = (o << 1) | data.vo24IInversionMoteur;
      o = (o << 1) | data.vo24IAntenneRF;
      o = (o << 1) | data.vo24IConfigurationProduit;

      buffer.writeUInt8(o, 0);

      return buffer;
    } else if (index == P00039DataRxTxIndex.Volet24_Parametrage) {
      const buffer = Buffer.allocUnsafe(3);

      let o = 0x00;

      o = (o << 0) | data.vo24PModeOuverture;

      buffer.writeInt8(o, 0);

      buffer.writeUInt16LE(parseInt(data.vo24PCodeDeverrouillage), 1);

      return buffer;
    } else if (index == P00039DataRxTxIndex.Volet24_Controle) {
      const buffer = Buffer.allocUnsafe(5);

      let o = 0x00;

      o = (o << 0) | data.vo24CUpdateTable;
      o = (o << 1) | data.vo24CResetUsine;
      o = (o << 1) | data.vo24CConfirmationOTA;

      buffer.writeUInt8(o, 0);

      buffer.writeUInt8(data.vo24CCommandeCloud, 1);
      buffer.writeUInt8(data.vo24CCommandeBLE, 2);
      buffer.writeUInt16LE(parseInt(data.vo24CCodeSaisi), 3);

      return buffer;
    }
    return null;
  }

  P00042Read(pool: Pool, action: number, buffer: Buffer): Pool {
    if (!pool?.deviceTable?.P00042?.data) {
      return pool;
    }

    const data = pool.deviceTable.P00042.data as P00042Data;

    if (action == P00039DataRxTxIndex.Volet230_Installation) {
      data.vo230IConfigurationProduit = buffer.readUInt8(0) & 1;
      data.vo230IAntenneRF = (buffer.readUInt8(0) >> 1) & 1;
      data.vo230IActivationFonctionArretFiltration =
        (buffer.readUInt8(0) >> 2) & 1;
    } else if (action == P00039DataRxTxIndex.Volet230_Controle) {
      data.vo230CConfirmationOTA = buffer.readUInt8(0) & 1;
      data.vo230CResetUsine = (buffer.readUInt8(0) >> 1) & 1;
      data.vo230CCommandeCloud = buffer.readUInt8(1);
      data.vo230CCommandeBLE = buffer.readUInt8(2);
      data.vo230CCodeSaisi = buffer.readUInt16LE(3).toString().padStart(4, '0');
    } else if (action == P00039DataRxTxIndex.Volet230_Parametrage) {
      data.vo230PModeOuverture = buffer.readInt8(0) & 1;
      data.vo230PCodeDeverrouillage = buffer
        .readUInt16LE(1)
        .toString()
        .padStart(4, '0');
    } else if (action == P00039DataRxTxIndex.Volet230_Status) {
      data.vo230SAlarme = buffer.readUInt8(0) & 1;
      data.vo230SProtectionInversionSens = (buffer.readUInt8(0) >> 1) & 1;
      data.vo230SOuvertureTemporiseeEnCours = (buffer.readUInt8(0) >> 2) & 1;
      data.vo230SEtatVolet = (buffer.readUInt8(0) >> 3) & 1;
      data.vo230SDeverrouillage = (buffer.readUInt8(0) >> 4) & 1;
      data.vo230SSourceCommande = (buffer.readUInt8(0) >> 5) & 1;
      data.vo230SCommandeOuverture = (buffer.readUInt8(0) >> 6) & 1;
      data.vo230SCommandeFermeture = (buffer.readUInt8(0) >> 7) & 1;

      data.vo230SCommandeVolet = buffer.readUInt8(1);
      data.vo230SEtatMoteur = buffer.readUInt8(2);
      data.vo230SCommandeBoiteACle = buffer.readUInt8(3);
      data.vo230SCommandeMaitre = buffer.readUInt8(4);
      data.vo230SSourceCommandeMaitre = buffer.readUInt8(5);
      data.vo230SCompteurDeverrouillage = buffer.readUInt8(6);
      data.vo230SDureeFonctionnementMoteur = buffer.readUInt8(7);
      data.vo230SCompteAReboursOuvertureTemporisee = buffer.readUInt16LE(8);
      data.vo230SNombreCommutationRelaisOuverture = buffer.readUInt32LE(10);
      data.vo230SNombreCommutationRelaisFermeture = buffer.readUInt32LE(14);
      data.vo230SCompteurBouton = buffer.readUInt32LE(18);
      data.vo230STempsSousTension = buffer.readUInt32LE(22);
      data.vo230SCompteurResetUsine = buffer.readUInt16LE(26);
      data.vo230SArretFiltration = buffer.readUInt8(28) & 1;
    }

    return pool;
  }

  P00042Write(
    productClass: IProduct,
    pool: Pool,
    index: number,
  ): Buffer | null {
    const data = pool.deviceTable[productClass.dataIdentifier!]
      .data as P00042Data;

    if (index == P00039DataRxTxIndex.Volet230_Installation) {
      const buffer = Buffer.allocUnsafe(1);

      let o = 0x00;

      o = (o << 0) | data.vo230IActivationFonctionArretFiltration;
      o = (o << 1) | data.vo230IAntenneRF;
      o = (o << 1) | data.vo230IConfigurationProduit;

      buffer.writeUInt8(o, 0);

      return buffer;
    } else if (index == P00039DataRxTxIndex.Volet230_Parametrage) {
      const buffer = Buffer.allocUnsafe(3);

      let o = 0x00;

      o = (o << 0) | data.vo230PModeOuverture;

      buffer.writeInt8(o, 0);

      buffer.writeUInt16LE(parseInt(data.vo230PCodeDeverrouillage), 1);

      return buffer;
    } else if (index == P00039DataRxTxIndex.Volet230_Controle) {
      const buffer = Buffer.allocUnsafe(5);

      let o = 0x00;

      o = (o << 0) | data.vo230CResetUsine;
      o = (o << 1) | data.vo230CConfirmationOTA;

      buffer.writeUInt8(o, 0);

      buffer.writeUInt8(data.vo230CCommandeCloud, 1);
      buffer.writeUInt8(data.vo230CCommandeBLE, 2);
      buffer.writeUInt16LE(parseInt(data.vo230CCodeSaisi), 3);

      return buffer;
    }
    return null;
  }

  P00031Read(pool: Pool, action: number, buffer: Buffer): Pool {
    if (!pool?.deviceTable?.P00031?.data) {
      return pool;
    }

    const data = pool.deviceTable.P00031.data as P00031Data;

    if (action == P00039DataRxTxIndex.TunableStandard_Controle) {
      data.tunableStandardCProgSuivant = buffer.readUInt8(0) & 1;
      data.tunableStandardCSynchronisationProg = (buffer.readUInt8(0) >> 1) & 1;
    } else if (action == P00039DataRxTxIndex.TunableStandard_Installation) {
      data.tunableStandardITypeEclairage = buffer.readUInt8(0) & 3;
    } else if (action == P00039DataRxTxIndex.TunableStandard_Status) {
      data.tunableStandardSCommandeEclairage = buffer.readUInt8(0) & 1;
      data.tunableStandardSCommandeHorloge = (buffer.readUInt8(0) >> 1) & 1;
    } else if (action == P00039DataRxTxIndex.TunableStandard_Parametrage1) {
      data.tunableStandardPHorlogeJour = buffer.toString('hex', 0, 42);
    } else if (action == P00039DataRxTxIndex.TunableStandard_Parametrage2) {
      data.tunableStandardPHorlogeSemaine = buffer.toString('hex', 0, 6);
      data.tunableStandardPTypeHorloge = buffer.readUInt8(6) & 1;
      data.tunableStandardPDureeRuptureAlimentation = buffer.readUInt8(7);
    } else if (action == P00039DataRxTxIndex.TunableCouleur_Controle) {
      data.tunableCouleurCFonctionnementModeOn = buffer.readUInt8(0);
      data.tunableCouleurCCouleurModeOn = buffer.readUInt16LE(1);
      data.tunableCouleurCProgModeOn = buffer.readUInt8(3);
      data.tunableCouleurCSequenceModeOn = buffer.readUInt8(4);
      data.tunableCouleurCControleProgSuivant = buffer.readUInt8(5) & 1;
      data.tunableCouleurCControleProgPrecedent =
        (buffer.readUInt8(5) >> 1) & 1;
    } else if (action == P00039DataRxTxIndex.TunableCouleur_Parametrage1) {
      data.tunableCouleurPTypeCalendrier = buffer.readUInt8(0) & 1;
      data.tunableCouleurPCalendrierJour03 = buffer.toString('hex', 1, 17);
      data.tunableCouleurPCalendrierSemaine07 = buffer.toString('hex', 17, 49);
    } else if (action == P00039DataRxTxIndex.TunableCouleur_Parametrage2) {
      data.tunableCouleurPCalendrierSemaine817 = buffer.toString('hex', 0, 40);
    } else if (action == P00039DataRxTxIndex.TunableCouleur_Parametrage3) {
      data.tunableCouleurPCalendrierSemaine1827 = buffer.toString('hex', 0, 40);
    } else if (action == P00039DataRxTxIndex.TunableCouleur_Parametrage4) {
      data.tunableCouleurPSequenceProgrammee01 = buffer.toString('hex', 0, 48);
    } else if (action == P00039DataRxTxIndex.TunableCouleur_Parametrage5) {
      data.tunableCouleurPSequenceProgrammee23 = buffer.toString('hex', 0, 48);
    } else if (action == P00039DataRxTxIndex.TunableCouleur_Status) {
      data.tunableCouleurSComportementEclairage = buffer.readUInt32LE(0);
    } else if (action == P00039DataRxTxIndex.TunableBlanc_Controle) {
      data.tunableBlancCFonctionnementModeOn = buffer.readUInt8(0);
      data.tunableBlancCTemperatureModeOn = buffer.readUInt16LE(1);
      data.tunableBlancCProgModeOn = buffer.readUInt8(3);
      data.tunableBlancCControleProgSuivant = buffer.readUInt8(4) & 1;
      data.tunableBlancCControleProgPrecedent = (buffer.readUInt8(4) >> 1) & 1;
    } else if (action == P00039DataRxTxIndex.TunableBlanc_Parametrage1) {
      data.tunableBlancPTypeCalendrier = buffer.readUInt8(0) & 1;
      data.tunableBlancPCalendrierSemaine07 = buffer.toString('hex', 1, 33);
      data.tunableBlancPCalendrierJour03 = buffer.toString('hex', 33, 49);
    } else if (action == P00039DataRxTxIndex.TunableBlanc_Parametrage2) {
      data.tunableBlancPCalendrierSemaine817 = buffer.toString('hex', 0, 40);
    } else if (action == P00039DataRxTxIndex.TunableBlanc_Parametrage3) {
      data.tunableBlancPCalendrierSemaine1827 = buffer.toString('hex', 0, 40);
    } else if (action == P00039DataRxTxIndex.TunableBlanc_Status) {
      data.tunableBlancSComportementEclairage = buffer.readUInt32LE(0);
    } else if (action == P00039DataRxTxIndex.Tunable_Installation) {
      data.tunableITypeProjecteur = buffer.readUInt8(0);
      data.tunableIConfigurationProduit = buffer.readUInt8(1) & 1;
      data.tunableIActivationProtectionSousTension =
        (buffer.readUInt8(1) >> 1) & 1;
      data.tunableIActivationProtectionThermique =
        (buffer.readUInt8(1) >> 2) & 1;
      data.tunableISourceVolet = buffer.readUInt8(2);
    } else if (action == P00039DataRxTxIndex.Tunable_Status) {
      data.tunableSAlarme = buffer.readUInt16LE(0) & 1;
      data.tunableSEtatSortie = (buffer.readUInt16LE(0) >> 1) & 1;
      data.tunableSProtectionThermique = (buffer.readUInt16LE(0) >> 2) & 1;
      data.tunableSProtectionSousTension = (buffer.readUInt16LE(0) >> 3) & 1;
      data.tunableSEtatVolet = (buffer.readUInt16LE(0) >> 4) & 1;
      data.tunableSDisponibiliteEtatVolet = (buffer.readUInt16LE(0) >> 5) & 1;
      data.tunableSArretEclairageFonctionVolet =
        (buffer.readUInt16LE(0) >> 6) & 1;
      data.tunableSMiseEnRouteFiltration = (buffer.readUInt16LE(0) >> 7) & 1;
      data.tunableSEtatFusible = (buffer.readUInt16LE(0) >> 8) & 1;
      data.tunableSArretEclairageFonctionExtinction =
        (buffer.readUInt16LE(0) >> 9) & 1;
      data.tunableSArretEclairageFonctionExtinction24h =
        (buffer.readUInt16LE(0) >> 10) & 1;
      data.tunableSEtatBouton = (buffer.readUInt16LE(0) >> 11) & 1;

      data.tunableSTemperature = buffer.readUInt16LE(2);
      data.tunableSTension = buffer.readUInt16LE(4);

      data.tunableSTempsProjecteursAllumes = buffer.readUInt32LE(6);
      data.tunableSTempsSousTension = buffer.readUInt32LE(10);

      data.tunableSCompteurProtectionThermique = buffer.readUInt32LE(14);
      data.tunableSCompteurProtectionSousTension = buffer.readUInt32LE(18);

      data.tunableSCompteurBouton = buffer.readUInt32LE(22);
      data.tunableSCompteurErreurST = buffer.readUInt32LE(26);
      data.tunableSCompteAReboursFonctionMinuterie = buffer.readUInt32LE(30);
      data.tunableSCompteAReboursFonctionExtinction24h =
        buffer.readUInt32LE(34);
      data.tunableSCompteurResetUsine = buffer.readUInt16LE(38);
    } else if (action == P00039DataRxTxIndex.Tunable_Controle) {
      data.tunableCResetManuelProtectionThermique = buffer.readUInt8(0) & 1;
      data.tunableCResetManuelProtectionSousTension =
        (buffer.readUInt8(0) >> 1) & 1;
      data.tunableCControleMinuterie = (buffer.readUInt8(0) >> 2) & 1;
      data.tunableCResetUsine = (buffer.readUInt8(0) >> 3) & 1;
      data.tunableCConfirmationOTA = (buffer.readUInt8(0) >> 4) & 1;
      data.tunableCMode = buffer.readUInt8(1);
    } else if (action == P00039DataRxTxIndex.Tunable_Parametrage) {
      data.tunablePDureeMinuterie = buffer.readUInt32LE(0);
      data.tunablePHeureExtinction =
        buffer.readUInt8(4) * 60 + buffer.readUInt8(5);
      data.tunablePActivationFonctionExtinction = buffer.readUInt8(6) & 1;
      data.tunablePActivationFonctionExtinction24h =
        (buffer.readUInt8(6) >> 1) & 1;
      data.tunablePActivationFonctionVolet = (buffer.readUInt8(6) >> 2) & 1;
      data.tunablePActivationFonctionRedemEclairage =
        (buffer.readUInt8(6) >> 3) & 1;
    }

    return pool;
  }

  P00031Write(
    productClass: IProduct,
    pool: Pool,
    index: number,
  ): Buffer | null {
    const data = pool.deviceTable[productClass.dataIdentifier!]
      .data as P00031Data;

    if (index == P00039DataRxTxIndex.TunableStandard_Controle) {
      const buffer = Buffer.allocUnsafe(1);

      let o = 0x00;

      o = (o << 0) | data.tunableStandardCSynchronisationProg;
      o = (o << 1) | data.tunableStandardCProgSuivant;

      buffer.writeUInt8(o, 0);

      return buffer;
    } else if (index == P00039DataRxTxIndex.TunableStandard_Installation) {
      const buffer = Buffer.allocUnsafe(1);

      let o = 0x00;

      o = (o << 0) | data.tunableStandardITypeEclairage;

      buffer.writeInt8(o, 0);

      return buffer;
    } else if (index == P00039DataRxTxIndex.TunableStandard_Status) {
      const buffer = Buffer.allocUnsafe(1);

      let o = 0x00;

      o = (o << 0) | data.tunableStandardSCommandeHorloge;
      o = (o << 1) | data.tunableStandardSCommandeEclairage;

      buffer.writeUInt8(o, 0);

      return buffer;
    } else if (index == P00039DataRxTxIndex.TunableStandard_Parametrage1) {
      const buffer = Buffer.allocUnsafe(42);

      buffer.write(data.tunableStandardPHorlogeJour, 0, 42, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.TunableStandard_Parametrage2) {
      const buffer = Buffer.allocUnsafe(8);

      buffer.write(data.tunableStandardPHorlogeSemaine, 0, 6, 'hex');

      let o = 0x00;

      o = (o << 0) | data.tunableStandardPTypeHorloge;

      buffer.writeUInt8(o, 6);

      buffer.writeUInt8(data.tunableStandardPDureeRuptureAlimentation, 7);

      return buffer;
    } else if (index == P00039DataRxTxIndex.TunableCouleur_Controle) {
      const buffer = Buffer.allocUnsafe(6);

      buffer.writeUInt8(data.tunableCouleurCFonctionnementModeOn, 0);
      buffer.writeUInt16LE(data.tunableCouleurCCouleurModeOn, 1);
      buffer.writeUInt8(data.tunableCouleurCProgModeOn, 3);
      buffer.writeUInt8(data.tunableCouleurCSequenceModeOn, 4);

      let o = 0x00;

      o = (o << 0) | data.tunableCouleurCControleProgPrecedent;
      o = (o << 1) | data.tunableCouleurCControleProgSuivant;

      buffer.writeUInt8(o, 5);

      return buffer;
    } else if (index == P00039DataRxTxIndex.TunableCouleur_Parametrage1) {
      const buffer = Buffer.allocUnsafe(49);

      let o = 0x00;

      o = (o << 0) | data.tunableCouleurPTypeCalendrier;

      buffer.writeUInt8(o, 0);

      buffer.write(data.tunableCouleurPCalendrierJour03, 1, 16, 'hex');
      buffer.write(data.tunableCouleurPCalendrierSemaine07, 17, 32, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.TunableCouleur_Parametrage2) {
      const buffer = Buffer.allocUnsafe(40);

      buffer.write(data.tunableCouleurPCalendrierSemaine817, 0, 40, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.TunableCouleur_Parametrage3) {
      const buffer = Buffer.allocUnsafe(40);

      buffer.write(data.tunableCouleurPCalendrierSemaine1827, 0, 40, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.TunableCouleur_Parametrage4) {
      const buffer = Buffer.allocUnsafe(48);
      buffer.write(data.tunableCouleurPSequenceProgrammee01, 0, 48, 'hex');
      return buffer;
    } else if (index == P00039DataRxTxIndex.TunableCouleur_Parametrage5) {
      const buffer = Buffer.allocUnsafe(48);
      buffer.write(data.tunableCouleurPSequenceProgrammee23, 0, 48, 'hex');
      return buffer;
    } else if (index == P00039DataRxTxIndex.TunableBlanc_Controle) {
      const buffer = Buffer.allocUnsafe(5);

      buffer.writeUInt8(data.tunableBlancCFonctionnementModeOn, 0);
      buffer.writeUInt16LE(data.tunableBlancCTemperatureModeOn, 1);
      buffer.writeUInt8(data.tunableBlancCProgModeOn, 3);

      let o = 0x00;

      o = (o << 0) | data.tunableBlancCControleProgPrecedent;
      o = (o << 1) | data.tunableBlancCControleProgSuivant;

      buffer.writeUInt8(o, 4);

      return buffer;
    } else if (index == P00039DataRxTxIndex.TunableBlanc_Parametrage1) {
      const buffer = Buffer.allocUnsafe(49);

      let o = 0x00;

      o = (o << 0) | data.tunableBlancPTypeCalendrier;

      buffer.writeUInt8(o, 0);

      buffer.write(data.tunableBlancPCalendrierSemaine07, 1, 32, 'hex');
      buffer.write(data.tunableBlancPCalendrierJour03, 33, 16, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.TunableBlanc_Parametrage2) {
      const buffer = Buffer.allocUnsafe(40);

      buffer.write(data.tunableBlancPCalendrierSemaine817, 0, 40, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.TunableBlanc_Parametrage3) {
      const buffer = Buffer.allocUnsafe(40);

      buffer.write(data.tunableBlancPCalendrierSemaine1827, 0, 40, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.Tunable_Installation) {
      const buffer = Buffer.allocUnsafe(3);

      buffer.writeUInt8(data.tunableITypeProjecteur, 0);

      let o = 0x00;

      o = (o << 0) | data.tunableIActivationProtectionThermique;
      o = (o << 1) | data.tunableIActivationProtectionSousTension;
      o = (o << 1) | data.tunableIConfigurationProduit;

      buffer.writeUInt8(o, 1);

      buffer.writeUInt8(data.tunableISourceVolet, 2);

      return buffer;
    } else if (index == P00039DataRxTxIndex.Tunable_Controle) {
      const buffer = Buffer.allocUnsafe(2);

      let o = 0x00;

      o = (o << 0) | data.tunableCConfirmationOTA;
      o = (o << 1) | data.tunableCResetUsine;
      o = (o << 1) | data.tunableCControleMinuterie;
      o = (o << 1) | data.tunableCResetManuelProtectionSousTension;
      o = (o << 1) | data.tunableCResetManuelProtectionThermique;

      buffer.writeUInt8(o, 0);

      buffer.writeUInt8(data.tunableCMode, 1);

      return buffer;
    } else if (index == P00039DataRxTxIndex.Tunable_Parametrage) {
      const buffer = Buffer.allocUnsafe(7);

      buffer.writeUInt32LE(data.tunablePDureeMinuterie, 0);
      buffer.writeUInt8(Math.floor(data.tunablePHeureExtinction / 60), 4);
      buffer.writeUInt8(data.tunablePHeureExtinction % 60, 5);

      let o = 0x00;

      o = (o << 0) | data.tunablePActivationFonctionRedemEclairage;
      o = (o << 1) | data.tunablePActivationFonctionVolet;
      o = (o << 1) | data.tunablePActivationFonctionExtinction24h;
      o = (o << 1) | data.tunablePActivationFonctionExtinction;

      buffer.writeUInt8(o, 6);

      return buffer;
    }

    return null;
  }

  P00061Read(pool: Pool, action: number, buffer: Buffer): Pool {
    if (!pool?.deviceTable?.P00061?.data) {
      return pool;
    }

    const data = pool.deviceTable.P00061.data as P00061Data;

    if (action == P00039DataRxTxIndex.PACWP_Controle) {
      data.wpCModeFonctionnement = buffer.readUInt8(0);
      data.wpCResetUsine = buffer.readUInt8(1) & 1;
      data.wpCConfirmationOTA = (buffer.readUInt8(1) >> 1) & 1;
    } else if (action == P00039DataRxTxIndex.PACWP_Installation) {
      data.wpIActivationFonctionPriorite = buffer.readUInt8(0) & 1;
      data.wpIActivationFonctionAutoMaintien = (buffer.readUInt8(0) >> 1) & 1;
      data.wpIConfigurationProduit = (buffer.readUInt8(0) >> 2) & 1;
      data.wpISourceVolet = buffer.readUInt8(1);
    } else if (action == P00039DataRxTxIndex.PACWP_Status1) {
      data.wpSEtatFonctionnementPAC = buffer.readUInt16LE(0) & 1;
      data.wpSCommandeHorloge = (buffer.readUInt16LE(0) >> 1) & 1;
      data.wpSMiseRouteFiltrationPriorite = (buffer.readUInt16LE(0) >> 2) & 1;
      data.wpSMiseRouteFiltrationAutoMaintien =
        (buffer.readUInt16LE(0) >> 3) & 1;
      data.wpSEtatVolet = (buffer.readUInt16LE(0) >> 4) & 1;
      data.wpSDIsponibiliteEtatVolet = (buffer.readUInt16LE(0) >> 5) & 1;
      data.wpSRecommandationFermetture = (buffer.readUInt16LE(0) >> 6) & 1;
      data.wpSAlarme = (buffer.readUInt16LE(0) >> 7) & 1;
      data.wpSEtatSysteme = (buffer.readUInt16LE(0) >> 8) & 1;
      data.wpSEtatBouton = (buffer.readUInt16LE(0) >> 9) & 1;
      data.wpSTemperatureConsigneHorloge = buffer.readUInt16LE(2);
      data.wpSBypassPac = buffer.readUInt8(4);
      data.wpSCompteurResetUsine = buffer.readUInt16LE(5);
      data.wpSTempsSousTension = buffer.readUInt32LE(7);
      data.wpSCompteurBouton = buffer.readUInt32LE(11);
    } else if (action == P00039DataRxTxIndex.PACWP_Status2) {
      data.wpSFonctionnementPACCompresseur = buffer.readUInt16LE(0) & 1;
      data.wpSFonctionnementPACVentilationHauteVitesse =
        (buffer.readUInt16LE(0) >> 1) & 1;
      data.wpSFonctionnementPACVentilationFaibleVitesse =
        (buffer.readUInt16LE(0) >> 2) & 1;
      data.wpSFonctionnementPACPilotagePompeCirculation =
        (buffer.readUInt16LE(0) >> 3) & 1;
      data.wpSFonctionnementPACPilotageVanne4Voies =
        (buffer.readUInt16LE(0) >> 4) & 1;
      data.wpSOnOff = buffer.readUInt16LE(2);
      data.wpSTemperatureConsigneModeFroid = buffer.readUInt16LE(4);
      data.wpSTemperatureConsigneModeChaud = buffer.readUInt16LE(6);
      data.wpSTemperatureConsigneModeAuto = buffer.readUInt16LE(8);
      data.wpSTemperatureEauEntrante = buffer.readInt16LE(10);
      data.wpSTemperatureEauSortante = buffer.readInt16LE(12);
      data.wpSTemperatureAmbiante = buffer.readInt16LE(14);
      data.wpSTemperatureEntreeEvaporateur = buffer.readInt16LE(16);
      data.wpSTemperatureEntreeCompresseur = buffer.readInt16LE(18);
      data.wpSTemperatureSortieCompresseur = buffer.readInt16LE(20);
      data.wpSPression = buffer.readUInt16LE(22);
      data.wpSFrequenceCompresseur = buffer.readUInt8(24);
      data.wpSTensionSecteur = buffer.readUInt16LE(25);
      data.wpSCourantConsomme = buffer.readUInt16LE(27);
      data.puissanceConsomme = data.wpSTensionSecteur * data.wpSCourantConsomme;
      data.wpSDefautsPrincipauxCodeP01 = buffer.readUInt16LE(29) & 1;
      data.wpSDefautsPrincipauxCodeP02 = (buffer.readUInt16LE(29) >> 1) & 1;
      data.wpSDefautsPrincipauxCodeP04 = (buffer.readUInt16LE(29) >> 2) & 1;
      data.wpSDefautsPrincipauxCodeP05 = (buffer.readUInt16LE(29) >> 3) & 1;
      data.wpSDefautsPrincipauxCodeP07 = (buffer.readUInt16LE(29) >> 4) & 1;
      data.wpSDefautsPrincipauxCodeP081 = (buffer.readUInt16LE(29) >> 5) & 1;
      data.wpSDefautsPrincipauxCodeE051 = (buffer.readUInt16LE(29) >> 6) & 1;
      data.wpSDefautsPrincipauxCodeE01 = (buffer.readUInt16LE(29) >> 7) & 1;
      data.wpSDefautsPrincipauxCodeE02 = (buffer.readUInt16LE(29) >> 8) & 1;
      data.wpSDefautsPrincipauxCodeE03 = (buffer.readUInt16LE(29) >> 9) & 1;
      data.wpSDefautsPrincipauxCodeE19 = (buffer.readUInt16LE(29) >> 10) & 1;
      data.wpSDefautsPrincipauxCodeE29 = (buffer.readUInt16LE(29) >> 11) & 1;
      data.wpSDefautsPrincipauxCodeE07 = (buffer.readUInt16LE(29) >> 12) & 1;
      data.wpSDefautsPrincipauxSystem1 = (buffer.readUInt16LE(29) >> 13) & 1;
      data.wpSDefautsPrincipauxCodeE06 = (buffer.readUInt16LE(29) >> 14) & 1;
      data.wpSDefautsPrincipauxDefrosting = (buffer.readUInt16LE(29) >> 15) & 1;
      data.wpSRegistreDefauts2CompressorOverloadProtection =
        buffer.readUInt16LE(31) & 1;
      data.wpSRegistreDefauts2HighPressureProtection =
        (buffer.readUInt16LE(31) >> 1) & 1;
      data.wpSRegistreDefauts2LowPressureProtection =
        (buffer.readUInt16LE(31) >> 2) & 1;
      data.wpSRegistreDefauts2WaterFlowProtection =
        (buffer.readUInt16LE(31) >> 3) & 1;
      data.wpSRegistreDefauts2AntifreezingProtection =
        (buffer.readUInt16LE(31) >> 4) & 1;
      data.wpSRegistreDefauts2HighDischargeTemperatureProtection =
        (buffer.readUInt16LE(31) >> 5) & 1;
      data.wpSRegistreDefauts2MOPDriveWarning =
        (buffer.readUInt16LE(31) >> 6) & 1;
      data.wpSRegistreDefauts2ConverterBoardOffline =
        (buffer.readUInt16LE(31) >> 7) & 1;
      data.wpSRegistreDefauts2IPMProtection =
        (buffer.readUInt16LE(31) >> 8) & 1;
      data.wpSRegistreDefauts2CompressorStartFailure =
        (buffer.readUInt16LE(31) >> 9) & 1;
      data.wpSRegistreDefauts2ConverterInputLostPhase =
        (buffer.readUInt16LE(31) >> 10) & 1;
      data.wpSRegistreDefauts2IPMSamplingCurrentFailure =
        (buffer.readUInt16LE(31) >> 11) & 1;
      data.wpSRegistreDefauts2ConverterOverheatProtection =
        (buffer.readUInt16LE(31) >> 12) & 1;
      data.wpSRegistreDefauts2ConverterDCOverVoltage =
        (buffer.readUInt16LE(31) >> 13) & 1;
      data.wpSRegistreDefauts2ConverterDCUnderVoltage =
        (buffer.readUInt16LE(31) >> 14) & 1;
      data.wpSRegistreDefauts2InputUnderVoltage =
        (buffer.readUInt16LE(31) >> 15) & 1;
      data.wpSRegistreDefauts3InputOverVoltage = buffer.readUInt16LE(33) & 1;
      data.wpSRegistreDefauts3SamplingVoltageFailure =
        (buffer.readUInt16LE(33) >> 1) & 1;
      data.wpSRegistreDefauts3DspPfcConnectionFailure =
        (buffer.readUInt16LE(33) >> 2) & 1;
      data.wpSRegistreDefauts3RadiatorTemperatureSensingFailure =
        (buffer.readUInt16LE(33) >> 3) & 1;
      data.wpSRegistreDefauts3OverUnderVoltageFailure =
        (buffer.readUInt16LE(33) >> 4) & 1;
      data.wpSRegistreDefauts3PfcFailure = (buffer.readUInt16LE(33) >> 5) & 1;
      data.wpSRegistreDefauts3IpmOverheatProtection =
        (buffer.readUInt16LE(33) >> 6) & 1;
      data.wpSRegistreDefauts3WeakMagneticProtection =
        (buffer.readUInt16LE(33) >> 7) & 1;
      data.wpSRegistreDefauts3InputOverCurrentWarning =
        (buffer.readUInt16LE(33) >> 8) & 1;
      data.wpSRegistreDefauts3ConverterOverheatWarning =
        (buffer.readUInt16LE(33) >> 9) & 1;
      data.wpSRegistreDefauts3InputOvercurrentProtection =
        (buffer.readUInt16LE(33) >> 10) & 1;
      data.wpSRegistreDefauts3EepromErrorWarning =
        (buffer.readUInt16LE(33) >> 11) & 1;
      data.wpSRegistreDefauts3IpmProtection =
        (buffer.readUInt16LE(33) >> 12) & 1;
      data.wpSRegistreDefauts3DCFanMotorDriverBoardProtection =
        (buffer.readUInt16LE(33) >> 13) & 1;
      data.wpSRegistreDefauts3PressureSensorFailure =
        (buffer.readUInt16LE(33) >> 14) & 1;
      data.wpSRegistreDefauts3InputCoverCurrent =
        (buffer.readUInt16LE(33) >> 15) & 1;
      data.wpSRegistreDefauts4AntiFreezingProtection =
        buffer.readUInt16LE(35) & 1;
      data.wpSRegistreDefauts4AntiFreezingProtectionHeatingMode =
        (buffer.readUInt16LE(35) >> 1) & 1;
      data.wpSRegistreDefauts4ECFanMotorSignalFailure =
        (buffer.readUInt16LE(35) >> 2) & 1;
      data.wpSRegistreDefauts4FanMotor1Failure =
        (buffer.readUInt16LE(35) >> 3) & 1;
      data.wpSRegistreDefauts4FanMotor2Failure =
        (buffer.readUInt16LE(35) >> 4) & 1;
      data.wpSRegistreDefauts4DCFanMotorCommunicationFailure =
        (buffer.readUInt16LE(35) >> 5) & 1;
      data.wpSRegistreDefauts4InletOutletTempDifferenceTooMuch =
        (buffer.readUInt16LE(35) >> 6) & 1;
      data.wpSRegistreDefauts4LowAmibentTempProtection =
        (buffer.readUInt16LE(35) >> 7) & 1;
      data.wpSRegistreDefauts4CoilTempSensor2Failure =
        (buffer.readUInt16LE(35) >> 8) & 1;
      data.wpSEtatSwitchsHPSwitch = buffer.readUInt16LE(37) & 1;
      data.wpSEtatSwitchsLPSwitch = (buffer.readUInt16LE(37) >> 1) & 1;
      data.wpSEtatSwitchsWaterFlowSwitch = (buffer.readUInt16LE(37) >> 2) & 1;
      data.wpSEtatSwitchsRemoteOnOff = (buffer.readUInt16LE(37) >> 3) & 1;
      data.wpSEtatSwitchsmodeRemote = (buffer.readUInt16LE(37) >> 4) & 1;
      data.wpSEtatSwitchsMasterAndSlave = (buffer.readUInt16LE(37) >> 5) & 1;
      data.wpSVitesseVentilateurPrincipal = buffer.readUInt16LE(39);
      data.wpSCompteurPuissanceActiveTotal = buffer.readUInt32LE(41);
    } else if (action == P00039DataRxTxIndex.PACWP_Parametrage1) {
      data.wpPModeFonctionnementTemperature = buffer.readUInt8(0);
      data.wpPTemperatureConsigne = buffer.readUInt16LE(1);
      data.wpPPlanning1HeureDepart =
        buffer.readUInt8(3) * 60 + buffer.readUInt8(4);
      data.wpPPlanning1HeureFin =
        buffer.readUInt8(5) * 60 + buffer.readUInt8(6);
      data.wpPPlanning2HeureDepart =
        buffer.readUInt8(7) * 60 + buffer.readUInt8(8);
      data.wpPPlanning2HeureFin =
        buffer.readUInt8(9) * 60 + buffer.readUInt8(10);
      data.wpPPlanning1DepartPlanning = buffer.readUInt8(11) & 1;
      data.wpPPlanning1FinPlanning = (buffer.readUInt8(11) >> 1) & 1;
      data.wpPPlanning2DepartPlanning = (buffer.readUInt8(11) >> 2) & 1;
      data.wpPPlanning2FinPlanning = (buffer.readUInt8(11) >> 3) & 1;
      data.wpPTypeHorloge = (buffer.readUInt8(11) >> 4) & 1;
      data.wpPFonctionnementCompresseur = buffer.readUInt8(12);
      data.wpPModeSilence = buffer.readUInt8(13);
    } else if (action == P00039DataRxTxIndex.PACWP_Parametrage2) {
      data.wpPHorlogeSemaine = buffer.toString('hex', 0, 48);
    } else if (action == P00039DataRxTxIndex.PACWP_Parametrage3) {
      data.wpPHorlogeJourLundi = buffer.toString('hex', 0, 48);
    } else if (action == P00039DataRxTxIndex.PACWP_Parametrage4) {
      data.wpPHorlogeJourMardi = buffer.toString('hex', 0, 48);
    } else if (action == P00039DataRxTxIndex.PACWP_Parametrage5) {
      data.wpPHorlogeJourMercredi = buffer.toString('hex', 0, 48);
    } else if (action == P00039DataRxTxIndex.PACWP_Parametrage6) {
      data.wpPHorlogeJourJeudi = buffer.toString('hex', 0, 48);
    } else if (action == P00039DataRxTxIndex.PACWP_Parametrage7) {
      data.wpPHorlogeJourVendredi = buffer.toString('hex', 0, 48);
    } else if (action == P00039DataRxTxIndex.PACWP_Parametrage8) {
      data.wpPHorlogeJourSamedi = buffer.toString('hex', 0, 48);
    } else if (action == P00039DataRxTxIndex.PACWP_Parametrage9) {
      data.wpPHorlogeJourDimanche = buffer.toString('hex', 0, 48);
    }

    return pool;
  }

  P00061Write(
    productClass: IProduct,
    pool: Pool,
    index: number,
  ): Buffer | null {
    const data = pool.deviceTable[productClass.dataIdentifier!]
      .data as P00061Data;

    if (index == P00039DataRxTxIndex.PACWP_Controle) {
      const buffer = Buffer.allocUnsafe(2);
      buffer.writeUInt8(data.wpCModeFonctionnement, 0);

      let o = 0x00;

      o = (o << 0) | data.wpCConfirmationOTA;
      o = (o << 1) | data.wpCResetUsine;

      buffer.writeUInt8(o, 1);

      return buffer;
    } else if (index == P00039DataRxTxIndex.PACWP_Installation) {
      const buffer = Buffer.allocUnsafe(2);

      let o = 0x00;

      o = (o << 0) | data.wpIConfigurationProduit;
      o = (o << 1) | data.wpIActivationFonctionAutoMaintien;
      o = (o << 1) | data.wpIActivationFonctionPriorite;

      buffer.writeUInt8(o, 0);

      buffer.writeUInt8(data.wpISourceVolet, 1);

      return buffer;
    } else if (index == P00039DataRxTxIndex.PACWP_Parametrage1) {
      const buffer = Buffer.allocUnsafe(14);

      buffer.writeUInt8(data.wpPModeFonctionnementTemperature, 0);
      buffer.writeUInt16LE(data.wpPTemperatureConsigne, 1);
      buffer.writeUInt8(Math.floor(data.wpPPlanning1HeureDepart / 60), 3);
      buffer.writeUInt8(data.wpPPlanning1HeureDepart % 60, 4);
      buffer.writeUInt8(Math.floor(data.wpPPlanning1HeureFin / 60), 5);
      buffer.writeUInt8(data.wpPPlanning1HeureFin % 60, 6);
      buffer.writeUInt8(Math.floor(data.wpPPlanning2HeureDepart / 60), 7);
      buffer.writeUInt8(data.wpPPlanning2HeureDepart % 60, 8);
      buffer.writeUInt8(Math.floor(data.wpPPlanning2HeureFin / 60), 9);
      buffer.writeUInt8(data.wpPPlanning2HeureFin % 60, 10);

      let o = 0x00;

      o = (o << 0) | data.wpPTypeHorloge;
      o = (o << 1) | data.wpPPlanning2FinPlanning;
      o = (o << 1) | data.wpPPlanning2DepartPlanning;
      o = (o << 1) | data.wpPPlanning1FinPlanning;
      o = (o << 1) | data.wpPPlanning1DepartPlanning;

      buffer.writeUInt8(o, 11);

      buffer.writeUInt8(data.wpPFonctionnementCompresseur, 12);
      buffer.writeUInt8(data.wpPModeSilence, 13);

      return buffer;
    } else if (index == P00039DataRxTxIndex.PACWP_Parametrage2) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.wpPHorlogeSemaine, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PACWP_Parametrage3) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.wpPHorlogeJourLundi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PACWP_Parametrage4) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.wpPHorlogeJourMardi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PACWP_Parametrage5) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.wpPHorlogeJourMercredi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PACWP_Parametrage6) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.wpPHorlogeJourJeudi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PACWP_Parametrage7) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.wpPHorlogeJourVendredi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PACWP_Parametrage8) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.wpPHorlogeJourSamedi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PACWP_Parametrage9) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.wpPHorlogeJourDimanche, 0, 48, 'hex');

      return buffer;
    }

    return null;
  }

  P00037Read(pool: Pool, action: number, buffer: Buffer): Pool {
    if (!pool?.deviceTable?.P0003700?.data) {
      return pool;
    }

    const data = pool.deviceTable.P0003700.data as P00037Data;

    if (action == P00039DataRxTxIndex.SALT_Controle) {
      data.elCModeFonctionnement = buffer.readUInt8(0);
      data.elCResetUsine = buffer.readUInt8(1) & 1;
      data.elCResetNiveauSel = (buffer.readUInt8(1) >> 1) & 1;
      data.elConfirmationOTA = (buffer.readUInt8(1) >> 2) & 1;
      data.elCResetProtectionPresenceGaz = (buffer.readUInt8(1) >> 3) & 1;
    } else if (action == P00039DataRxTxIndex.SALT_Installation) {
      data.elIConfigurationProduit = buffer.readUInt8(0) & 1;
      data.elIActivationFonctionPrioriteElectrolyse =
        (buffer.readUInt8(0) >> 1) & 1;
      data.elIActivationFonctionPrioriteAutoMaintien =
        (buffer.readUInt8(0) >> 2) & 1;
      data.elIActivationFonctionPrioriteBoost = (buffer.readUInt8(0) >> 3) & 1;
      data.elISondeReferenceRX = buffer.readUInt8(1);
      data.elISourceReferenceFonctionVolet = buffer.readUInt8(2);
      data.elICapteurTemperatureReferenceFonctionProtectionHivernage =
        buffer.readUInt8(3);
      data.elISourceReferenceDebitFonctionProtectionDebit = buffer.readUInt8(4);
      data.elICaracteristiqueCelluleQRImax = buffer.readUInt8(5);
      data.elICaracteristiqueCelluleQRUmax = buffer.readUInt8(6);
      data.elICaracteristiqueCelluleQRVt = buffer.readUInt8(7);
    } else if (action == P00039DataRxTxIndex.SALT_Status1) {
      data.elSProtectionThermique = (buffer.readUInt8(0) >> 0) & 1;
      data.elSEtatInverseurPolarite = (buffer.readUInt8(0) >> 1) & 3;
      data.elSEtatAlimentation = (buffer.readUInt8(0) >> 3) & 1;
      data.elSEtatProduction = (buffer.readUInt8(0) >> 4) & 3;
      data.elSDisponibiliteSondeRX = (buffer.readUInt8(0) >> 6) & 1;
      data.elSEtatVolet = (buffer.readUInt8(0) >> 7) & 1;
      data.elSDisponibiliteVolet = (buffer.readUInt8(1) >> 0) & 1;
      data.elSAbaissementVolet = (buffer.readUInt8(1) >> 1) & 1;
      data.elSMesureDebit = (buffer.readUInt8(1) >> 2) & 1;
      data.elSDisponibiliteDebit = (buffer.readUInt8(1) >> 3) & 1;
      data.elSSecuriteDesinfection = (buffer.readUInt8(1) >> 4) & 1;
      data.elSProtectionHivernage = (buffer.readUInt8(1) >> 5) & 1;
      data.elSDisponibiliteTemperatureEau = (buffer.readUInt8(1) >> 6) & 1;
      data.elSProtectionPresenceGaz = (buffer.readUInt8(1) >> 7) & 1;
      data.elSEtatLimiteurPuissance = (buffer.readUInt8(2) >> 0) & 1;
      data.elSCaracteristiqueCelluleUtilise = (buffer.readUInt8(2) >> 1) & 3;
      data.elSMiseEnRouteFiltrationPriorite = (buffer.readUInt8(2) >> 3) & 1;
      data.elSMiseEnRouteFiltrationAutoMaintien =
        (buffer.readUInt8(2) >> 4) & 1;
      data.elSSecuriteDeconnexionProduit = (buffer.readUInt8(2) >> 5) & 1;
      data.elSAlarme = (buffer.readUInt8(2) >> 6) & 1;
      data.elSDefautCourant = (buffer.readUInt8(2) >> 7) & 1;
      data.elSResultatTestUsureCellule = (buffer.readUInt8(3) >> 0) & 3;
      data.elSEtatTemperature = (buffer.readUInt8(3) >> 3) & 1;
      data.elSEtatGPIOExtendeur = (buffer.readUInt8(3) >> 4) & 1;
      data.elSMemoire = (buffer.readUInt8(3) >> 5) & 1;
      data.elSMiseEnRouteFiltrationPrioriteBoost =
        (buffer.readUInt8(3) >> 6) & 1;
      data.elSNiveauSelBas = (buffer.readUInt8(3) >> 7) & 1;
      data.elSConsigneProduction = buffer.readUInt8(4);
      data.elSConsigneApplique = buffer.readUInt8(5);
      data.elSConsigneInversion = buffer.readUInt8(6);
      data.elSConsigneCommandeAlim = buffer.readUInt16LE(7);
      data.elSConsigneCourant = buffer.readUInt8(9);
      data.elSConsigneMesureCellule = buffer.readUInt8(10);
      data.elSTensionMesureCellule = buffer.readUInt8(11);
      data.elSTemperatureProduit = buffer.readUInt16LE(12);
      data.elSMesureRX = buffer.readUInt16LE(14);
      data.elSTempsRestantBoost = buffer.readUInt8(16);
      data.elSDureeDebitMaintenu = buffer.readUInt32LE(17);
      data.elSMesureTemperatureEau = buffer.readUInt16LE(21);
      data.elSTempsRestantEtapePolariteCourant = buffer.readUInt32LE(23);
      data.elSCaracteristiqueCelluleImax = buffer.readUInt8(27);
      data.elSCaracteristiqueCelluleUmax = buffer.readUInt8(28);
      data.elSCaracteristiqueCelluleVt = buffer.readUInt8(29);
      data.elSCumulTempsFonctionnementTemperatureBasse =
        buffer.readUInt32LE(30);
    } else if (action == P00039DataRxTxIndex.SALT_Status2) {
      data.elSDureeProduction25 = buffer.readUInt16LE(0);
      data.elSDureeProduction50 = buffer.readUInt16LE(2);
      data.elSDureeProduction75 = buffer.readUInt16LE(4);
      data.elSDureeProduction100 = buffer.readUInt16LE(6);
      data.elSPuissanceActive = buffer.readUInt16LE(8);
      data.elSCompteurPuissanceActiveTotale = buffer.readUInt32LE(10);
      data.elSTransferChargeCellule = buffer.readUInt32LE(14);
      data.elSNombreInversionPolarite = buffer.readUInt16LE(18);
      data.elSEtatBouton = (buffer.readUInt8(20) >> 0) & 1;
      data.elSPolariteProduction = (buffer.readUInt8(20) >> 1) & 3;
      data.elSCompteurBouton = buffer.readUInt32LE(21);
      data.elSCompteurResetUsine = buffer.readUInt32LE(25);
    } else if (action == P00039DataRxTxIndex.SALT_Parametrage1) {
      data.elPConsigneManuel = buffer.readUInt8(0);
      data.elPHysteresisRegulationRX = buffer.readUInt8(1);
      data.elPConsigneRX = buffer.readUInt16LE(2);
      data.elPTypeHorloge = (buffer.readUInt8(4) >> 0) & 1;
      data.elPActivationSecuriteDesinfection = (buffer.readUInt8(4) >> 1) & 1;
      data.elPActivationHivernage = (buffer.readUInt8(4) >> 2) & 1;
      data.elPTauxAbaissementVolet = buffer.readUInt8(5);
      data.elPTemperatureHivernage = buffer.readUInt8(6);
      data.elPDureeInversionPolarite = buffer.readUInt8(7);
    } else if (action == P00039DataRxTxIndex.SALT_Parametrage2) {
      data.elPHorlogeLundi = buffer.toString('hex', 0, 24);
      data.elPHorlogeMardi = buffer.toString('hex', 24, 48);
    } else if (action == P00039DataRxTxIndex.SALT_Parametrage3) {
      data.elPHorlogeMercredi = buffer.toString('hex', 0, 24);
      data.elPHorlogeJeudi = buffer.toString('hex', 24, 48);
    } else if (action == P00039DataRxTxIndex.SALT_Parametrage4) {
      data.elPHorlogeVendredi = buffer.toString('hex', 0, 24);
      data.elPHorlogeSamedi = buffer.toString('hex', 24, 48);
    } else if (action == P00039DataRxTxIndex.SALT_Parametrage5) {
      data.elPHorlogeDimanche = buffer.toString('hex', 0, 24);
      data.elPHorlogeSemaine = buffer.toString('hex', 24, 48);
    }

    return pool;
  }

  P00037Write(
    productClass: IProduct,
    pool: Pool,
    index: number,
  ): Buffer | null {
    const data = pool.deviceTable[productClass.dataIdentifier!]
      .data as P00037Data;

    if (index == P00039DataRxTxIndex.SALT_Controle) {
      const buffer = Buffer.allocUnsafe(2);
      buffer.writeUInt8(data.elCModeFonctionnement, 0);

      let o = 0x00;

      o = (o << 0) | data.elCResetProtectionPresenceGaz;
      o = (o << 1) | data.elConfirmationOTA;
      o = (o << 1) | data.elCResetNiveauSel;
      o = (o << 1) | data.elCResetUsine;

      buffer.writeUInt8(o, 1);

      return buffer;
    } else if (index == P00039DataRxTxIndex.SALT_Installation) {
      const buffer = Buffer.allocUnsafe(8);

      let o = 0x00;

      o = (o << 0) | data.elIActivationFonctionPrioriteBoost;
      o = (o << 1) | data.elIActivationFonctionPrioriteAutoMaintien;
      o = (o << 1) | data.elIActivationFonctionPrioriteElectrolyse;
      o = (o << 1) | data.elIConfigurationProduit;

      buffer.writeUInt8(o, 0);
      buffer.writeUInt8(data.elISondeReferenceRX, 1);
      buffer.writeUInt8(data.elISourceReferenceFonctionVolet, 2);
      buffer.writeUInt8(
        data.elICapteurTemperatureReferenceFonctionProtectionHivernage,
        3,
      );
      buffer.writeUInt8(data.elISourceReferenceDebitFonctionProtectionDebit, 4);

      buffer.writeUInt8(data.elICaracteristiqueCelluleQRImax, 5);
      buffer.writeUInt8(data.elICaracteristiqueCelluleQRUmax, 6);
      buffer.writeUInt8(data.elICaracteristiqueCelluleQRVt, 7);

      return buffer;
    } else if (index == P00039DataRxTxIndex.SALT_Parametrage1) {
      const buffer = Buffer.allocUnsafe(14);

      buffer.writeUInt8(data.elPConsigneManuel, 0);
      buffer.writeUInt8(data.elPHysteresisRegulationRX, 1);
      buffer.writeUInt16LE(data.elPConsigneRX, 2);

      let o = 0x00;

      o = (o << 0) | data.elPActivationHivernage;
      o = (o << 1) | data.elPActivationSecuriteDesinfection;
      o = (o << 1) | data.elPTypeHorloge;

      buffer.writeUInt8(o, 4);
      buffer.writeUInt8(data.elPTauxAbaissementVolet, 5);
      buffer.writeUInt8(data.elPTemperatureHivernage, 6);
      buffer.writeUInt8(data.elPDureeInversionPolarite, 7);

      return buffer;
    } else if (index == P00039DataRxTxIndex.SALT_Parametrage2) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.elPHorlogeLundi, 0, 24, 'hex');
      buffer.write(data.elPHorlogeMardi, 24, 24, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.SALT_Parametrage3) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.elPHorlogeMercredi, 0, 24, 'hex');
      buffer.write(data.elPHorlogeJeudi, 24, 24, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.SALT_Parametrage4) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.elPHorlogeVendredi, 0, 24, 'hex');
      buffer.write(data.elPHorlogeSamedi, 24, 24, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.SALT_Parametrage5) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.elPHorlogeDimanche, 0, 24, 'hex');
      buffer.write(data.elPHorlogeSemaine, 24, 24, 'hex');

      return buffer;
    }

    return null;
  }

  P00062Read(pool: Pool, action: number, buffer: Buffer): Pool {
    if (!pool?.deviceTable?.P00062?.data) {
      return pool;
    }

    const data = pool.deviceTable.P00062.data as P00062Data;

    if (action == P00039DataRxTxIndex.PACPOLY_Controle) {
      data.ppCModeFonctionnement = buffer.readUInt8(0);
      data.ppCResetUsine = buffer.readUInt8(1) & 1;
      data.ppCConfirmationOTA = (buffer.readUInt8(1) >> 1) & 1;
    } else if (action == P00039DataRxTxIndex.PACPOLY_Installation) {
      data.ppIActivationFonctionPriorite = buffer.readUInt8(0) & 1;
      data.ppIActivationFonctionAutoMaintien = (buffer.readUInt8(0) >> 1) & 1;
      data.ppIConfigurationProduit = (buffer.readUInt8(0) >> 2) & 1;
      data.ppISourceVolet = buffer.readUInt8(1);
      data.ppISourceTemperature = buffer.readUInt8(2);
    } else if (action == P00039DataRxTxIndex.PACPOLY_Status1) {
      data.ppSEtatFonctionnementPAC = buffer.readUInt16LE(0) & 1;
      data.ppSCommandeHorloge = (buffer.readUInt16LE(0) >> 1) & 1;
      data.ppSMiseRouteFiltrationPriorite = (buffer.readUInt16LE(0) >> 2) & 1;
      data.ppSMiseRouteFiltrationAutoMaintien =
        (buffer.readUInt16LE(0) >> 3) & 1;
      data.ppSEtatVolet = (buffer.readUInt16LE(0) >> 4) & 1;
      data.ppSDIsponibiliteEtatVolet = (buffer.readUInt16LE(0) >> 5) & 1;
      data.ppSRecommandationFermetture = (buffer.readUInt16LE(0) >> 6) & 1;
      data.ppSAlarme = (buffer.readUInt16LE(0) >> 7) & 1;
      data.ppSEtatSysteme = (buffer.readUInt16LE(0) >> 8) & 1;
      data.ppSEtatBouton = (buffer.readUInt16LE(0) >> 9) & 1;
      data.ppSDisponibiliteTemperatureEau = (buffer.readUInt16LE(0) >> 10) & 1;
      data.ppSModeRegistreCommande = buffer.readUInt8(2);
      data.ppSCompensationTemperature = buffer.readInt8(3);
      data.ppSTemperatureEauEntrante = buffer.readInt16LE(4);
      data.ppSTemperatureEauSortante = buffer.readInt16LE(6);
      data.ppSMesureTemperatureEau = buffer.readInt16LE(8);
      data.ppSTemperatureConsigneHorloge = buffer.readUInt16LE(10);
      data.ppSBypassPac = buffer.readUInt8(12);
      data.ppSCompteurResetUsine = buffer.readUInt16LE(13);
      data.ppSTempsSousTension = buffer.readUInt32LE(15);
      data.ppSTensionAlimentation = buffer.readUInt16LE(19);
      data.ppSCourantConsomme = buffer.readUInt8(21);
      data.ppSPuissanceActive = buffer.readUInt16LE(22);
      data.ppSCompteurPuissanceActiveTotale = buffer.readUInt32LE(24);
      data.ppSDefaut1 = buffer.readUInt16LE(28);
      data.ppSDefaut2 = buffer.readUInt16LE(30);
      data.ppSDefaut3 = buffer.readUInt16LE(32);
      data.ppSDefaut4 = buffer.readUInt16LE(34);
      data.ppSTemperatureDecharge = buffer.readInt16LE(36);
      data.ppSTemperatureAspiration = buffer.readInt16LE(38);
      data.ppSTemperatureBobine = buffer.readInt16LE(40);
      data.ppSTemperatureAirAmbiant = buffer.readInt16LE(42);
      data.ppSTemperatureIPM = buffer.readInt16LE(44);
      data.ppSCompteurBouton = buffer.readUInt32LE(46);
    } else if (action == P00039DataRxTxIndex.PACPOLY_Parametrage1) {
      data.ppPModeFonctionnementTemperature = buffer.readUInt8(0);
      data.ppPModeFonctionnementRegulation = buffer.readUInt8(1);
      data.ppPTemperatureConsigne = buffer.readUInt16LE(2);
      data.ppPTypeHorloge = buffer.readUInt8(4) & 1;
    } else if (action == P00039DataRxTxIndex.PACPOLY_Parametrage2) {
      data.ppPHorlogeSemaine = buffer.toString('hex', 0, 48);
    } else if (action == P00039DataRxTxIndex.PACPOLY_Parametrage3) {
      data.ppPHorlogeJourLundi = buffer.toString('hex', 0, 48);
    } else if (action == P00039DataRxTxIndex.PACPOLY_Parametrage4) {
      data.ppPHorlogeJourMardi = buffer.toString('hex', 0, 48);
    } else if (action == P00039DataRxTxIndex.PACPOLY_Parametrage5) {
      data.ppPHorlogeJourMercredi = buffer.toString('hex', 0, 48);
    } else if (action == P00039DataRxTxIndex.PACPOLY_Parametrage6) {
      data.ppPHorlogeJourJeudi = buffer.toString('hex', 0, 48);
    } else if (action == P00039DataRxTxIndex.PACPOLY_Parametrage7) {
      data.ppPHorlogeJourVendredi = buffer.toString('hex', 0, 48);
    } else if (action == P00039DataRxTxIndex.PACPOLY_Parametrage8) {
      data.ppPHorlogeJourSamedi = buffer.toString('hex', 0, 48);
    } else if (action == P00039DataRxTxIndex.PACPOLY_Parametrage9) {
      data.ppPHorlogeJourDimanche = buffer.toString('hex', 0, 48);
    }

    return pool;
  }

  P00062Write(
    productClass: IProduct,
    pool: Pool,
    index: number,
  ): Buffer | null {
    const data = pool.deviceTable[productClass.dataIdentifier!]
      .data as P00062Data;

    if (index == P00039DataRxTxIndex.PACPOLY_Controle) {
      const buffer = Buffer.allocUnsafe(2);
      buffer.writeUInt8(data.ppCModeFonctionnement, 0);

      let o = 0x00;

      o = (o << 0) | data.ppCConfirmationOTA;
      o = (o << 1) | data.ppCResetUsine;

      buffer.writeUInt8(o, 1);

      return buffer;
    } else if (index == P00039DataRxTxIndex.PACPOLY_Installation) {
      const buffer = Buffer.allocUnsafe(3);

      let o = 0x00;

      o = (o << 0) | data.ppIConfigurationProduit;
      o = (o << 1) | data.ppIActivationFonctionAutoMaintien;
      o = (o << 1) | data.ppIActivationFonctionPriorite;

      buffer.writeUInt8(o, 0);

      buffer.writeUInt8(data.ppISourceVolet, 1);

      buffer.writeUInt8(data.ppISourceTemperature, 2);

      return buffer;
    } else if (index == P00039DataRxTxIndex.PACPOLY_Parametrage1) {
      const buffer = Buffer.allocUnsafe(5);

      buffer.writeUInt8(data.ppPModeFonctionnementTemperature, 0);
      buffer.writeUInt8(data.ppPModeFonctionnementRegulation, 1);
      buffer.writeUInt16LE(data.ppPTemperatureConsigne, 2);

      let o = 0x00;

      o = (o << 0) | data.ppPTypeHorloge;

      buffer.writeUInt8(o, 4);

      return buffer;
    } else if (index == P00039DataRxTxIndex.PACPOLY_Parametrage2) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.ppPHorlogeSemaine, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PACPOLY_Parametrage3) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.ppPHorlogeJourLundi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PACPOLY_Parametrage4) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.ppPHorlogeJourMardi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PACPOLY_Parametrage5) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.ppPHorlogeJourMercredi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PACPOLY_Parametrage6) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.ppPHorlogeJourJeudi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PACPOLY_Parametrage7) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.ppPHorlogeJourVendredi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PACPOLY_Parametrage8) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.ppPHorlogeJourSamedi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PACPOLY_Parametrage9) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.ppPHorlogeJourDimanche, 0, 48, 'hex');

      return buffer;
    }

    return null;
  }

  P00058Read(pool: Pool, action: number, buffer: Buffer): Pool {
    const P00058P0006600Read = (data: P00058Data): P00058Data => {
      if (action == P00039DataRxTxIndex.PompeVS_Controle) {
        data.pvCModeFonctionnement = buffer.readUInt8(0);
        data.pvCProgrammeManuel = buffer.readUInt8(1);
        data.pvCProgrammeAuto = buffer.readUInt8(2);
        data.pvCResetUsine = buffer.readUInt8(3) & 1;
        data.pvCConfirmationOTA = (buffer.readUInt8(3) >> 1) & 1;
      } else if (action == P00039DataRxTxIndex.PompeVS_Parametrage1) {
        data.pvPUniteConsignePompe = buffer.readUInt8(0) & 1;
        data.pvPTypeHorlogeEte = (buffer.readUInt8(0) >> 1) & 1;
        data.pvPTypeHorlogeHiver = (buffer.readUInt8(0) >> 2) & 1;
        data.pvPActivationFonction24 = (buffer.readUInt8(0) >> 3) & 1;
        data.pvPVitesseV1 = buffer.readUInt16LE(1);
        data.pvPVitesseV2 = buffer.readUInt16LE(3);
        data.pvPVitesseEcremage = buffer.readUInt16LE(5);
        data.pvPVitesseV3 = buffer.readUInt16LE(7);
        data.pvPDureeBaignade = buffer.readUInt8(9);
        data.pvPDureeEcremage = buffer.readUInt8(10);
        data.pvPSeuilTemperatureHorsGel = buffer.readInt8(11);
        data.pvPSeuilTemperature24 = buffer.readUInt8(12);
        data.pvPDureeAmorcage = buffer.readUInt8(13);
        data.pvPVitesseAmorcage = buffer.readUInt16LE(14);
      } else if (action == P00039DataRxTxIndex.PompeVS_Parametrage2) {
        data.pvPHorlogeSemaineEte = buffer.toString('hex', 0, 48);
      } else if (action == P00039DataRxTxIndex.PompeVS_Parametrage3) {
        data.pvPHorlogeJourEteLundi = buffer.toString('hex', 0, 48);
      } else if (action == P00039DataRxTxIndex.PompeVS_Parametrage4) {
        data.pvPHorlogeJourEteMardi = buffer.toString('hex', 0, 48);
      } else if (action == P00039DataRxTxIndex.PompeVS_Parametrage5) {
        data.pvPHorlogeJourEteMercredi = buffer.toString('hex', 0, 48);
      } else if (action == P00039DataRxTxIndex.PompeVS_Parametrage6) {
        data.pvPHorlogeJourEteJeudi = buffer.toString('hex', 0, 48);
      } else if (action == P00039DataRxTxIndex.PompeVS_Parametrage7) {
        data.pvPHorlogeJourEteVendredi = buffer.toString('hex', 0, 48);
      } else if (action == P00039DataRxTxIndex.PompeVS_Parametrage8) {
        data.pvPHorlogeJourEteSamedi = buffer.toString('hex', 0, 48);
      } else if (action == P00039DataRxTxIndex.PompeVS_Parametrage9) {
        data.pvPHorlogeJourEteDimanche = buffer.toString('hex', 0, 48);
      } else if (action == P00039DataRxTxIndex.PompeVS_Parametrage10) {
        data.pvPHorlogeSemaineHivers = buffer.toString('hex', 0, 48);
      } else if (action == P00039DataRxTxIndex.PompeVS_Parametrage11) {
        data.pvPHorlogeJourHiversLundi = buffer.toString('hex', 0, 48);
      } else if (action == P00039DataRxTxIndex.PompeVS_Parametrage12) {
        data.pvPHorlogeJourHiversMardi = buffer.toString('hex', 0, 48);
      } else if (action == P00039DataRxTxIndex.PompeVS_Parametrage13) {
        data.pvPHorlogeJourHiversMercredi = buffer.toString('hex', 0, 48);
      } else if (action == P00039DataRxTxIndex.PompeVS_Parametrage14) {
        data.pvPHorlogeJourHiversJeudi = buffer.toString('hex', 0, 48);
      } else if (action == P00039DataRxTxIndex.PompeVS_Parametrage15) {
        data.pvPHorlogeJourHiversVendredi = buffer.toString('hex', 0, 48);
      } else if (action == P00039DataRxTxIndex.PompeVS_Parametrage16) {
        data.pvPHorlogeJourHiversSamedi = buffer.toString('hex', 0, 48);
      } else if (action == P00039DataRxTxIndex.PompeVS_Parametrage17) {
        data.pvPHorlogeJourHiversDimanche = buffer.toString('hex', 0, 48);
      } else if (action == P00039DataRxTxIndex.PompeVS_Installation) {
        data.pvIActivationAmorcage = buffer.readUInt8(0) & 1;
        data.pvIConfigurationProduit = (buffer.readUInt8(0) >> 1) & 1;
        data.pvIConsignePompeDoconnexion = buffer.readUInt16LE(1);
        data.pvISourceVolet = buffer.readUInt8(3);
        data.pvISourceTemperature24 = buffer.readUInt8(4);
        data.pvISourceTemperatureHorsGel = buffer.readUInt8(5);
      } else if (action == P00039DataRxTxIndex.PompeVS_Status1) {
        data.pvSEtatBouton = buffer.readUInt8(0) & 1;
        data.pvSEtatVolet = (buffer.readUInt8(0) >> 1) & 1;
        data.pvSDisponibiliteVolet = (buffer.readUInt8(0) >> 2) & 1;
        data.pvSEtatFonctionHorsGel = (buffer.readUInt8(0) >> 3) & 1;
        data.pvSDisponibiliteTemperatureHorsGel =
          (buffer.readUInt8(0) >> 4) & 1;
        data.pvSDisponibiliteTemperature24 = (buffer.readUInt8(0) >> 5) & 1;
        data.pvSFonctionnementPompe = (buffer.readUInt8(0) >> 6) & 1;
        data.pvSSecuriteDeconnexionProduit = (buffer.readUInt8(0) >> 7) & 1;

        data.pvSEafPrioriteStandard = buffer.readUInt16LE(1) & 1;
        data.pvSEafAutoMaintienElectrolyseurStandard =
          (buffer.readUInt16LE(1) >> 1) & 1;
        data.pvSEafAutoMaintienInjectionCL = (buffer.readUInt16LE(1) >> 2) & 1;
        data.pvSEafPrioriteCellule = (buffer.readUInt16LE(1) >> 3) & 1;
        data.pvSEafPrioriteBoostCellule = (buffer.readUInt16LE(1) >> 4) & 1;
        data.pvSEafAutoMaintienElectrolyseurCellule =
          (buffer.readUInt16LE(1) >> 5) & 1;
        data.pvSEafAutoMaintienInjectionPh = (buffer.readUInt16LE(1) >> 6) & 1;
        data.pvSEafAutoMaintienPac = (buffer.readUInt16LE(1) >> 7) & 1;
        data.pvSEafPrioritePac = (buffer.readUInt16LE(1) >> 8) & 1;
        data.pvSEafAutoMaintienPacWP = (buffer.readUInt16LE(1) >> 9) & 1;
        data.pvSEafPrioritePacWP = (buffer.readUInt16LE(1) >> 10) & 1;
        data.pvSEafAutoMaintienPacPoly = (buffer.readUInt16LE(1) >> 11) & 1;
        data.pvSEafPrioritePacPoly = (buffer.readUInt16LE(1) >> 12) & 1;
        data.pvSEafRedemEclairageStandard = (buffer.readUInt16LE(1) >> 13) & 1;
        data.pvSEafRedemEclairageTunalble = (buffer.readUInt16LE(1) >> 14) & 1;
        data.pvSEafPrioriteRobot = (buffer.readUInt16LE(1) >> 15) & 1;

        data.pvSEafAutoMaintientRobot = buffer.readUInt8(3) & 1;
        data.pvSEaaFiltrationVolet24 = (buffer.readUInt8(3) >> 1) & 1;
        data.pvSEaaFiltrationVolet230 = (buffer.readUInt8(3) >> 2) & 1;
        data.pvSAvertissement = (buffer.readUInt8(3) >> 3) & 1;
        data.pvSConsigneAvertissement = (buffer.readUInt8(3) >> 4) & 7;
        data.pvSAlarme = (buffer.readUInt8(3) >> 7) & 1;

        data.pvSVitesseCouranteRPM = buffer.readUInt16LE(4);
        data.pvSPuissanceDriver = buffer.readUInt16LE(6);
        data.pvSCodeErreur = buffer.readUInt8(8);
        data.pvSCourantConsomme = buffer.readUInt8(9);
        data.pvSCompteurPuissanceActive = buffer.readUInt32LE(10);
        data.pvSTempsSousTension = buffer.readUInt32LE(14);
        data.pvSCompteurAh = buffer.readUInt32LE(18);
        data.pvSCompteurBouton = buffer.readUInt32LE(22);
        data.pvSConsigneHorlogeEte = buffer.readUInt16LE(26);
        data.pvSConsigneHorlogeHivers = buffer.readUInt16LE(28);
        data.pvSCompteRebours72 = buffer.readUInt32LE(30);
        data.pvSCompteReboursBaignade = buffer.readUInt16LE(34);
        data.pvSCompteReboursEcremage = buffer.readUInt16LE(36);
        data.pvSConsigneHorsGel = buffer.readUInt16LE(38);
        data.pvSMesureTemperatureEauHorsGel = buffer.readInt16LE(40);
        data.pvSMesureTemperatureEau24 = buffer.readInt16LE(42);
        data.pvSConsigne24 = buffer.readUInt16LE(44);
        data.pvSCompteReboursAmorcage = buffer.readUInt16LE(46);
        data.pvSCompteurResetUsine = buffer.readUInt16LE(48);
      } else if (action == P00039DataRxTxIndex.PompeVS_Status2) {
        data.pvSVitesseMaxRpm = buffer.readUInt16LE(0);
        data.pvSAmorcageEnCours = buffer.readUInt8(2) & 1;
        data.pvSVitesseMinRpm = buffer.readUInt16LE(3);
      }

      return data;
    };

    //On va vérifier ici la présence de P0003607 ou P0004900
    if (pool?.deviceTable?.P00058?.data) {
      pool!.deviceTable!.P00058!.data = P00058P0006600Read(
        pool!.deviceTable!.P00058!.data,
      );
    }

    if (pool?.deviceTable?.P0006600?.data) {
      pool!.deviceTable!.P0006600!.data = P00058P0006600Read(
        pool!.deviceTable!.P0006600!.data,
      );
    }

    return pool;
  }

  P00058Write(
    productClass: IProduct,
    pool: Pool,
    index: number,
  ): Buffer | null {
    const data = pool.deviceTable[productClass.dataIdentifier!]
      .data as P00058Data;

    if (index == P00039DataRxTxIndex.PompeVS_Controle) {
      const buffer = Buffer.allocUnsafe(4);

      buffer.writeUInt8(data.pvCModeFonctionnement, 0);
      buffer.writeUInt8(data.pvCProgrammeManuel, 1);
      buffer.writeUInt8(data.pvCProgrammeAuto, 2);

      let o = 0x00;

      o = (o << 0) | data.pvCConfirmationOTA;
      o = (o << 1) | data.pvCResetUsine;

      buffer.writeUInt8(o, 3);
      return buffer;
    } else if (index == P00039DataRxTxIndex.PompeVS_Parametrage1) {
      const buffer = Buffer.allocUnsafe(16);

      let o = 0x00;

      o = (o << 0) | data.pvPActivationFonction24;
      o = (o << 1) | data.pvPTypeHorlogeHiver;
      o = (o << 1) | data.pvPTypeHorlogeEte;
      o = (o << 1) | data.pvPUniteConsignePompe;

      buffer.writeUInt8(o, 0);
      buffer.writeUInt16LE(data.pvPVitesseV1, 1);
      buffer.writeUInt16LE(data.pvPVitesseV2, 3);
      buffer.writeUInt16LE(data.pvPVitesseEcremage, 5);
      buffer.writeUInt16LE(data.pvPVitesseV3, 7);
      buffer.writeUInt8(data.pvPDureeBaignade, 9);
      buffer.writeUInt8(data.pvPDureeEcremage, 10);
      buffer.writeInt8(data.pvPSeuilTemperatureHorsGel, 11);
      buffer.writeUInt8(data.pvPSeuilTemperature24, 12);
      buffer.writeUInt8(data.pvPDureeAmorcage, 13);
      buffer.writeUInt16LE(data.pvPVitesseAmorcage, 14);

      return buffer;
    } else if (index == P00039DataRxTxIndex.PompeVS_Parametrage2) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.pvPHorlogeSemaineEte, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PompeVS_Parametrage3) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.pvPHorlogeJourEteLundi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PompeVS_Parametrage4) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.pvPHorlogeJourEteMardi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PompeVS_Parametrage5) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.pvPHorlogeJourEteMercredi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PompeVS_Parametrage6) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.pvPHorlogeJourEteJeudi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PompeVS_Parametrage7) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.pvPHorlogeJourEteVendredi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PompeVS_Parametrage8) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.pvPHorlogeJourEteSamedi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PompeVS_Parametrage9) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.pvPHorlogeJourEteDimanche, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PompeVS_Parametrage10) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.pvPHorlogeSemaineHivers, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PompeVS_Parametrage11) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.pvPHorlogeJourHiversLundi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PompeVS_Parametrage12) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.pvPHorlogeJourHiversMardi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PompeVS_Parametrage13) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.pvPHorlogeJourHiversMercredi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PompeVS_Parametrage14) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.pvPHorlogeJourHiversJeudi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PompeVS_Parametrage15) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.pvPHorlogeJourHiversVendredi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PompeVS_Parametrage16) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.pvPHorlogeJourHiversSamedi, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PompeVS_Parametrage17) {
      const buffer = Buffer.allocUnsafe(48);

      buffer.write(data.pvPHorlogeJourHiversDimanche, 0, 48, 'hex');

      return buffer;
    } else if (index == P00039DataRxTxIndex.PompeVS_Installation) {
      const buffer = Buffer.allocUnsafe(6);

      let o = 0x00;

      o = (o << 0) | data.pvIConfigurationProduit;
      o = (o << 1) | data.pvIActivationAmorcage;

      buffer.writeUInt8(o, 0);

      buffer.writeUInt16LE(data.pvIConsignePompeDoconnexion, 1);
      buffer.writeUInt8(data.pvISourceVolet, 3);
      buffer.writeUInt8(data.pvISourceTemperature24, 4);
      buffer.writeUInt8(data.pvISourceTemperatureHorsGel, 5);
      return buffer;
    }

    return null;
  }
}
